import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Injectable,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { CommonService } from '../../../commons/services/common.service';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import {
  I18n, CustomDatepickerI18n, NgbDateCustomParserFormatter,
  NgbDateNativeAdapter
} from '../../../commons/input-date/injection-datepicker';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription, iif } from 'rxjs';
import * as moment from 'moment';
// import * as $$ from 'jquery';
import { ConstanteEcorec } from '../../../recylog/application/constante.ecorec';
import { GestionSite } from '../../../recylog/application/gestion.site';
import { GestionBon } from '../../../recylog/application/gestion.bon';
import { GestionFormat } from '../../../recylog/application/gestion.format';
import { GestionBsdd } from '../../../recylog/application/gestion.bsdd';
import { AlertService } from '../../../commons/services/alert.service';
import { DragulaService } from 'ng2-dragula';
import { addDateToExcludeWeekendsOrHoliday } from "../../../commons/utils/DateUtils";
import { GestionAdr } from "../../../recylog/application/gestion.adr";
import { element } from 'protractor';
import { timeStamp } from 'console';
import { GestionSygetrack } from '../../../recylog/application/gestion.sygetrack';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { GestionDAC } from '../../../../app/recylog/application/gestion.dac';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-create-mvt',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './create-mvt.component.html',
  styleUrls: ['./create-mvt.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }]
})
export class CreateMvtComponent implements OnInit, OnDestroy {
  showFicheclt: Boolean = false;
  showLeft: Boolean = false;
  showFichechantier: any = false;
  showSpinner: any = false;
  dataClient = [];
  listChantier = [];
  selectedEvent: any = {};
  eventSelected: any = {};
  selectedChantier: any = {};
  newprest: any = {};
  step = 1;
  date = new Date();
  addClient: Boolean = false;
  addChantier: Boolean = false;
  isEditChantier: Boolean = false;
  isEditContenant: Boolean = false;
  isModifier: Boolean = false;
  disableModif: Boolean = false;
  isModifDateVidage: Boolean = false;
  isAddcontenant: Boolean = false;
  encoursDechargement: Boolean = false;
  listcontenant = [];
  listExutoireLimiteArticle = [];
  listExutoire = [];
  listChantierBenne = [];
  typeContenant = [];
  listArticle = [];
  newBenne = {};
  groupId = [];
  defaultExutoir: any = false;
  selectContenant = {};
  benneChantier = {};
  typeOperation = [];
  formatPerso = [];
  listFormatEtiquetteADR = [];
  templistJourFerie = [];
  listJourFerie = [];
  listeChoixDmdFaitPar = [
    { id: 1, libelle: 'Tél', libelleObjetEntite: 'Tél' },
    { id: 2, libelle: 'Fax', libelleObjetEntite: 'Fax' },
    { id: 3, libelle: 'Mail', libelleObjetEntite: 'mail' },
  ];
  defaultChoixDmdFaitPar: any = this.listeChoixDmdFaitPar[0];
  immatriculationCamionSsChauffeur = '';
  listeContent

  listOperationNew = [
    { id: 0, libelleObjetEntite: 'Depot' },
  ];
  listOperationBenne = [
    { id: 2, libelleObjetEntite: 'Rotation' },
    { id: 1, libelleObjetEntite: 'Retrait' },
  ];
  defaultSelected;
  numBonManuelObligatoire: Boolean = false;
  // clientSelected_numBonManuelObligatoire: Boolean = false;
  isVidage: Boolean = false;
  showDate: Boolean = false;
  nbdigit = 0;
  default = 0;
  mouvement: any = {};
  raisonReport = '';
  isReport: Boolean = false;
  formatprs: String = '';
  formatADRSelected: any = {};
  raisonSuppression: String = '';
  error = '';
  listeMouvSupp = [];
  showContrat: Boolean = false;
  isChoixCamionCreationMouv: Boolean = false;
  isPricipal: Boolean = false;
  hasRetrait: Boolean = false;
  isMvtRetrait: Boolean = false;
  isCreateWithBtn: Boolean = false;
  isRetrait: Boolean = false;
  isShowSite: Boolean = false;
  isClicked: Boolean = false;
  updateAll: Boolean = false;
  isJourFerie: Boolean = false;
  isSuspension: Boolean = false;
  isAddContTournee: Boolean = false;
  deposerContenant: Boolean = false;
  showEditBtn: Boolean = false;
  showDeleteGroupBtn: Boolean = true;
  isModifierLeContenant: Boolean = false;
  afficherAutreStep: Boolean = false;
  IsAjoutCont: Boolean = false;
  detailBon: any = {};
  listPeriode: any = [];
  listeSite = [];
  listCamion = [];
  listeSiteCA = [];
  defaultSite: any = {};
  defaultSiteCA: any = {};
  defaultPeriode: any = {};
  defaultCamion: any = { id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' };
  defaultLieu: any = { id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun' };
  detailTournee;
  client: any = {};
  isProgrammation: Boolean = false;
  isModeEquipe: Boolean = false;
  numBon: any = 0;
  isMouvPraxy: Boolean = false;
  listIndispoChauff = [];

  modifContenantGrp: Boolean = false;
  selectedContenantGrp: any = {};

  listProgram = [
    { id: 1, libelleObjetEntite: 'Jour du mois' },
    { id: 0, libelleObjetEntite: 'Jour de la semaine' },
    { id: 2, libelleObjetEntite: 'Jour et semaine du mois' },
    { id: 3, libelleObjetEntite: 'Dernière semaine du mois' },
  ];

  listSemaine = [
    { id: 2, libelleObjetEntite: 'LUN' },
    { id: 3, libelleObjetEntite: 'MAR' },
    { id: 4, libelleObjetEntite: 'MER' },
    { id: 5, libelleObjetEntite: 'JEU' },
    { id: 6, libelleObjetEntite: 'VEN' },
    { id: 7, libelleObjetEntite: 'SAM' },
    { id: 1, libelleObjetEntite: 'DIM' },
  ];

  listJour = [];
  nbSemainesProgram = '1';
  mouvBenneProgramme: any = {};
  tempMvtProgramme: any = {};
  listBenneSelected = [];
  listcontenantGroupe = [];
  contenantGoupe: any = { isGroupeBenne: true };
  societe: any = {};

  subs = new Subscription();
  BAG = 'DRAGULA_EVENTS';
  isDD: Boolean = false;

  contenantDepot: any = {};
  listContDepot: any = [];
  addDepotCont: Boolean = false;
  listOperationDepot: any = [];
  listTypeContDepot: any = [];
  dataArticleDepot: any = [];
  contenantFact: any = {};

  addArticle: Boolean = false;
  selactedArticle: any = {};
  delay;

  dataDepot = [];
  dataRetrait = [];
  dataRotation = [];
  dataAutre = [];
  dataOppSupp = [];
  dataOppSuppBennePlace = [];
  defaultSelectedOPeration = {};

  // Pour l'envoi par mail
  datamail: any = {};
  siteUtilisateur = {};
  user;
  envoiemail_mail = '';
  envoiemail_adrEmailFact = '';
  envoiemail_f;
  envoiemail_adrDestClient = '';
  envoiemail_format = '';
  envoiemail_signatureTexte = '';
  envoiemail_signatureImageTemp = '';
  envoiemail_signatureImage = '';
  envoiemail_formatImpressionParEmail;
  envoiemail_finalSignatureImage = '';
  envoiemail_strSignatureTexte = '';
  envoiemail_expMail = '';
  envoiemail_copieMail = '';
  envoiemail_titreMail = '';
  envoiemail_corpsMail = '';
  envoiemail_destMail = '';
  SUJET_MAIL_BON_CHANTIER_ECOBENNES = '@nomSociete Bon(s) du @dateBonChantierEcobennes';
  CONTENU_MAIL_BON_CHANTIER_ECOBENNES = '\nBonjour,\n\nVeuillez '
    + 'trouver ci-joint le(s) bon(s)  du @dateBonChantierEcobennes:\n'
    + '@numBon'
    + '\n\nCordialement,\n@nomSociete.\n\n'
    + '@signatureTexteEcobennes \n\n';
  envoiemail_strDevis;
  envoiemail_strType;
  envoiemail_strNumBon;
  envoiemail_strNomSociete;
  envoimail_siteEntrepriseAdresseExpBon;
  envoimail_siteEntrepriseAdresseCopieBon;
  envoimail_siteEntrepriseTitreMailBon;
  envoimail_siteEntrepriseCorpsMailBon;
  isEnvoiParEmail = false;
  aUnSignature = false;
  mouvementRiche;
  objectFocus = {};
  objectoldFocus = {};
  isDroitImpBSD = false;
  isDroitModifLocation = false;
  isDroitImpBon = false;
  isDroitSuppMouv = false;
  qteSelected: any = {};
  listQte = [];
  operationBenneEnPlaceFalse = false;
  modifierGroupe = false;
  objEquipe = {};

  defaultSelectedOPerationDefauf: any = {};
  defaultSelectedDefaut: any = {};
  dataisOpSurBenneEnPlace = [];
  isEcoDDS = false;

  isExisteMouvSupp = false;
  disableModifGroupe = false;

  //sygetrack
  msgSygetrack = '';
  arg1FuncAfterSygetrack; // idChantier
  arg2FuncAfterSygetrack; // event
  callSygetrack = '';
  resourceSygetrack;
  nomInformatiqueImbrique = 'Sygetrack'; // Par défaut
  @ViewChild('loadingSygetrack') loadingSygetrack;

  @Input() info;
  @Input() addContenant;
  @Input() editContenant;
  @Input() edit;
  @Input() isPlanningLocked;
  @Input() isHisto;
  @Input() isGroupe;
  @Input() isNotMvt;
  @Input() notEditable;
  @Input() isDmdEcoGED;
  @Input() isHistoMvt;
  @Input() benneId;

  @Output() close = new EventEmitter<any>();
  @Output() showalert = new EventEmitter<any>();
  @Output() updateDate = new EventEmitter<any>();

  @ViewChild('mail') mail;
  @ViewChild('loading') loading;
  @ViewChild('changedate') changedate;
  @ViewChild('changedateBon') changedateBon;
  @ViewChild('confirmeImpBonSansChauffeur') confirmeImpBonSansChauffeur;
  @ViewChild('format') format;
  @ViewChild('formatBonParMail') formatBonParMail;
  @ViewChild('formatEtiquetteADR') formatEtiquetteADR;
  @ViewChild('dialogueSuppression') dialogueSuppression;
  @ViewChild('dialogueConfirmSuppresionGroupe') dialogueConfirmSuppresionGroupe;
  @ViewChild('programConfirme') programConfirme;
  @ViewChild('msg') msg;
  @ViewChild('msgFormat') msgFormat;
  @ViewChild('confirmaFIPDND') confirmaFIPDND;
  @ViewChild('confirmaFIPDD') confirmaFIPDD;
  @ViewChild('formatPesroFIP') formatPesroFIP;
  @ViewChild('dialogueQteADR') dialogueQteADR;
  @ViewChild('msgFormatTrackdechets') msgFormatTrackdechets;

  listBonImp = [];

  isClickFacturation: boolean;
  isADR: Boolean = false;
  clientBloquer: Boolean = false;

  LISTE_CONTRAT = [];
  listPrestation = [];
  listContrat = [];
  resultZone = [];
  contenantVert: Boolean = false;
  isAmiante: Boolean = false;
  emptyInfoMouvement: Boolean = false;

  constructor(public common: CommonService, private modalService: BsModalService,
    protected alert: AlertService, private dragulaService: DragulaService) {
    this.subs.add(dragulaService.drop(this.BAG)
      .subscribe(({ el }) => {
        // this.addClass(el, 'ex-moved');
        const id = $(el).attr('id');
      })
    );
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
    this.common.isRedirectOpenDocImp = false;
    console.log('rdestroy', this.common.isRedirectOpenDocImp);
  }

  ngOnInit() {
    this.showDeleteGroupBtn = this.isGroupe && this.isNotMvt;
    this.user = this.common.local.getObject('userDetail') || {};
    this.isDroitImpBSD = ((this.user.clefDroit & 0x00000040) !== 0) ? true : false;
    this.isDroitModifLocation = ((this.user.clefDroit & 0x00800000) !== 0) ? true : false;
    this.isDroitImpBon = ((this.user.clefDroit & 0x00000080) !== 0) ? true : false;
    this.isDroitSuppMouv = ((this.user.clefDroit & 0x00000010) !== 0) ? true : false;
    this.siteUtilisateur = this.common.getType('siteUtilisateur');
    console.log('infos', this.info)
    console.log('isDmdEcoGED', this.isDmdEcoGED)
    const listeSite = this.common.getType('tousSite') || [];
    for (let i = 0; i < 31; i++) {
      this.listJour.push({ id: i + 1, libelleObjetEntite: i + 1 });
    }
    const listSupp = [{ id: -1, libelleObjetEntite: 1 },
    { id: -1, libelleObjetEntite: 2 },
    { id: -1, libelleObjetEntite: 3 },
    { id: -1, libelleObjetEntite: 4 }];
    this.listJour = [...this.listJour, ...listSupp];
    if (!listeSite.length) {
      this.getListeSite();
    } else {
      this.isShowSite = listeSite.length > 1 ? true : false;
      this.listeSite = listeSite;
      this.listeSite.forEach(elt => {
        if (elt.id === this.common.user[2]) {
          this.defaultSite = elt;
          this.defaultSiteCA = elt;
        }
      });
    }
    this.isModifierLeContenant = false;
    this.showEditBtn = false;

    this.societe = this.common.local.getObject('paramSociete') || {};
    // console.log('this.societe', this.societe.travailSamedi, this.societe.travailDimanche)
    const list = this.common.getType('listOperationSupp') || [];
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise || 0;
    this.showContrat = this.common.local.getObject('paramSociete').refContratBenne ? true : false;
    this.isChoixCamionCreationMouv = this.common.local.getObject('paramSociete').choixCamionCreationMouv ? true : false;
    const droitEquipe = this.societe['ecobennesEquipe'] || false;
    this.listPeriode = this.common.getType('listePeriodes') || [];
    if (this.isChoixCamionCreationMouv && this.listPeriode.length) {
      this.defaultPeriode = this.listPeriode[0];
    }

    // this.numBonManuelObligatoire = this.common.local.getObject('paramSociete').numBonManuelObligatoire ? true : false;
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];

    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    this.dataisOpSurBenneEnPlace = [...list2]
    if (this.societe['operationBenneSupp']) {
      this.listOperationNew.push(...list);
      this.listOperationBenne.push(...list2);
    } else {
      this.listOperationNew.push(...[{ id: 6, libelleObjetEntite: 'Autres' }]);
      // this.listOperationBenne.push(...[{ id: 6, libelleObjetEntite: 'Autres' }]);
    }
    if (this.info && (!this.info['mouvement'] || (Object.keys(this.info['mouvement']).length === 0))) {
      this.emptyInfoMouvement = true;
      console.log('Pas de mouvement en paramètre')
    }

    this.showLeft = true;
    this.defaultExutoir = false;
    this.isPricipal = true;
    this.newprest['isImportant'] = false;
    // this.newprest['dateStart'] = this.common.parseDate(moment().add( 1, 'days').format('DD/MM/YYYY'));
    // const dateStart = this.common.parseDate(moment().add(0, 'days').format('DD/MM/YYYY'));
    // const dayPlus = addDateToExcludeWeekendsOrHoliday(dateStart, this.societe.travailSamedi, this.societe.travailDimanche);
    // this.newprest['dateStart'] = this.common.parseDate(moment().add(dayPlus, 'days').format('DD/MM/YYYY'));

    // console.log("dayPlus : ", + dayPlus);
    // console.log("this.newprest['dateStart'] : " + this.newprest['dateStart']);
    this.searchTypecontenant();
    this.detectIfAdd();
    if (this.info['mouvCourant'] && this.info['mouvCourant'][3] && this.info['mouvCourant'][4]) {
      const mvt = this.info['mouvCourant'][3] || {};
      if (!this.hasRetrait) {
        this.hasRetrait = parseInt((mvt.operation || 0), 10) === 1 ? true : false;
      }
      const listMvtSupp = this.info['mouvCourant'][4];
      listMvtSupp.forEach(mvtPgm => {
        if (!this.hasRetrait) {
          this.hasRetrait = parseInt((mvtPgm.operation || 0), 10) === 1 ? true : false;
        }
      });
    }

    console.log('hasRetrait :' + this.hasRetrait, 'isRetrait :' + this.isMvtRetrait);

    // Filtre operation
    this.dataDepot = this.getListOperation(0);
    this.dataRetrait = this.getListOperation(1);
    this.dataRotation = this.getListOperation(2);
    this.dataAutre = this.getListOperation(6);
    this.dataOppSupp = this.getListOperation('listOperationSupp');
    this.dataOppSuppBennePlace = this.getListOperation('listOperationSuppBennePlace');

    if ((this.editContenant && this.info['isCreateMouvSupp']) || (this.isExisteMouvSupp)) {
      this.disableModifGroupe = this.isGroupe ? true : false;
      this.dataOppSupp = this.dataOppSupp.filter(op => op.id !== 0);
      this.dataDepot = this.dataDepot.filter(op => op.id === 0);
    }

    this.getNomInformatiqueEmbarque();
  }

  getNomInformatiqueEmbarque() {
    if (this.common.isSiteSygetrack()) {
      const ctrl = this;
      GestionSygetrack.getNomInformatiqueEmbarque(this.common).then(datas => {
        ctrl.nomInformatiqueImbrique = datas.data;
      });
    }
  }

  isInformatiqueEmbarqueSimplicity() {
    return this.nomInformatiqueImbrique == 'Simplicity';
  }

  getDetailArticle(id, notActualiseamiante?) {
    const clef = '' + id;
    const param = {
      'servlet': 'DBGetArticle',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetArticle', clef]
    };
    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data[0] && !notActualiseamiante) {
        this.isAmiante = datas.data[0].amiante || false;
      }
      return datas.data;
    });
  }

  DBCheckContrat() {
    // const clef = '' + id;
    const param = {
      'servlet': 'DBCheckContrat',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'NUM_CONTRAT': '' + (this.newprest.numContrat || ''),
      }
    };
    if (this.societe['verifNumContratEcobenne'] && this.newprest.numContrat) {
      return this.common.post('', { param: param }, true).then(datas => {
        const dt = datas.data || {};
        if (Object.keys(datas.data).length === 0) {
          this.error = 'Ce contrat n\'existe pas.';
          this.common.openModal(this.modalService, this.msgFormat);
          this.newprest.numContrat = '';
          return false;
        } else if (dt['SOLDE'] || (dt['DATE_FIN'] && moment(dt['DATE_FIN'], 'DD/MM/YYYY HH:mm:ss').isBefore(moment(this.newprest.dateStart)))) {
          this.error = 'Ce contrat n\'est plus actif.';
          this.common.openModal(this.modalService, this.msgFormat);
          this.newprest.numContrat = '';
          return false;
        } else {
          return true
        }
      });
    } else {
      return Promise.resolve(true);
    }
  }

  detectIfAdd() {
    this.listContDepot = [];
    this.showSpinner = false;
    this.isClicked = false;

    console.log("ff1", this.info);
    console.log("ff2", this.addContenant);
    console.log("ff3", this.editContenant);
    console.log("ff4", this.edit);

    if (!this.addContenant && (!this.editContenant || this.isDmdEcoGED) && !this.edit) {
      this.isCreateWithBtn = true;
      this.newprest['dateDemandeManuelModel'] = new Date();
      this.newprest['dateDemandeManuel'] = moment().format('DD/MM/YYYY');
      if (this.isDmdEcoGED) {
        this.newprest['client'] = this.info['client'];
        this.newprest['chantier'] = this.info['chantier'];
        this.selectedChantier = this.info['chantier'];
        this.newprest['adresse'] = 'test';
        this.newprest['infoNextMouv'] = this.info['infoNextMouv']
        this.getListContrat();

        if (this.info['contenant'].isGroupeBenne) {
          this.newprest['newContenant'] = true;

          // Quand on sélectionne plusieurs contenant à importer en mouvement, il devient un groupe, il faut que le benneChantiers père ait un "art et typeContenant" pour une conformité de données
          if (this.info['contenant'].listBennes && this.info['contenant'].listBennes.length) {
            const benneIndex0 = Object.assign({}, this.info['contenant'].listBennes[0]);
            this.info['contenant']['art'] = benneIndex0['art'];
            this.info['contenant']['typeContenant'] = benneIndex0['typeContenant'];
          }

          this.setValue(this.info['contenant'], 'newBenne');
          this.isGroupe = true;
          if (this.newprest['newBenne']) {
            this.newprest['newBenne'].listBennes.forEach(element => {
              element.isChecked = true;
              element.isContenantCheck = true;
              this.operationBenneGroupe(element);
            });
            this.newprest['newBenne'].listBennes = this.newprest['newBenne'].listBennes || [];
            this.listBenneSelected = this.newprest['newBenne'].listBennes || [];
          }
        } else {
          this.setValue(this.info['contenant'], 'contenant');
        }

        this.getDetailChantier((this.newprest['chantier'] ? (this.newprest['chantier'].id || 0) : 0), true).then(datas => {
          this.newprest['chantier'] = datas.data[0];
          if (this.newprest['contenant'] && !this.info['contenant'].isGroupeBenne) {
            let article = this.newprest['contenant'] && this.newprest['contenant']['art'] ? this.newprest['contenant']['art'] : { id: 0 }
            const libelleObjetEntite = article.libelleObjetEntite;
            if (article.id > 0) {
              this.getDetailArticle(article.id).then(data => {
                article = data[0] || article;
                if (!this.newprest['contenant']['isGroupeArticle']) {
                  this.newprest['contenant']['art'] = article;
                  this.newprest['contenant']['art'].libelleObjetEntite = `${this.newprest['contenant']['art'].code}/${this.newprest['contenant']['art'].libelle}`;
                }

                this.actualiseAxeAnaArticle(this.newprest['contenant'], article);
                this.actualiseCont(this.newprest['contenant']);
              })
            } else {
              if (this.newprest['contenant'].isGroupeArticle) {
                this.getListArticleGrp(this.newprest['contenant'].id).then(() => {
                  this.actualiseAxeAnaArticle(this.newprest['contenant']);
                  this.actualiseCont(this.newprest['contenant']);
                });
              }
            }
          }

        });
        this.newprest['exutoire'] = this.info['exutoire'] || {};
        this.newprest['exutoire'].libelleObjetEntite = this.newprest['exutoire'] ? (this.newprest['exutoire'].libelleObjetEntite ||
          this.newprest['exutoire'].nom) : '';
        this.defaultExutoir = this.newprest['exutoire'];
        this.newprest['dateStart'] = this.info['date'];


        this.typeOperation = [...this.listOperationNew, ...this.listOperationBenne];
        const operation = [];
        operation.push(...this.listOperationBenne, ...this.listOperationNew);
        operation.forEach(elt => {
          if (elt.id === parseInt(this.info['typeOperation'], 10)) {
            this.newprest['typeOperation'] = elt;
            this.defaultSelected = elt;
            this.defaultSelectedOPeration = Object.assign({}, elt);
          }
        });
        this.newprest['hour'] = ''; // '00'
        this.newprest['min'] = '00';
        this.newprest['hourDuree'] = '01';
        this.newprest['minDuree'] = '00';
        this.newprest['showdate'] = true;
        this.showDate = true;
        this.newprest['infoNextMouv'] = this.info['infoNextMouv'];
        if (this.newprest['infoNextMouv'] && this.newprest['infoNextMouv'] !== '') {
          this.newprest['showInfos'] = true;
        }
        if (this.info['contenant'] && this.info['contenant'].lieu) {
          this.newprest['lieu'] = this.info['contenant'].lieu;
          this.newprest['lieu'].libelleObjetEntite = this.newprest['lieu'].nom || '';
        }

        // this.step = 7;
        this.step = 4;
        this.isEditContenant = true;
      }
      if (this.isHistoMvt) {
        this.newprest['client'] = this.info['client'];
        this.newprest['chantier'] = this.info['chantier'];
        this.selectedChantier = this.info['chantier'];
        this.newprest['adresse'] = 'test';
        this.newprest['newContenant'] = true;
        this.newprest['IsAfficheNewContenant'] = true;
        this.newBenne = this.info['contenant'];
        this.newBenne['id'] = 0;
        if (this.newBenne['dateDebutLoc']) {
          this.newBenne['dateDebutLoc'] = this.common.parseDate(this.newBenne['dateDebutLoc']);
        }
        this.setValue(this.newBenne, 'newBenne');
        // this.setValue(this.info['contenant'], 'contenant');
        this.getDetailChantier((this.newprest['chantier'] ? (this.newprest['chantier'].id || 0) : 0), true).then(datas => {
          this.newprest['chantier'] = datas.data[0];
          let article = this.newBenne && this.newBenne['art'] ? this.newBenne['art'] : { id: 0 }
          const libelleObjetEntite = article.libelleObjetEntite;
          if (article.id > 0) {
            this.getDetailArticle(article.id).then(data => {
              article = data[0] || article;
              if (!this.newBenne['isGroupeArticle']) {
                this.newBenne['art'] = article;
                this.newBenne['art'].libelleObjetEntite = libelleObjetEntite;
                this.newBenne['art'].libelleObjetEntite = `${this.newBenne['art'].code}/${this.newBenne['art'].libelle}`;
              }

              this.actualiseAxeAnaArticle(this.newBenne, article);
              this.actualiseCont(this.newBenne);
            })
          } else {
            this.actualiseAxeAnaArticle(this.newBenne);
            this.actualiseCont(this.newBenne);
          }
        });

        // this.step = 8;
        this.getListContrat();
        this.isEditContenant = true;

        if (this.info['sitePrest']) {
          this.listeSite.forEach(elt => {
            if (elt.id === parseInt(this.info['sitePrest'], 10)) {
              this.newprest['sitePrest'] = elt;
              this.defaultSite = elt;
            }
          });
        }
        if (this.isChoixCamionCreationMouv) {
          if (this.info['periode']) {
            this.defaultPeriode = this.remplirDetailPeriode(parseInt(this.info['periode'], 10), this.info['periode']);
          }

          if (this.info['camion']) {
            this.defaultCamion = this.info['camion'];
          }
        }
        this.newprest['exutoire'] = this.info['exutoire'] || {};
        this.newprest['isImportant'] = this.info['important'] === '1' ? true : false;
        this.newprest['exutoire'].libelleObjetEntite = this.newprest['exutoire'] ? (this.newprest['exutoire'].libelleObjetEntite ||
          this.newprest['exutoire'].nom) : '';
        if (parseInt(this.info['typeOperation'], 10) !== 0) {
          this.typeOperation = this.listOperationBenne;
        } else {
          this.typeOperation = this.listOperationNew;
        }
        this.getOperationMvt();
        this.defaultExutoir = this.newprest['exutoire'];
        this.newprest['dateStart'] = this.info['date'];
        this.newprest['infoFact'] = this.info['infoFact'];
        this.newprest['infoNextMouv'] = this.info['infoNextMouv'];
        this.newprest['infos'] = this.info['infos'];
        // this.newprest['infosbenneChantiers'] = this.info['contenant'].infos || '';
        this.newprest['hour'] = this.info['heure'] || '';
        // const existe = this.info['heure'] ? this.info['heure'].search('h') : 1;


        this.newprest['hourDuree'] = Math.floor(parseFloat(this.info['duree'] || '0'));
        this.newprest['minDuree'] = Math.round((parseFloat(this.info['duree'] || '0') - parseInt(this.newprest['hourDuree'], 10)) * 60);

        this.newprest['listBon'] = this.info['listBon'] || [];
        this.date = this.newprest['dateStart'];
        this.step = 6;
        // this.showLeft = false;
        this.newprest['acompte'] = this.info['acompte'] || 0;
        this.newprest['numBonManuel'] = this.info['numBonManuel'];
        this.newprest['numBSDD'] = this.info['numBSDD'];
        this.newprest['numScelle'] = this.info['numScelle'];
        this.newprest['numContrat'] = this.info['numContrat'];
        this.isVidage = this.info['isVidage'];
        this.newprest['tournee'] = this.info['tournee'];
        if (this.info['tournee']) {
          this.getTournee(this.info['tournee'].id);
        }
        this.info['mouvement'] = this.info['mouvement'] || {};
        this.mouvement = this.info['mouvement'] || {};
        this.newprest['program'] = this.info['mouvBenneProgramme'] ? true : false;
        this.mouvBenneProgramme = this.info['mouvBenneProgramme'] ? this.info['mouvBenneProgramme'] : {};
        if (this.isGroupe && !this.info['tournee'] && !this.isEcoDDS) {
          this.getGroupeBenne(this.info['contenant'], true);
        }
        this.mvtProgramme();
      }

      if (!this.isDmdEcoGED && !this.isHistoMvt) {
        this.getValeurDatePrestation();
        this.newprest['hour'] = '';
        this.newprest['hourDuree'] = '01';
        this.newprest['minDuree'] = '00';
        if (this.newprest['client']) {
          this.getValeurDateMax();
        }
      }
    }

    if (this.addContenant) {
      this.getValeurDatePrestation();
      this.newprest['client'] = this.info['client'];
      this.getDetailClient(this.newprest['client'].id).then(() => {
        this.newBenne['isLocation'] = (this.societe['isLocation'] || this.client['isLoc']) ? true : false;
        this.newBenne['isLocJour'] = (this.client['isLocJournalier']) ? true : false;
      });
      this.newprest['chantier'] = this.info['chantier'];
      this.selectedChantier = this.info['chantier'];
      this.newprest['adresse'] = 'test';
      this.newprest['newContenant'] = true;
      this.newprest['IsAfficheNewContenant'] = true;
      this.newprest['hour'] = '';
      this.newprest['hourDuree'] = '01';
      this.newprest['minDuree'] = '00';
      this.newprest['dateDemandeManuelModel'] = new Date();
      this.newprest['dateDemandeManuel'] = moment().format('DD/MM/YYYY');
      this.step = 3;
      this.getListContrat();
      this.isPricipal = true;
      this.getListPoste();
      this.actualiseAxeAnaArticle(this.newBenne);
      this.actualiseAxeAnaContenant(this.newBenne);
      setTimeout(() => {
        if (!this.isGroupe) {
          $('#date1').focus();
        } else {
          $('#inputTypeHidden').focus();
        }
      }, 510);
      this.getValeurDateMax();
    }

    if (this.editContenant) {
      if (this.isDmdEcoGED) {
        if (!this.info['date']) {
          this.getValeurDatePrestation();
        }
      } else {
        this.getValeurDatePrestation();
      }
      this.newprest['client'] = this.info['client'];
      this.newprest['chantier'] = this.info['chantier'];
      this.selectedChantier = this.info['chantier'];
      this.newprest['adresse'] = 'test';
      this.getDetailClient(this.newprest['client'].id);
      this.actualiseAxeAnaContenant(this.info['contenant']);
      this.setValue(this.info['contenant'], 'contenant', true);
      const beneData = this.info['contenant'];
      if (this.newprest['contenant'].isGroupeArticle) {
        this.getListArticleGrp(this.newprest['contenant'].id);
      } else {
        this.newprest['contenant'].qte = this.newprest['contenant']['art'] && this.newprest['contenant']['art'].qtePrevisionnelle ?
          this.newprest['contenant']['art'].qtePrevisionnelle : 0;
        if (this.newprest['contenant']['art']) {
          this.newprest['contenant']['art'].libelleObjetEntite = `${this.newprest['contenant']['art'].code}/${this.newprest['contenant']['art'].libelle}`;
          const idArticle = this.newprest['contenant']['art'].id ? this.newprest['contenant']['art'].id || 0 : 0;
          console.log('idArticle', idArticle)
          if (idArticle > 0) {
            this.getDetailArticle(idArticle).then(data => {
              const article = data[0] || null;
              if (article !== null) {
                this.contenantVert = article.isDIS || false;
                console.log('contenantVert', this.contenantVert);
              }
            })
          }
        }

        this.actualiseAxeAnaArticle(this.newprest['contenant']);
      }

      if (this.info['contenant'] && this.info['contenant'].lieu) {
        this.newprest['lieu'] = this.info['contenant'].lieu;
        this.newprest['lieu'].libelleObjetEntite = this.newprest['lieu'].nom || '';
      }

      this.newprest['hour'] = '';
      this.newprest['hourDuree'] = '01';
      this.newprest['minDuree'] = '00';
      this.newprest['dateDemandeManuelModel'] = new Date();
      this.newprest['dateDemandeManuel'] = moment().format('DD/MM/YYYY');
      this.getListContrat();
      this.actualiseCont(this.newprest['contenant']);
      if (this.newprest['contenant'] && this.newprest['contenant'].clefOperationBenneParDefaut) {
        this.dataisOpSurBenneEnPlace.forEach(op => {
          if (op.id === this.newprest['contenant'].clefOperationBenneParDefaut) {
            this.defaultSelectedDefaut = op;
          }
        });
      }
      this.newprest['numContrat'] = this.info['numContrat'];
      if (!this.isDmdEcoGED) {
        this.newprest['infoNextMouv'] = beneData['infoNextMouv'] || '';
      }
      this.getDefaultExutoire(this.info['contenant']).then(data => {
        this.newprest['exutoire'] = this.defaultExutoir;
      });
      this.searchExutoireLimitArticle('', true)
      // if (!this.isGroupe) {
      this.step = 5;
      if (!this.isMouvPraxy) {
        setTimeout(function () {
          $('#date1').focus();
        }, 600);
      }

      this.showEditBtn = true;
      // } else {
      // this.step = 7;
      // this.step = 8;
      // this.getGroupeBenne(this.info['contenant']);
      // }

      this.isEditContenant = true;
      this.listQteCombo('contenant');
      this.qteSelected = {
        id: this.newprest['contenant'].qteContenant,
        libelleObjetEntite: this.newprest['contenant'].qteContenant
      };
      this.newprest['chauffeur'] = { id: 0 };
      this.newprest['listePersonnelParPoste'] = this.newprest['contenant'] && this.newprest['contenant'].id ?
        (this.newprest['contenant']['listePersonnelParPoste'] || []) : [];
      this.newprest['mouvement'] = { id: 0 };
      this.newprest['modeEquipe'] = this.newprest['contenant'].modeEquipe ? true : false;
      this.newprest['program'] = this.info['mouvBenneProgramme'] ? true : false;
      this.mouvBenneProgramme = this.info['mouvBenneProgramme'] ? this.info['mouvBenneProgramme'] : {};
      this.newprest['showdate'] = true;

      if (this.info['isCreateMouvSupp']) {
        if (this.newprest['program'] && parseInt(this.info['typeOperation'], 10) === 0) {

        } else {
          this.getOperationMvt();
        }

        if (this.defaultSelectedDefaut && this.defaultSelectedDefaut['id']) {
          this.newprest['champOperationDefaut'] = this.defaultSelectedDefaut;
        }

        // this.dataOppSupp = this.dataOppSupp.filter(op => op.id !== 0);
        this.newprest['typeOperation'] = this.defaultSelected;
      } else {
        if (!this.info['typeOperation']) {
          this.newprest['typeOperation'] = this.defaultSelected || { id: 2, libelleObjetEntite: 'Rotation' };
        } else {
          this.getOperationMvt();
          this.newprest['typeOperation'] = this.defaultSelected;
        }

      }
      this.mvtProgramme();
      if (this.info['mouvCourant']) {
        this.modifContentMvt();
        this.isPricipal = false;
      } else {
        this.isPricipal = true;
      }
      this.newprest['infos'] = this.info['contenant'].infos || '';
      this.getListPoste();

      setTimeout(function () {
        // $('.combo').click();
        $('#inputTypeHidden').focus();
      }, 550);
      this.getValeurDateMax();
    }

    if (this.edit) {
      this.showDate = true;
      console.log(this.info)
      this.newprest['client'] = this.info['client'];
      this.newprest['chantier'] = this.info['chantier'];
      // const isTourneeMultiClient = this.info['tournee'] && this.info['tournee'].multiClient ? true : false;
      this.getDetailClient(this.newprest['client'].id).then(() => {
        if (this.client['codeBlocage'] && (this.client['codeBlocage'] === 3 || this.client['codeBlocage'] === 4 ||
          this.client['codeBlocage'] === 5 || this.client['codeBlocage'] === 10)) {
          // this.error = `Client bloqu\u00e9.\nVeuillez consulter votre administrateur pour le d\u00e9bloquer.`;
          if (!this.info['tournee']) {
            this.error = `Ce client est bloqu\u00e9 vous ne pouvez pas modifier ses prestations.`;
            this.isRetrait = false;
            this.notEditable = true;
            this.clientBloquer = true;
            // this.closeFunction();
            this.common.openModal(this.modalService, this.msgFormat);
          }
        }
        this.getDetailChantier((this.newprest['chantier'] ? (this.newprest['chantier'].id || 0) : 0), true).then(datas => {
          this.newprest['chantier'] = datas.data[0];
        });
      });
      this.selectedChantier = this.info['chantier'];
      this.newprest['adresse'] = 'test';
      this.info['mouvement'] = this.info['mouvement'] || {};
      this.newprest['contenant'] = this.info['contenant'];

      this.actualiseCont(this.newprest['contenant'], true);
      if (this.newprest['contenant'].dateDebutLoc) {
        this.newprest['contenant'].dateDebutLoc = this.common.parseDate(this.newprest['contenant'].dateDebutLoc);
      }

      if (this.info['contenant'] && this.info['contenant'].lieu) {
        this.newprest['lieu'] = this.info['contenant'].lieu;
        this.newprest['lieu'].libelleObjetEntite = this.newprest['lieu'].nom || '';
      }

      const idArticle = this.newprest['contenant'] && this.newprest['contenant']['art'] && this.newprest['contenant']['art'].id ? this.newprest['contenant']['art'].id || 0 : 0;
      console.log('idArticle', idArticle)
      if (idArticle > 0) {
        this.getDetailArticle(idArticle).then(data => {
          const article = data[0] || null;
          if (article !== null) {
            this.contenantVert = article.isDIS || false;
            console.log('contenantVert', this.contenantVert);
          }
        })
      }

      this.newprest['modeEquipe'] = this.newprest['contenant'].modeEquipe ? true : false;


      this.isEditContenant = true;

      if (this.info['sitePrest']) {
        this.listeSite.forEach(elt => {
          if (elt.id === parseInt(this.info['sitePrest'], 10)) {
            this.newprest['sitePrest'] = elt;
            this.defaultSite = elt;
          }
        });
      }


      this.mouvement = this.info['mouvement'] || {};

      if (this.info && this.info['mouvPrincipal'] && this.info['mouvPrincipal'][26] && this.info['mouvPrincipal'][26] !== '0000-00-00') {
        this.newprest['dateDemandeManuelModel'] = this.common.parseDate(moment(this.info['mouvPrincipal'][26]).format('DD/MM/YYYY'));
        this.newprest['dateDemandeManuel'] = moment(this.info['mouvPrincipal'][26]).format('DD/MM/YYYY');
      }

      if (!this.mouvement['id']) {
        if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
          if (this.info['bonSelected']) {
            if ('' + this.info['bonSelected'].id === this.info['mouvPrincipal'][16]) {
              this.mouvement['id'] = this.info['mouvPrincipal'][0];
            } else {
              this.listeMouvSupp.forEach(elt => {
                if (elt[5] === '' + this.info['bonSelected'].id) {
                  this.mouvement['id'] = elt[4];
                }
              });
            }
          }
        }
      }

      if (this.newprest['contenant'] && this.newprest['contenant'].art && !this.newprest['contenant'].isGroupeArticle) {
        this.newprest['contenant']['art'].libelleObjetEntite = `${this.newprest['contenant']['art'].code}/${this.newprest['contenant']['art'].libelle}`;
        console.log(this.newprest['contenant']['art'].libelleObjetEntite)
      }

      if (this.newprest['contenant'].clefBenneChantiersD0 > 0) {
        this.isMouvPraxy = true;
        this.isGroupe = true;
        if (this.isMouvPraxy && this.mouvement['id']) {
          this.getDetailMouvEdit(this.mouvement['id']).then(data => {
            const mvtP = data[0] || { id: this.mouvement['id'] };
            this.mouvement = mvtP;
            this.newprest['contenant'] = this.mouvement['benne'] || this.newprest['contenant'];
            this.info['contenant'] = this.mouvement['benne'] || this.info['contenant'];

            const benne = Object.assign({}, this.newprest['contenant']);
            benne.isGroupeBenne = true;
            benne.isGroupeArticle = false;
            benne.listBennes = this.newprest['contenant'].listBennes && this.newprest['contenant'].listBennes ?
              this.newprest['contenant'].listBennes : [Object.assign({}, this.newprest['contenant'])];
            this.newprest['contenant'] = Object.assign({}, benne);
            this.info['contenant'] = Object.assign({}, benne);
            this.getBeneDataChantier();
          })
        }
      } else {
        const BenneData = this.newprest['contenant'];
        const isEcoDDS = (BenneData.benneRecylex && BenneData.isCurrent && this.societe['isECODDS']) ? true : false;
        if (isEcoDDS) {
          this.isEcoDDS = true;
          this.isGroupe = true;
          if (this.isEcoDDS && this.mouvement['id']) {
            this.getDetailMouvEdit(this.mouvement['id']).then(data => {
              const mvtP = data[0] || { id: this.mouvement['id'] };
              this.mouvement = mvtP;
              this.newprest['contenant'] = this.mouvement['benne'] || this.newprest['contenant'];
              this.info['contenant'] = this.mouvement['benne'] || this.info['contenant'];

              const benne = Object.assign({}, this.newprest['contenant']);
              benne.isGroupeBenne = true;
              benne.isGroupeArticle = false;
              benne.listBennes = this.newprest['contenant'].listBennes && this.newprest['contenant'].listBennes.length ?
                this.newprest['contenant'].listBennes : [Object.assign({}, this.newprest['contenant'])];

              console.log('benne', benne);
              this.listBenneSelected = benne.listBennes || [];
              this.newprest['contenant'] = Object.assign({}, benne);
              this.info['contenant'] = Object.assign({}, benne);
              this.getBeneDataChantier(true);
            })
          }
        } else {
          this.getListContrat();
          if (this.newprest['contenant'].isGroupeArticle) {
            this.getListArticleGrp(this.newprest['contenant'].id);
          }
        }
      }

      if (this.isChoixCamionCreationMouv && !this.info['tournee']) {
        if (this.info['periode']) {
          const p = this.remplirDetailPeriode(parseInt(this.info['periode'], 10), this.info['periode']);
          this.newprest['periode'] = p;
          this.defaultPeriode = p;
        }
        if (this.info['camion']) {
          this.newprest['camion'] = this.info['camion'];
          this.defaultCamion = this.info['camion'];
        }
      }

      this.newprest['exutoire'] = this.info['exutoire'] || {};
      this.newprest['isImportant'] = this.info['important'] === '1' ? true : false;
      this.newprest['exutoire'].libelleObjetEntite = this.newprest['exutoire'] ? (this.newprest['exutoire'].libelleObjetEntite ||
        this.newprest['exutoire'].nom) : '';
      if (parseInt(this.info['typeOperation'], 10) !== 0) {
        this.typeOperation = this.listOperationBenne;
      } else {
        this.typeOperation = this.listOperationNew;
      }

      if (this.newprest['contenant'] && this.newprest['contenant'].clefOperationBenneParDefaut) {
        this.dataisOpSurBenneEnPlace.forEach(op => {
          if (op.id === this.newprest['contenant'].clefOperationBenneParDefaut) {
            this.defaultSelectedDefaut = op;
          }
        });
      }


      this.isMvtRetrait = parseInt(this.info['typeOperation'], 10) === 1 ? true : false;
      this.listQteCombo('contenant');
      this.qteSelected = {
        id: this.newprest['contenant'].qteContenant,
        libelleObjetEntite: this.newprest['contenant'].qteContenant
      };

      this.getOperationMvt();

      console.log(this.defaultSelectedOPeration)
      this.defaultExutoir = this.newprest['exutoire'];
      this.newprest['dateStart'] = this.info['date'];
      this.newprest['infoFact'] = this.info['infoFact'];
      this.newprest['infoNextMouv'] = this.info['infoNextMouv'];
      this.newprest['infos'] = this.info['infos'];

      this.newprest['hour'] = this.info['heure'] || '';

      this.newprest['listBon'] = this.info['listBon'] || [];
      this.date = this.newprest['dateStart'];
      this.step = 1;
      this.showLeft = false;
      this.newprest['acompte'] = this.info['acompte'] || 0;
      this.newprest['numBonManuel'] = this.info['numBonManuel'];
      this.newprest['numBSDD'] = this.info['numBSDD'];
      this.newprest['numScelle'] = this.info['numScelle'];
      this.newprest['numContrat'] = this.info['numContrat'];
      this.isVidage = this.info['isVidage'];
      this.newprest['tournee'] = this.info['tournee'];
      if (this.info['tournee']) {
        this.getTournee(this.info['tournee'].id);
      } else {
        this.newprest['hourDuree'] = Math.floor(parseFloat(this.info['duree']));
        this.newprest['minDuree'] = Math.round((parseFloat(this.info['duree']) - parseInt(this.newprest['hourDuree'], 10)) * 60);
        this.newprest['hourDuree'] = this.newprest['hourDuree'] === 0 ? '00' : this.newprest['hourDuree'];
        this.newprest['minDuree'] = this.newprest['minDuree'] === 0 ? '00' : this.newprest['minDuree'];
      }

      this.newprest['program'] = this.info['mouvBenneProgramme'] ? true : false;
      this.mouvBenneProgramme = this.info['mouvBenneProgramme'] ? this.info['mouvBenneProgramme'] : {};
      if (this.isGroupe && !this.info['tournee'] && !this.isMouvPraxy && !this.isEcoDDS) {
        this.getGroupeBenne(this.info['contenant'], true);
      }
      this.mvtProgramme();


      console.log(this.mouvement['id'])

      if (this.isVidage) {
        const id = this.mouvement['parking'] ? this.mouvement['parking'].id : 0;
        this.newprest['parking'] = this.common.getItem(this.common.getType('listeParking'), id);
      }
      if (!this.isHisto) {
        this.modifContentMvt();
        if (this.info['bonSelected']) {
          if ('' + this.info['bonSelected'].id === this.info['mouvPrincipal'][16]) {
            this.isPricipal = true;
            this.info['siteCA'] = this.info['mouvPrincipal'][15]
            this.info['typeDemande'] = this.info['mouvPrincipal'][21];
            if (this.info['typeDemande']) {
              this.defaultChoixDmdFaitPar = this.listeChoixDmdFaitPar.find(elt => elt.id === parseInt(this.info['mouvPrincipal'][21], 10)) || {}
            }
            if (this.info['siteCA']) {
              this.listeSite.forEach(elt => {
                if (elt.id === parseInt(this.info['siteCA'], 10)) {
                  this.newprest['siteCA'] = elt;
                  this.defaultSiteCA = elt;
                }
              });
            }
          } else {
            this.listeMouvSupp.forEach(elt => {
              if (elt[5] === '' + this.info['bonSelected'].id) {
                this.isPricipal = false;
                this.info['siteCA'] = elt[16]
                this.info['typeDemande'] = elt[17];
                if (this.info['typeDemande']) {
                  this.defaultChoixDmdFaitPar = this.listeChoixDmdFaitPar.find(elt => elt.id === parseInt(elt[17], 10)) || {}
                }
                if (this.info['siteCA']) {
                  this.listeSite.forEach(site => {
                    if (site.id === parseInt(this.info['siteCA'], 10)) {
                      this.newprest['siteCA'] = site;
                      this.defaultSiteCA = site;
                    }
                  });
                }
              }
            });
          }
        }
        console.log('this.isPricipal = ' + this.isPricipal)
      }
      this.getlistIndispo().then(() => {
        this.getListPoste();
        if (this.newprest['contenant'] && !this.newprest['contenant'].isGroupeBenne && !this.newprest['contenant'].isGroupeArticle) {
          if (this.newprest['mouvement'] && this.newprest['mouvement'].articleMouv && this.newprest['mouvement'].articleMouv.id > 0) {
            this.newprest['contenant'].art = this.newprest['mouvement'].articleMouv;
            this.newprest['contenant']['art'].libelleObjetEntite = `${this.newprest['contenant']['art'].code}/${this.newprest['contenant']['art'].libelle}`;
          }
        }
      })



      console.log(this.listeMouvSupp);
    }

    if (this.isGroupe && !this.isMouvPraxy) {
      this.getListeContenant(this.newprest['client'].id, (this.newprest['chantier'].numChantier || ''));
    }



    console.log(this.newprest);
  }

  isChauffeurIndispoInfoBulle(chauffeur, format?) {
    let isIndispo = false;
    if (!this.listIndispoChauff || !chauffeur) {
      return false;
    }

    this.listIndispoChauff = this.listIndispoChauff || [];
    this.listIndispoChauff.forEach(c => {
      const aStart = this.common.parseDate(moment(c.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const aEnd = this.common.parseDate(moment(c.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      const bStart = this.common.parseDate(moment(this.newprest['dateStart']).format('DD/MM/YYYY'));
      const bEnd = this.common.parseDate(moment(this.newprest['dateStart']).format('DD/MM/YYYY'));
      const range1 = moment(bStart).isSameOrAfter(aStart) && moment(bStart).isSameOrBefore(aEnd);
      const range2 = moment(bEnd).isSameOrAfter(aStart) && moment(bEnd).isSameOrBefore(aEnd);
      if (c.ressource && c.ressource.id === chauffeur.id && (range2 || range1)) {
        isIndispo = true;
      }
    });

    return isIndispo;
  }


  remplirDetailPeriode(idObj, defaultRet) {
    let ret = defaultRet;
    this.listPeriode.forEach(p => {
      if (p.id === idObj) {
        ret = p;
      }
    });

    return ret;
  }

  getListPoste() {

    if (this.isPricipal) {
      this.info['mouvPrincipalObj'] = this.info['mouvPrincipalObj'] || {};
      this.newprest['chauffeur'] = this.info['mouvPrincipalObj'].chauffeur || {};
      this.newprest['dateMaxStart'] = this.common.parseDate(moment(this.info['mouvPrincipalObj'].dateMax,
        'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
      if (this.isChoixCamionCreationMouv && !this.info['tournee']) {
        this.newprest['periode'] = this.info['mouvPrincipalObj'].periode || {};
        this.newprest['camion'] = this.info['mouvPrincipalObj'].camion || {};
      }
      this.newprest['auPlusTard'] = this.info['mouvPrincipalObj'].auPlusTard || false;
      this.newprest['listePersonnelParPoste'] = this.info['mouvPrincipalObj'].listePersonnelParPoste || [];

      this.newprest['mouvement'] = this.info['mouvPrincipalObj'];
      if (this.emptyInfoMouvement) {
        this.info['mouvement'] = Object.assign({}, this.info['mouvPrincipalObj']);
        this.mouvement = this.info['mouvement'];
      }
      if (this.newprest['contenant']) {
        this.newprest['contenant']['axeAnalytiqueLigne'] = this.info['mouvPrincipalObj']['bon'] ?
          this.info['mouvPrincipalObj']['bon'].axeAnalytiqueLignePrestation : (this.newprest['contenant']['axeAnalytiqueLigne'] || '');
        if (!this.newprest['contenant'].isGroupeArticle) {
          this.newprest['contenant'].qte = this.info['mouvPrincipalObj'].qtePrevisionnelle;
          this.newprest['contenant']['axeAnalytiqueLigneArt'] = this.info['mouvPrincipalObj']['bon'] ?
            this.info['mouvPrincipalObj']['bon'].axeAnalytiqueLigneArticle : (this.newprest['contenant']['axeAnalytiqueLigneArt'] || '');
        }
      }

      this.parseMouvement();
    } else {

      if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
        this.info['mouvCourant'][4] = this.info['mouvCourant'][4] || [];
        this.info['mouvCourant'][4].forEach(mouv => {
          if (mouv.bon && this.info['bonSelected'] && mouv.bon.id === parseInt(this.info['bonSelected'].id, 10)) {
            console.log('mouv')
            this.newprest['chauffeur'] = Object.assign({}, mouv['chauffeur'] || {});
            this.newprest['auPlusTard'] = mouv.auPlusTard || false;
            this.newprest['listePersonnelParPoste'] = Object.assign([], mouv['listePersonnelParPoste'] || []);
            this.newprest['dateMaxStart'] = this.common.parseDate(moment(mouv.dateMax,
              'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
            this.newprest['mouvement'] = mouv;
            if (this.emptyInfoMouvement) {
              this.info['mouvement'] = Object.assign({}, mouv);
              this.mouvement = this.info['mouvement'];
            }
            console.log(mouv)
            if (this.newprest['contenant']) {
              this.newprest['contenant']['axeAnalytiqueLigne'] = mouv['bon'] ? mouv['bon'].axeAnalytiqueLignePrestation :
                (this.newprest['contenant']['axeAnalytiqueLigne'] || '');
              if (!this.newprest['contenant'].isGroupeArticle) {
                this.newprest['contenant'].qte = mouv.qtePrevisionnelle;
                this.newprest['contenant']['axeAnalytiqueLigneArt'] = mouv['bon'] ? mouv['bon'].axeAnalytiqueLigneArticle :
                  (this.newprest['contenant']['axeAnalytiqueLigneArt'] || '');
              }
            }

            if (!this.info['tournee']) {
              this.newprest['periode'] = mouv.periode;
              this.newprest['camion'] = mouv.camion;
            }
          }
        });
        this.parseMouvement();
      }
    }

    // const idArticle = this.info['contenant'] && this.info['contenant'] && this.info['contenant'].art
    //  && this.info['contenant'].art.id ? this.info['contenant'].art.id || 0 : 0;
    //  console.log('idArticle', idArticle)
    // if (idArticle > 0) {
    //   this.getDetailArticle(idArticle).then(data => {
    //     const article = data[0] || null;
    //     if (article !== null) {
    //       this.isADR = article.isImpEtiqADR || false;
    //     }
    //   })
    // }

    if (this.isChoixCamionCreationMouv && !this.info['tournee']) {
      if (this.newprest['periode'] && this.newprest['periode'].id) {
        this.newprest['periode'] = this.remplirDetailPeriode(this.newprest['periode'].id, this.newprest['periode']);
        this.info['periode'] = this.newprest['periode'];
        this.defaultPeriode = this.newprest['periode'];
      }

      if (this.newprest['camion'] && this.newprest['camion'].id) {
        this.info['camion'] = this.newprest['camion'];
        this.defaultCamion = this.newprest['camion'];
      }
    }
  }

  getOperationMvt() {
    const operation = [];
    const list = this.common.getType('listOperationSupp') || [];
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];
    let existe = false;
    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    operation.forEach(elt => {
      if (elt.id === parseInt(this.info['typeOperation'], 10)) {
        existe = true;
        this.newprest['typeOperation'] = elt;
        this.defaultSelected = elt;
        this.defaultSelectedOPeration = Object.assign({}, elt);
        if (!elt.operationSurBenneEnPlace && (elt.id !== 2 && elt.id !== 1)) {
          this.operationBenneEnPlaceFalse = true;
        } else {
          this.operationBenneEnPlaceFalse = false;
        }
      }
    });


    console.log('this.operationBenneEnPlaceFalse', this.operationBenneEnPlaceFalse)

    if ((this.defaultSelectedOPeration && !this.defaultSelectedOPeration['id']) || !existe) {
      const operationSupp = [...list, ...list2];
      operationSupp.forEach(elt => {
        if (elt.id === parseInt(this.info['typeOperation'], 10)) {
          existe = true;
          this.newprest['typeOperation'] = elt;
          this.defaultSelected = elt;
          this.defaultSelectedOPeration = Object.assign({}, elt);
        }
      });
    }
  }

  isBenneEnPlace(operaion) {
    const list = this.common.getType('listOperationSuppBennePlace') || [];
    const existe = list.filter(elt => operaion && elt.id === operaion.id);
    return existe && existe.length ? true : false;
  }

  isBenneNonEnPlace(operaion) {
    const list = this.common.getType('listOperationSupp') || [];
    const existe = list.filter(elt => operaion && elt.id === operaion.id);
    return existe && existe.length ? true : false;
  }

  getListOperation(type) {
    let value = [];
    const dataOperation = this.societe['operationBenneSupp'] ? [
      { id: 0, libelle: 'Dépot' },
      { id: 1, libelle: 'Retrait' },
      { id: 2, libelle: 'Rotation' }
    ] : [
      { id: 0, libelle: 'Dépot' },
      { id: 1, libelle: 'Retrait' },
      { id: 2, libelle: 'Rotation' },
      // { id: 6, libelle: 'Autres' }
    ];

    if (!this.societe['operationBenneSupp'] && (type === 0 || type === 6 || type === 'listOperationSupp')) {
      dataOperation.push({ id: 6, libelle: 'Autres' })
    }

    const listOperationSuppBennePlace = this.societe['operationBenneSupp'] ? this.common.getType('listOperationSuppBennePlace') : [];
    const listOperationSupp = this.societe['operationBenneSupp'] ? this.common.getType('listOperationSupp') : [];
    switch (type) {
      case 0:
        value = dataOperation.filter(elt => elt.id !== 1 && elt.id !== 2);
        value = [...value, ...this.societe['operationBenneSupp'] ? listOperationSupp : []];
        break;
      case 1:
        value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        if (this.societe['operationBenneSupp']) {
          value = [...value, ...listOperationSuppBennePlace];
        }
        break;
      case 2:
        value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        if (this.societe['operationBenneSupp']) {
          value = [...value, ...listOperationSuppBennePlace];
        }

        if (this.hasRetrait && !this.isMvtRetrait) {
          value = value.filter(elt => elt.id !== 1);
        }
        break;
      case 6:
        value = dataOperation.filter(elt => elt.id !== 2);
        if (this.societe['operationBenneSupp']) {
          value = [...value, ...listOperationSuppBennePlace];
        }
        if (this.hasRetrait && !this.isMvtRetrait) {
          value = value.filter(elt => elt.id !== 1);
        }
        break;
      case 'listOperationSupp':
        if (this.societe['operationBenneSupp']) {
          value = dataOperation.filter(elt => elt.id !== 1 && elt.id !== 2 && elt.id !== 6);
        } else {
          value = dataOperation.filter(elt => elt.id !== 1 && elt.id !== 2);
        }

        value = [...value, ...listOperationSupp];
        break;
      case 'listOperationSuppBennePlace':
        if (this.societe['operationBenneSupp']) {
          value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        } else {
          value = dataOperation.filter(elt => elt.id !== 0 && elt.id !== 6);
        }
        value = [...value, ...listOperationSuppBennePlace];
        if (this.hasRetrait && !this.isMvtRetrait) {
          value = value.filter(elt => elt.id !== 1);
        }
        break;
    }

    value.forEach(elt => elt.libelleObjetEntite = elt.libelle || '');
    return value;
  }


  getListArticleGrp(id, isNotArtCont?) {
    const param = {
      'servlet': 'DBGetGroupeArticle',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeArticle', '' + id, '1']
    };


    return this.common.post('', { param: param }, true).then(datas => {
      if (datas.data) {
        if (!isNotArtCont) {
          this.newprest['contenant'].listArticles = datas.data || [];
          this.newprest['contenant'].listArticle = [];
          this.newprest['contenant'].listArticles = this.newprest['contenant'].listArticles || [];
          this.newprest['contenant'].listArticles.forEach(elt => {
            const art = {};
            art['art'] = Object.assign({}, elt);
            art['exutoire'] = Object.assign({}, elt.exu);
            art['qte'] = (elt.qtePrevisionnelle || 0);
            art['axeAnalytiqueLigneArt'] = elt.axeAnalytiqueLigneArticle || '';
            this.newprest['contenant'].listArticle.push(art);
          });

          console.log(this.newprest['contenant'].listArticle)
        } else {
          return datas.data;
        }
      }
    });

  }

  mvtProgramme() {
    if (this.mouvBenneProgramme['id']) {
      if (this.mouvBenneProgramme['typeOperation']) {
        this.listProgram.forEach(elt => {
          if (elt.id === this.mouvBenneProgramme['typeOperation']) {
            this.mouvBenneProgramme['typeProgram'] = elt;
          }
        });
      } else {
        this.mouvBenneProgramme['typeProgram'] = this.listProgram[1];
      }
      if (this.mouvBenneProgramme['dateFin']) {
        this.mouvBenneProgramme['editDate'] = true;
        if (this.mouvBenneProgramme['dateFin'] !== '01/01/1970 00:00:00') {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate(moment((this.mouvBenneProgramme['dateFin']),
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        } else {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate('31/12/9999');
        }

      }
      this.mouvBenneProgramme['nbSemainesProgram'] = '' + (this.mouvBenneProgramme['nbSemainesProgram'] || 1);
      this.mouvBenneProgramme['frequence'] = this.mouvBenneProgramme['frequence'] || 0;
      this.mouvBenneProgramme['listTtSemaine'] = [];
      this.mouvBenneProgramme['listSemainePaire'] = [];
      this.mouvBenneProgramme['listSemaineImpaire'] = [];
      this.mouvBenneProgramme['listJoursMois'] = [];
      this.mouvBenneProgramme['listJoursMois1'] = [];
      this.mouvBenneProgramme['listJoursMois2'] = [];
      this.mouvBenneProgramme['listJoursMois3'] = [];
      this.mouvBenneProgramme['listJoursMois4'] = [];
      this.mouvBenneProgramme['listJoursMois5'] = [];
      this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
      this.mouvBenneProgramme['listePeriodesPause'] = this.mouvBenneProgramme['listePeriodesPause'] || [];
      this.mouvBenneProgramme['typeOperation'] = this.mouvBenneProgramme['typeOperation'] || 0;
      switch (this.mouvBenneProgramme['typeOperation']) {
        case 0:
          if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
            this.mouvBenneProgramme['listTtSemaine'] = this.mouvBenneProgramme['listJours'] || [];
          } else {
            this.mouvBenneProgramme['listSemainePaire'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
            this.mouvBenneProgramme['listSemaineImpaire'] = this.mouvBenneProgramme['listJours'] || [];
          }
          break;
        case 1:
          this.mouvBenneProgramme['listJoursMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
        case 2:
          this.mouvBenneProgramme['listJoursMois1'] = this.mouvBenneProgramme['listJours'] || [];
          this.mouvBenneProgramme['listJoursMois2'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
          this.mouvBenneProgramme['listJoursMois3'] = this.mouvBenneProgramme['listJoursSemaine3'] || [];
          this.mouvBenneProgramme['listJoursMois4'] = this.mouvBenneProgramme['listJoursSemaine4'] || [];
          this.mouvBenneProgramme['listJoursMois5'] = this.mouvBenneProgramme['listJoursSemaine5'] || [];
          break;
        case 3:
          this.mouvBenneProgramme['listJoursDerSemaineMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
      }
      this.tempMvtProgramme = Object.assign({}, this.mouvBenneProgramme);

    }
  }

  modifProgram() {
    let isModif = false;
    const listTtSemaine = this.mouvBenneProgramme['listTtSemaine'].length ? true : false,
      listSemainePaire = this.mouvBenneProgramme['listSemainePaire'].length ? true : false,
      listSemaineImpaire = this.mouvBenneProgramme['listSemaineImpaire'].length ? true : false,
      listJoursMois = this.mouvBenneProgramme['listJoursMois'].length ? true : false,
      listJoursMois1 = this.mouvBenneProgramme['listJoursMois1'].length ? true : false,
      listJoursMois2 = this.mouvBenneProgramme['listJoursMois2'].length ? true : false,
      listJoursMois3 = this.mouvBenneProgramme['listJoursMois3'].length ? true : false,
      listJoursMois4 = this.mouvBenneProgramme['listJoursMois4'].length ? true : false,
      listJoursMois5 = this.mouvBenneProgramme['listJoursMois5'].length ? true : false,
      existeListePeriode = this.societe['programBenneMultiperiodes'] && this.mouvBenneProgramme['listMouvementsParPeriode'] &&
        this.mouvBenneProgramme['listMouvementsParPeriode'].length ? true : false,
      listJoursDerSemaineMois = this.mouvBenneProgramme['listJoursDerSemaineMois'].length ? true : false;
    if (listTtSemaine || listSemainePaire || listSemaineImpaire || listJoursMois || listJoursMois1 || listJoursMois2
      || listJoursMois3 || listJoursMois4 || listJoursMois5 || listJoursDerSemaineMois || existeListePeriode) {
      isModif = true;
    }
    return isModif;
  }

  createObjtMvtBennePgm() {
    console.log(this.mouvBenneProgramme);
    if (this.mouvBenneProgramme['tableConfigJoursFeries']) {
      this.mouvBenneProgramme['tableConfigJoursFeries'].forEach(elt => {
        if (elt.configJourFerie) {
          elt.configJourFerie.rattrapageLendemain = elt.configJourFerie.rattrapageLendemain || false;
        }
      });
    }
    this.mouvBenneProgramme['listMouvementsParPeriode'] = this.mouvBenneProgramme['listMouvementsParPeriode'] || [];
    this.mouvBenneProgramme['listMouvementsParPeriode'].forEach(element => {
      element.id = element.id > 0 ? element.id : 0;
    });
    const mouv = {
      id: this.mouvBenneProgramme['id'] || 0,
      typeOperation: this.mouvBenneProgramme['typeOperation'],
      frequence: this.mouvBenneProgramme['frequence'],
      tableConfigJoursFeries: this.mouvBenneProgramme['tableConfigJoursFeries'],
      listePeriodesPause: this.mouvBenneProgramme['listePeriodesPause'],
      listMouvementsParPeriode: this.mouvBenneProgramme['listMouvementsParPeriode'] || [],
      nomclass: 'MouvementBenneProgramme',
    };
    switch (this.mouvBenneProgramme['typeOperation']) {
      case 0:
        mouv['nbSemainesProgram'] = this.mouvBenneProgramme['nbSemainesProgram'];
        if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
          mouv['listJours'] = this.mouvBenneProgramme['listTtSemaine'] || [];
        } else {
          mouv['listJours'] = this.mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listSemainePaire'] || [];
        }
        break;
      case 1:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois'] || [];
        break;
      case 2:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois1'] || [];
        mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listJoursMois2'] || [];
        mouv['listJoursSemaine3'] = this.mouvBenneProgramme['listJoursMois3'] || [];
        mouv['listJoursSemaine4'] = this.mouvBenneProgramme['listJoursMois4'] || [];
        mouv['listJoursSemaine5'] = this.mouvBenneProgramme['listJoursMois5'] || [];
        break;
      case 3:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursDerSemaineMois'] || [];
        break;
    }

    if (this.mouvBenneProgramme['editDate']) {
      console.log(this.mouvBenneProgramme['datePgm'])
      if (this.mouvBenneProgramme['datePgm'] && typeof this.mouvBenneProgramme['datePgm'] === 'string' &&
        this.mouvBenneProgramme['datePgm'].match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
        mouv['dateFin'] = this.mouvBenneProgramme['datePgm'];
      } else {
        if (moment(this.mouvBenneProgramme['datePgm']).isValid()) {
          mouv['dateFin'] = moment(this.mouvBenneProgramme['datePgm']).format('DD/MM/YYYY');
        }
        if (!this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '') {
          mouv['dateFin'] = '31/12/9999';
        }
      }
    }

    console.log(mouv)
    return mouv;
  }

  selectedDay(list, elem) {
    if (elem > 0) {
      const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
      return listfilter.length ? true : false;
    } else {
      return false;
    }
  }

  selectedSemaine(list, elem) {
    list = list || [];
    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    return listfilter.length ? true : false;
  }

  checkDayWeek(list, elem) {
    // let list = [];

    const listfilter = list.filter(elt => parseInt(elt, 10) === parseInt(elem, 10));
    if (listfilter.length) {
      let index;
      list.forEach((elt, idx) => {
        if (parseInt(elt, 10) === parseInt(elem, 10)) {
          index = idx;
        }
      });
      // const index = list.indexOf('' + 5);
      list.splice(index, 1);
      list = [...list];
    } else {
      list.push('' + elem);
      list = [...list];
    }
  }


  changeDateStart(event) {
    clearTimeout(this.delay);
    const ctrl = this;
    if (typeof event === 'string' && event.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
      ctrl.newprest['dateStart'] = ctrl.common.parseDate(event);
      this.getlistIndispo();
    }
    if (this.isVidage || this.edit) {
      this.isModifDateVidage = true;
    }

    if (this.societe['gestionDateMax']) {
      if (!this.edit) {
        if (moment(ctrl.newprest['dateStart']).isAfter(ctrl.newprest['dateMaxStart'])) {
          ctrl.newprest['dateMaxStart'] = ctrl.newprest['dateStart'];
        }
      }
    }
    if (this.newprest['contenant'] && this.newprest['contenant'].isLocation && this.newprest['typeOperation'] && this.newprest['typeOperation'].id == 0) {
      ctrl.newprest['contenant'].dateDebutLoc = ctrl.newprest['dateStart']
    }
  }

  modifContentContenant() {
    this.setValue(this.info['contenant'], 'contenant', false, false, false, true);
    this.newprest['IsAfficheNewContenant'] = false;
    this.addArticle = false;
    this.isEditContenant = true;
    if (this.newprest['contenant'] && !this.newprest['contenant'].isGroupeArticle && this.newprest['contenant'].art) {
      this.newprest['contenant'].art.libelleObjetEntite = `${this.newprest['contenant'].art.code || ''}/${this.newprest['contenant'].art.libelle || ''}`;
    }
    this.editEvent(this.newprest, 3);
  }

  closeFunction() {
    this.isClicked = false;
    this.showSpinner = false;
    this.close.emit();
    this.selectedChantier = {};
    this.newprest = {};
    this.step = 1;
    this.newBenne = {};
  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  focusStep() {
    switch (this.step) {
      case 1:
        setTimeout(function () {
          $('#autocomplete').focus();
        }, 550);
        break;
      case 2:
        setTimeout(function () {
          $('#autocomplete').focus();
        }, 550);
        break;
      case 3:
        setTimeout(function () {
          $('#inputTypeHidden').focus();
          // $('#autofocus').focus();
        }, 550);
        break;
      case 3:
        if (this.addContenant && !this.isGroupe) {
          setTimeout(function () {
            $('#date1').focus();
          }, 550);
        } else {
          if (this.newprest['newContenant']) {
            setTimeout(function () {
              $('.typecontenant').click();
            }, 550);
          } else {
            setTimeout(function () {
              $('[tabindex=0]').focus();
            }, 550);
          }
        }

        break;
      case 5:
        if (this.addContenant && !this.isGroupe) {
        } else {
          if (!this.isEditContenant) {
            setTimeout(function () {
              $('[tabindex=0]').focus();
            }, 550);
          } else {
            setTimeout(function () {
              $('.typecontenant').click();
            }, 550);
          }
        }

        break;
      case 6:
        if (this.addContenant && !this.isGroupe) {
          if (!this.isEditContenant) {
            setTimeout(function () {
              $('[tabindex=0]').focus();
            }, 550);
          } else {
            setTimeout(function () {
              $('.typecontenant').click();
            }, 550);
          }
        } else {
          setTimeout(function () {
            $('.typecontenant').click();
          }, 550);
        }

        break;
      case 7:
        if (this.addContenant && !this.isGroupe) {
          setTimeout(function () {
            $('.typecontenant').click();
          }, 550);
        } else {
          setTimeout(function () {
            $('#inputTypeHidden').focus();
            console.log($('#inputTypeHidden'));
            // $('.typeOperation').click();
          }, 550);
        }

        break;
      case 8.1:
        setTimeout(function () {
          $('.combo').click();
        }, 550);
        break;
      case 8:
        if (this.addContenant && !this.isGroupe) {
          setTimeout(function () {
            $('#inputTypeHidden').focus();
            console.log($('#inputTypeHidden'));
            // $('.typeOperation').click();
          }, 550);
        } else {
          setTimeout(function () {
            $('#date1').focus();
          }, 550);
        }

        break;
      case 9:
        if (!this.newprest['showInfo']) {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        }
        break;
      // case 10:
      //   setTimeout(function () {
      //     $('#acompte').focus();
      //   }, 500);
      //   break;
      // case 11:
      //   if (!this.newprest['showInfo']) {
      //     setTimeout(function () {
      //       $('[tabindex=0]').focus();
      //     }, 550);
      //   }
      //   break;
    }
  }

  keyEnterHideInput() {
    console.log('step keyEnterHideInput', this.step)
    switch (this.step) {
      case 1:
        setTimeout(function () {
          $('#autocomplete').focus();
        }, 550);
        break;
      case 2:
        setTimeout(function () {
          $('#autocomplete').focus();
        }, 550);
        break;
      case 3:
        setTimeout(function () {
          $('.ChoiceContent').click();
        }, 550);
        break;
      case 4:
        if (this.newprest['newContenant']) {
          setTimeout(function () {
            $('.typecontenant').click();
          }, 550);
        } else {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        }
        break;
      case 5:
        if (!this.isEditContenant) {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        } else {
          setTimeout(function () {
            $('.typecontenant').click();
          }, 550);
        }
        break;
      case 6:
        setTimeout(function () {
          $('.typecontenant').click();
        }, 550);
        break;
      case 7:
        setTimeout(function () {
          $('.typeOperation').click();
        }, 550);
        break;
      case 8.1:
        setTimeout(function () {
          $('.combo').click();
        }, 550);
        break;
      case 8:
        setTimeout(function () {
          $('#date1').focus();
        }, 550);
        break;
      case 9:
        setTimeout(function () {
          $('.sitePrest').click();
        }, 550);
        break;
      case 10:
        setTimeout(function () {
          $('#acompte').focus();
        }, 500);
        break;
      case 11:
        if (!this.newprest['showInfo']) {
          setTimeout(function () {
            $('[tabindex=0]').focus();
          }, 550);
        }
        break;
    }
  }

  getMargin() {
    let value;
    // switch (this.step) {
    //   case 1:
    //     value = !this.edit ? '35px' : '-100px';
    //     break;
    //   case 2:
    //     value = !this.edit ? '15px' : '-100px';
    //     break;
    //   case 3:
    //     value = !this.edit ? '2px' : '-100px';
    //     break;
    //   case 4:
    //     value = !this.edit ? '-11px' : '-30px';
    //     break;
    //   case 5:
    //     value = !this.edit ? '-24px' : '-42px';
    //     break;
    //   case 6:
    //     value = !this.edit ? '-36px' : '-55px';
    //     break;
    //   case 7:
    //     value = !this.edit ? '-51px' : '-70px';
    //     break;
    //   case 8:
    //     value = !this.edit ? '-62px' : '-80px';
    //     break;
    //   case 8.1:
    //     value = !this.edit ? '-75px' : '-90px';
    //     break;
    //   case 9:
    //     value = !this.edit ? '-90px' : '-107px';
    //     break;
    //   case 10:
    //     value = !this.edit ? '-100px' : '-120px';
    //     break;
    //   case 11:
    //     value = !this.edit ? '-110px' : '-130px';
    //     break;
    //   default:
    value = !this.edit ? '35px' : '-100px';
    // }

    return value;
  }

  countRowsInText(text) {
    if (text) {
      const numerOfRowsInText = text.length ? text.split(/\r*\n/).length : 0;
      return numerOfRowsInText <= 3 ? 3 : 10;
    }
  }

  findCalendar(event) {
    this.objectoldFocus = Object.assign({}, this.objectFocus);
    if (event.target.id !== 'autocomplete') {
      if (this.common.dropdown) {
        this.common.dropdown.hide();
        this.objectFocus = {};
      }
    } else {
      if (this.common.dropdown && this.common.dropdown['ouvert']) {
        this.common.dropdown.show();
        this.objectFocus = Object.assign({}, this.objectoldFocus);
      }
    }
  }


  prevStep() {
    if (this.editContenant && !this.isGroupe) {
      if (this.step === 7) {
        this.step = 6;
      } else {
        return false;
      }
    }

    this.step = this.step > 1 ? this.step - 1 : 1;
    if (this.isGroupe && this.step === 5) {
      this.prevStep();
    }
    this.focusStep();
    if (this.step === 7 && !this.isShowSite) {
      this.prevStep();
    }
  }

  nextStep(isclient?) {
    if (!this.notValideChamp()) {
      if (this.step === 2) {
        setTimeout(() => {
          $('#inputTypeHidden').focus();
        }, 550);
      }
      if (this.step === 1) {
        if (isclient) {
          this.getDetailClient(this.newprest['client'].id).then(() => {
            if (this.client['codeBlocage'] && (this.client['codeBlocage'] === 3 || this.client['codeBlocage'] === 4 ||
              this.client['codeBlocage'] === 5 || this.client['codeBlocage'] === 10)) {
              this.error = `Client bloqu\u00e9.\nVeuillez consulter votre administrateur pour le d\u00e9bloquer.`;
              this.step = 1;
              this.common.openModal(this.modalService, this.msg);
              return false;
            } else {
              this.step = this.step < 11 ? this.step + 1 : 11;
            }
          });
        } else {
          this.step = this.step < 11 ? this.step + 1 : 11;
        }
      } else {
        if (this.editContenant && !this.isGroupe) {
          if (this.step === 6) {
            this.step = 7;
          } else {
            return false;
          }
        }
        this.step = this.step < 11 ? this.step + 1 : 11;
        if (this.isGroupe && (this.step === 5)) {
          this.nextStep();
        }

        if (this.step === 7 && !this.isShowSite) {
          this.nextStep();
        }

        this.focusStep();
      }

    }
  }

  notValideChamp() {
    let boolValue = false;
    switch (this.step) {
      case 1:

        if (!this.newprest['client'] || (this.newprest['client'] && !this.newprest['client'].id)) {
          $('#autocomplete').focus();
          this.newprest['client'] = false;
          boolValue = true;
        } else {

        }
        break;
      case 2:
        if (!this.selectedChantier || (this.selectedChantier && !this.selectedChantier['id'])) {
          $('#autocomplete').focus();
          this.newprest['chantier'] = false;
          boolValue = true;
        }
        break;
      case 3:
        if (this.addContenant && !this.isGroupe) {

        } else {
          if (this.newBenne['typeContenant']) {
            if (!this.isGroupe) {
              if ((!this.newBenne['typeContenant'] || (this.newBenne['typeContenant'] && !this.newBenne['typeContenant'].id))
                || (this.newprest['contenant'] && !this.newprest['contenant']['typeContenant'] ||
                  (this.newprest['contenant'] && this.newprest['contenant']['typeContenant'] && !this.newprest['contenant']['typeContenant'].id))
                || (this.newprest['newBenne'] && !this.newprest['newBenne']['typeContenant'] ||
                  (this.newprest['newBenne']['typeContenant'] && !this.newprest['newBenne']['typeContenant'].id))) {
                $('.typecontenant').click();
                this.error = `Vous devez sélectionner un type de contenant`;
                this.common.openModal(this.modalService, this.msg);
                boolValue = true;
              } else {
                if (this.newBenne['isGroupeArticle']) {
                  boolValue = false;
                } else {
                  if (!this.newBenne['art'] || (this.newprest['art'] && !this.newprest['art'].id)) {
                    $('.articleCont').focus();
                    boolValue = true;
                  }
                }
              }
            }

          } else {
            if (!this.newprest['contenant'] && !this.isGroupe || (this.newprest['contenant'] && !this.newprest['contenant'].id)) {
              $('[tabindex=0]').focus();
              boolValue = true;
            } else {
              if (!this.isGroupe) {
                if (!this.newprest['contenant']['typeContenant'] || (this.newprest['contenant']['typeContenant'] &&
                  !this.newprest['contenant']['typeContenant'].id)) {
                  $('.typecontenant').click();
                  this.error = `Vous devez sélectionner un type de contenant`;
                  this.common.openModal(this.modalService, this.msg);
                  boolValue = true;
                } else {
                  if (this.newprest['contenant']['isGroupeArticle'] && this.newprest['contenant'].listArticle
                    && this.newprest['contenant'].listArticle.length) {
                    boolValue = false;
                  } else {
                    if (!this.newprest['contenant']['art'] || (this.newprest['contenant']['art'] &&
                      !this.newprest['contenant']['art'].id)) {
                      $('.articleCont').focus();
                      boolValue = true;
                    }
                  }
                }
              }
            }
          }
        }
        break;
      case 4:
        if (this.addContenant && !this.isGroupe) {
          if (!this.newBenne['art'] || !this.newBenne['typeContenant'] || (this.newBenne['art'] && !this.newBenne['art'].id)
            || (this.newBenne['typeContenant'] && !this.newBenne['typeContenant'].id)) {
            boolValue = true;
          }
          if (!this.newprest['newBenne']) {
            boolValue = true;
          } else {
            if ((!this.newprest['newBenne']['typeContenant'] || (this.newprest['newBenne']['typeContenant'] &&
              !this.newprest['newBenne']['typeContenant'].id))) {
              $('.typecontenant').click();
              boolValue = true;
              this.error = `Vous devez sélectionner un type de contenant`;
              this.common.openModal(this.modalService, this.msg);
            } else {
              if (this.newprest['newBenne']['isGroupeArticle'] && this.newprest['newBenne'].listArticle
                && this.newprest['newBenne'].listArticle.length) {
                boolValue = false;
              } else {
                if (!this.newprest['newBenne']['art'] || (this.newprest['newBenne']['art'] &&
                  !this.newprest['newBenne']['art'].id)) {
                  $('.articleCont').focus();
                  boolValue = true;
                }
              }
            }
          }


        } else {
          if (!this.newprest['exutoire'] || (this.newprest['exutoire'] && !this.newprest['exutoire'].id)) {
            $('#autocomplete').focus();
            boolValue = true;
          }
        }
        break;
      case 7:
        if (this.addContenant && !this.isGroupe) {
          if (!this.newprest['exutoire'] || (this.newprest['exutoire'] && !this.newprest['exutoire'].id)) {
            $('#autocomplete').focus();
            boolValue = true;
          }
        }
        break;
      // case 5:
      //   if (this.addContenant && !this.isGroupe) {
      //     if (this.newprest['newContenant']) {
      //       if (!this.isGroupe) {
      //         if (!this.newBenne['typeContenant'] || (this.newprest['typeContenant'] && !this.newprest['typeContenant'].id)) {
      //           $('.typecontenant').click();
      //           boolValue = true;
      //         } else {
      //           if (this.newBenne['isGroupeArticle']) {
      //             boolValue = false;
      //           } else {
      //             if (!this.newBenne['art'] || (this.newprest['art'] && !this.newprest['art'].id)) {
      //               $('.articleCont').focus();
      //               boolValue = true;
      //             }
      //           }
      //         }
      //       }

      //     } else {
      //       if (!this.newprest['contenant'] || (this.newprest['contenant'] && !this.newprest['contenant'].id)) {
      //         $('[tabindex=0]').focus();
      //         boolValue = true;
      //       }
      //     }
      //   }

      //   break;

      case 7:
        if (this.addContenant && !this.isGroupe) {
          if (!this.newprest['exutoire'] || (this.newprest['exutoire'] && !this.newprest['exutoire'].id)) {
            $('#autocomplete').focus();
            boolValue = true;
          }
        }
        break;
    }
    return boolValue;
  }

  setFocuscalendar(event) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
    }
  }

  showFiche() {
    this.showFicheclt = !this.showFicheclt;
    if (this.showFichechantier) {
      this.hideChantier();
    }
  }

  createChantier(event) {
    event.nomclass = 'Chantier';
    event.siteChantier = {
      'id': this.common.user[2]
    };
    const param = {
      'servlet': 'DBSaveChantierHolding',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBSaveChantierHolding'], event, {
        id: this.newprest['client'] ? this.newprest['client'].id : 0,
        nomclass: 'Client'
      }]
    };

    this.common.post('', { param: param }, true).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data !== null) {
          if (datas.data[0]) {
            this.hideChantier();
            event['id'] = datas.data[0];
            this.common.createLog('108', datas.data[0], true);
            this.arg1FuncAfterSygetrack = event['id'];
            this.arg2FuncAfterSygetrack = event;

            if (datas.data.length && this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity()) {
              this.setPOI(datas.data[0]);
            } else {
              this.suiteRetourUpdateChantier();
            }
          }
        }
      }
    });
  }

  hourMvt() {

    return (this.newprest['hour'] || '');
  }

  dureeMvt() {
    if (parseInt(this.newprest['hourDuree'], 10)) {
      const heure = (this.newprest['hourDuree'] || '00') + 'h' + (this.newprest['minDuree'] || '00');
      return heure;
    } else {
      if (this.newprest['hourDuree'] === '00') {
        const heure = (this.newprest['hourDuree'] || '00') + 'h' + (this.newprest['minDuree'] || '00');
        return heure;
      } else {
        return;
      }

    }
  }

  parseDureeMvt() {
    const heureDuree = parseInt((this.newprest['hourDuree'] || 0), 10);
    const minDuree = parseFloat('' + parseInt((this.newprest['minDuree'] || 0), 10) / 60).toFixed(2);
    const duree = heureDuree + parseFloat(minDuree);
    console.log('duree = ' + duree);
    return duree;
  }

  hideChantier() {
    this.isEditChantier = false;
    this.showFichechantier = false;
    this.addChantier = false;
  }

  updateChantier(event) {
    this.newprest['chantier'].telephone = event.telephone || '';
    if (event && event.lieuChantierSelect && event.lieuChantierSelect.id) {
      if (this.info && this.info.contenant) {
        this.info.contenant['lieu'] = event.lieuChantierSelect;
      }

      if (this.newprest && this.newprest['contenant']) {
        this.newprest['contenant']['lieu'] = event.lieuChantierSelect;
      }

      const benne = this.newprest['contenant'] && this.newprest['contenant'].id ? this.newprest['contenant'] : this.newBenne;
      this.actualiseAxeAnaArticle(benne);
      this.actualiseCont(benne);
    }
  }

  showFicheCltadd() {
    this.addClient = !this.addClient;
    this.showFiche();
    if (!this.showFicheclt) {
      setTimeout(function () {
        $('#autocomplete').focus();
      }, 500);
    }
  }

  afterAddClt(event) {
    console.log(event);
    this.setValue(event, 'client');
    // this.newprest['client'] = event;
  }

  getChantier(id, edit?) {
    if (this.showFicheclt) {
      this.showFicheclt = false;
    }

    if (id) {
      this.getDetailChantier(id).then(datas => {
        this.isEditChantier = edit ? true : false;
        this.showFichechantier = datas.data[0];
        $('#slide-right').trigger('click');
        this.showFichechantier['lieuChantierSelect'] = this.info && this.info.contenant && this.info.contenant.lieu ? this.info.contenant.lieu : {};
      });
    } else {
      this.isEditChantier = true;
      this.showFichechantier = {};
      this.addChantier = true;
    }
  }

  getDetailChantier(id, isSpiner?) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', id]
    };

    return this.common.post('', { param: param }, isSpiner || false).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas;
      }
    });
  }

  showCreate() {
    this.newprest['newContenant'] = true;
    this.newprest['IsAfficheNewContenant'] = !this.newprest['IsAfficheNewContenant'];
    this.newBenne = {};
    this.isAddcontenant = true;
    this.newBenne['dateDebutLoc'] = this.common.parseDate(moment().add(1, 'days').format('DD/MM/YYYY'));
    this.newBenne['isLocation'] = (this.societe['isLocation'] || this.client['isLoc']) ? true : false;
    this.newBenne['isLocJour'] = (this.client['isLocJournalier']) ? true : false;
    this.newprest['contenant'] = false;
    setTimeout(function () {
      $('.combo').click();
    }, 550);
  }

  changeDateTest(event) {
    console.log(event);
  }

  getDetailClient(id) {
    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.client = datas.data ? datas.data[0] : {};
        this.client['codeBlocage'] = this.common.getCodeBlocageClient(this.client, parseInt(this.common.user[2], 10));
      }
    });
  }

  setValue(value, name?, isFirst?, isOk?, isNotNext?, notReChargeGroupe?) {
    console.log('Calling setValue()');
    console.log('step glob', this.step)
    console.log('value', value);
    console.log('name', name);
    if (name === 'divers' && this.isChoixCamionCreationMouv) {
      this.newprest['periode'] = this.defaultPeriode;
      this.newprest['camion'] = this.defaultCamion;
      console.log(this.newprest['periode']);
    }
    if (this.isModifierLeContenant) {
      this.afficherAutreStep = false;
    }
    if (this.edit) {
      this.showLeft = false;
      this.isModifier = true;
      setTimeout(function () {
        $('#btnvalider').focus();
      }, 500);
    }

    if (name) {
      this.newprest[name] = value;
      this.objectFocus = {};
    }
    if (this.addContenant && !this.isGroupe) {
      if (this.step === 3) {
        this.newBenne['dateDebutLoc'] = this.newprest['dateStart'];
      }
    }

    if (this.editContenant) {
      if (!this.isModifierLeContenant && !this.isGroupe && !this.newprest.program) {
        this.step = 5;
      }
    }
    if (!this.notValideChamp()) {
      $('#autofocus').focus();
      if (name && name === 'client') {
        this.newprest['chantier'] = false;
        this.selectedChantier = {};
        this.newprest['adresse'] = false;
        if (value) {
          // this.clientSelected_numBonManuelObligatoire = false;
          this.getDetailClient(value.id).then(() => {
            if (this.client['codeBlocage'] && (this.client['codeBlocage'] === 3 || this.client['codeBlocage'] === 4 ||
              this.client['codeBlocage'] === 5 || this.client['codeBlocage'] === 10)) {
              this.error = `Client bloqu\u00e9.\nVeuillez consulter votre administrateur pour le d\u00e9bloquer.`;
              this.step = 1;
              this.common.openModal(this.modalService, this.msgFormat);
              return false;
            }
            // this.clientSelected_numBonManuelObligatoire = this.client['numBonManuelObligatoire'] || false;
            this.getListContrat();
            this.getValeurDateMax();
          });
        }
      }

      if (name && name === 'chantier') {
        console.log('contenant', name)
        this.getListeContenant(this.newprest['client'].id, (this.newprest['chantier'].numChantier || '')).then((res) => {
          if (!this.isGroupe && this.isCreateWithBtn) {
            this.listContenantCree('event', this.listcontenant)
          }
        })
        const benne = this.newprest['contenant'] && this.newprest['contenant'].id ? this.newprest['contenant'] : this.newBenne;
        this.actualiseAxeAnaArticle(benne);
        this.searchZone()
        this.actualiseCont(benne);
        setTimeout(function () {
          $('#autofocus').focus();
        }, 100);
      }

      if (name && name === 'cont') {
        // if (this.newprest['contenant'].isGroupeArticle  && (!this.newprest['contenant'].listArticle ||
        // (this.newprest['contenant'].listArticle && !this.newprest['contenant'].listArticle.length ))) {
        // return
        // } else {
        this.isEditContenant = false;
        if (!this.newprest['exutoire'] || (this.newprest['exutoire'] && !this.newprest['exutoire'].id)) {
          const siteUtilisateur = this.common.local.getObject('siteUser') || this.siteUtilisateur;
          this.searchExutoireLimitArticle('', true).then(dataExu => {
            if (!this.isHistoMvt) {
              let exutoire = siteUtilisateur['exutoireEcobennesParDefaut'] || { id: 0 };
              if (this.isHistoMvt) {
                exutoire = this.info['exutoire'];
              }

              console.log(this.isHistoMvt, exutoire)
              const existe: any = exutoire && exutoire.id ?
                (this.listExutoireLimiteArticle && this.listExutoireLimiteArticle.length > 0 ?
                  this.listExutoireLimiteArticle.filter(element =>
                    element.id === exutoire.id) : [exutoire]) : [];
              const verifDefaultExutoire = (existe && existe[0] && existe[0].id > 0) ? true : false;
              if (verifDefaultExutoire) {
                this.defaultExutoir = exutoire;
                this.defaultExutoir['libelleObjetEntite'] = this.defaultExutoir['nom'] || '';
                this.newprest['exutoire'] = this.defaultExutoir;
              } else {
                this.defaultExutoir = false;
                this.newprest['exutoire'] = { id: 0 };
              }
            }
          });
        }
        // }
      }


      if (name && name === 'newBenne') {

        if (!this.isDmdEcoGED) {
          this.typeOperation = this.listOperationNew;
          this.defaultSelected = this.typeOperation[0];
          this.defaultSelectedOPeration = Object.assign({}, this.typeOperation[0]);
        }
        this.changeDatePlanning('dateDebutLoc');
        if (!this.edit && this.newprest['newBenne'] && this.newprest['newBenne'].clefBenneChantiersD0 > 0) {
          this.isMouvPraxy = true;
          // this.isGroupe = true;
        }
        if (!this.newprest['exutoire'] || (this.newprest['exutoire'] && !this.newprest['exutoire'].id)) {
          const siteUtilisateur = this.common.local.getObject('siteUser') || this.siteUtilisateur;
          this.searchExutoireLimitArticle('', true).then(dataExu => {
            if (!this.isHistoMvt) {
              let exutoire = siteUtilisateur['exutoireEcobennesParDefaut'] || { id: 0 };
              if (this.isHistoMvt) {
                exutoire = this.info['exutoire'];
              }
              console.log(this.isHistoMvt, exutoire)
              const existe: any = exutoire && exutoire.id ?
                (this.listExutoireLimiteArticle && this.listExutoireLimiteArticle.length > 0 ?
                  this.listExutoireLimiteArticle.filter(element =>
                    element.id === exutoire.id) : [exutoire]) : [];
              const verifDefaultExutoire = (existe && existe[0] && existe[0].id > 0) ? true : false;
              if (verifDefaultExutoire) {
                this.defaultExutoir = exutoire;
                this.defaultExutoir['libelleObjetEntite'] = this.defaultExutoir['nom'] || '';
                this.newprest['exutoire'] = this.defaultExutoir;
              } else {
                this.defaultExutoir = false;
                this.newprest['exutoire'] = { id: 0 };
              }
            }
          });
        }

        if (this.modifierGroupe) {
          this.modifierGroupe = !this.modifierGroupe;
          return false;
        }
      }
      if (name && name === 'contenant') {
        this.listQteCombo('contenant');
        this.qteSelected = {
          id: this.newprest['contenant'].qteContenant,
          libelleObjetEntite: this.newprest['contenant'].qteContenant
        };
        this.actualiseAxeAnaArticle(this.newprest['contenant']);
        this.actualiseAxeAnaContenant(this.newprest['contenant']);

        if (!this.edit && this.newprest['contenant'] && this.newprest['contenant'].clefBenneChantiersD0 > 0) {
          this.isMouvPraxy = true;
          // this.isGroupe = true;
        }
        if (!this.isDmdEcoGED) {
          if (!this.edit) {
            this.typeOperation = this.listOperationBenne;
            this.defaultSelected = this.typeOperation[0];
            this.defaultSelectedOPeration = Object.assign({}, this.typeOperation[0]);
          }
        }
        value.dateDebutLoc = value ? this.common.parseDate(value.dateDebutLoc) : '01/01/2000';

        this.changeDatePlanning('dateDebutLoc', 'contenant');
        if (this.newprest['contenant'].typeContenant) {
          const elt = this.newprest['contenant'].typeContenant;
          this.newprest['contenant'].typeContenant.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') +
            (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') + (elt.uniteCont ? elt.uniteCont.libelle : '');
        }
        if (this.newprest['contenant'].art) {
          this.newprest['contenant'].art.libelleObjetEntite = this.newprest['contenant'].art.libelle;
        }

        if (!this.edit) {
          this.getDefaultExutoire(value);
        }

        if (!this.isDmdEcoGED) {
          if (!notReChargeGroupe) {
            if (value.isGroupeArticle && !this.isMouvPraxy && !this.isEcoDDS) {
              this.getGroupeArt(value);
            }
            if (value.isGroupeBenne && !this.isMouvPraxy && !this.isEcoDDS) {
              isFirst = isFirst || false;
              this.getGroupeBenne(value, isFirst);
            }
          }
        }

        if (this.modifierGroupe) {
          this.modifierGroupe = !this.modifierGroupe;
          return false;
        }

      }

      if (!isNotNext) {

        if (!this.editContenant) { //  || (this.editContenant && this.isGroupe)
          const isChampOp = this.societe.operationBenneSupp && this.societe.operationBenneParDefaut
            && this.dataisOpSurBenneEnPlace && this.dataisOpSurBenneEnPlace.length ? true : false;
          if (name === 'typeOperation' && isChampOp && value && (value.id !== 0 && value.id !== 1)) {
            if (isOk) {
              this.nextStep();
            }
          } else {
            this.nextStep();
          }
        } else {
          this.step = 5
        }
      }


      if (this.step === 3) {

        console.log('step4', this.step)
        if (!this.isMouvPraxy) {
          this.getContenantCht();
        }
        this.listcontenant.sort(function (x, y) {
          return (x === y) ? 0 : x ? -1 : 1;
        });
        this.selectContenant = this.listcontenant[0];
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      }
      if (this.step === 4) {
        setTimeout(function () {
          $('#autofocus2').focus();
        }, 500);
      }


      if (this.step === 5) {
        this.isEditContenant = false;
      }
      if (this.step === 8) {
        setTimeout(function () {
          $('#date1').focus();
        }, 500);
      }

      if (this.step === 10) {
        setTimeout(function () {
          $('#acompte').focus();
        }, 500);
      }

      if (this.step === 11) {
        this.newprest['showInfo'] = false;
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      }
    }

    if (this.isModifierLeContenant) {
      this.afficherAutreStep = false;
      this.step = 7;
    }

    console.log(this.newprest);
  }

  searchClientNew(event) {
    const user = this.common.local.getObject('userDetail') || {};
    this.common.getModule();
    const activedModule = '' + this.common.activedModule;
    const fonctionUser = user.fonctionUser ? (user.fonctionUser.id || 0) : 0;
    const param = {
      'critere': event,
      'type': ['clients'],
      'afficherCodeNomClient': 'true',
      'afficherPrenom': 'true',
      'afficherClientToutProspect': 'false',
      'afficherFactureAvoirNonHistorise': 'false',
      'clefSite': this.common.user[2],
      'clefUser': this.common.user[0],
      'clefFonction': fonctionUser,
      'clefModule': activedModule
    };

    this.common.searchEcoloc({ param: param }).then(datas => {
      $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataClient = datas.data;
      }
    });
  }

  searchClient(event) {
    this.searchClientNew(event);
  }

  searchArticle(event, grp?) {
    const isNonSoumisFIP = this.client && this.client.id ? this.client?.isNonSoumisFIP || false : false;
    const param = this.societe['gestionFIP'] && this.societe['isFIPCET'] && this.societe['compteGoodflag'] && !isNonSoumisFIP ? 57 : 14;
    const tab = this.societe['gestionFIP'] && this.societe['isFIPCET'] && this.societe['compteGoodflag'] && !isNonSoumisFIP  ? [{
      nom: 'CLEF_CLIENT', valeur: {
        'typeParam': 'int',
        'valeur': this.newprest.client && this.newprest.client.id ? this.newprest.client.id : 0
      }
    },
    {
      nom: 'CLEF_CHANTIER', valeur: {
        'typeParam': 'int',
        'valeur': this.newprest.chantier && this.newprest.chantier.id ? this.newprest.chantier.id : 0
      }
    }] : [];


    return this.common.appelComboK3Fct(param, event, tab).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => elt.libelle = elt.libelleObjetEntite);

        if (!grp) {
          this.listArticle = datas.data;
        } else {
          this.listArticle = [];
          const list = [];

          grp.forEach(g => {
            if (g.art && g.art.id) {
              list.push(g.art.id);
            }
          })

          datas.data.forEach(art => {
            if (art.id && list.indexOf(art.id)) {
              const exist = this.listArticle.filter(a => a.id === art.id);
              console.log(art);
              if (!exist.length) {
                this.listArticle.push(art);
              }
            }
          });
          console.log(this.listArticle)
        }
      }
    });
  }


  searchChantier(event) {
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.newprest['client'] ? this.newprest['client'].id : 0
        },
        'CRITERE': event,

      }
    };
    if (this.societe['visuChantierDateFin']) {
      param['data']['NBR_MOIS_VISU_CHANTIER'] = {
        'typeParam': 'int',
        'valeur': this.societe['nbrMoisVisuChantier'] || 60
      };
    }
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = datas.data;
      }
    });
  }

  getListeContenant(clt, cht?) {
    this.listChantierBenne = [];
    const param = {
      'servlet': 'DBRechercheClient',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'true',
      'data': ['DBRechercheClient', '' + clt, '' + this.common.user[2], '' + (cht || '')]
    };
    this.encoursDechargement = true;

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data.length) {
        const chantier = datas.data[0].listChantier ? datas.data[0].listChantier : [];
        const listChantier = this.common.sortByText(chantier, 'numChantier');
        this.sortListeBenne(listChantier);
        this.listChantierBenne = listChantier;
        this.getContenantCht();
        this.encoursDechargement = false;
        setTimeout(() => {
          $('.etape4').trigger('click');
        }, 650)
      }
    }).catch(error => {
      console.log(error);
      this.encoursDechargement = false;
    });
  }

  showGroupeContenant() {
    this.listcontenant = []
    this.getContenantCht()
  }

  getContenantCht() {
    // this.listcontenant = [];
    this.listChantierBenne.forEach(elt => {
      if (this.newprest['chantier'] && elt.id === this.newprest['chantier'].id) {
        elt.listBenne = elt.listBenne || [];
        if (this.isGroupe) {
          elt.listBenne.forEach(benne => {
            // A revoir avec JB
            // if (!benne.isCurrent) {
            const exist = this.listcontenant.filter(ext => ext.id === benne.id)
            if (!benne.isGroupeBenne && !exist.length) {
              benne.operationBenne = { id: 2, libelleObjetEntite: 'Rotation' };
              benne.libelleObjetEntite = (benne.typeContenant && benne.typeContenant.famille ?
                benne.typeContenant.famille.libelle : '') + '/' + (benne.typeContenant &&
                  benne.typeContenant.cubage ? benne.typeContenant.cubage.cubage : '0')
                + '' + (benne.typeContenant && benne.typeContenant.uniteCont ?
                  benne.typeContenant.uniteCont.libelle : '') + ' / ' + (benne.isGroupeArticle ? 'Grp Art' :
                    (benne.art ?
                      benne.art.code : '') + '' + (benne.art ? (benne.art.libelle || benne.art.libelleObjetEntite || '') : '')) +
                (benne.operationBenne ? ' / ' + benne.operationBenne.libelleObjetEntite : '');
              this.listcontenant.push(benne);
              // if (!benne.isCurrent) {
              //   benne.operationBenne = { id: 2, libelleObjetEntite: 'Rotation' };
              //   elt.idAndOp = elt.id + 'Op' + (elt.operationBenne ? elt.operationBenne.id : '');
              //   benne.libelleObjetEntite = (benne.typeContenant && benne.typeContenant.famille ?
              //     benne.typeContenant.famille.libelle : '') + '/' + (benne.typeContenant &&
              //       benne.typeContenant.cubage ? benne.typeContenant.cubage.cubage : '0')
              //     + '' + (benne.typeContenant && benne.typeContenant.uniteCont ?
              //       benne.typeContenant.uniteCont.libelle : '') + ' / ' + (benne.isGroupeArticle ? 'Grp Art' :
              //         (benne.art ?
              //           benne.art.code : '') + '' + (benne.art.libelle || benne.art.libelleObjetEntite)) +
              //     (benne.operationBenne ? ' / ' + benne.operationBenne.libelleObjetEntite : '');
              //   this.listcontenant.push(Object.assign({}, benne));
              // } else {
              //   if (benne.listBon && benne.listBon.length) {
              //     benne.listBon.forEach(element => {
              //       console.log(element)
              //       benne.operationBenne = this.getOperationByLibelle(element.libelleOperationBenne);
              //       elt.idAndOp = elt.id + 'Op' + (elt.operationBenne ? elt.operationBenne.id : '');
              //       benne.libelleObjetEntite = (benne.typeContenant && benne.typeContenant.famille ?
              //         benne.typeContenant.famille.libelle : '') + '/' + (benne.typeContenant &&
              //           benne.typeContenant.cubage ? benne.typeContenant.cubage.cubage : '0')
              //         + '' + (benne.typeContenant && benne.typeContenant.uniteCont ?
              //           benne.typeContenant.uniteCont.libelle : '') + ' / ' + (benne.isGroupeArticle ? 'Grp Art' :
              //             (benne.art ?
              //               benne.art.code : '') + '' + (benne.art.libelle || benne.art.libelleObjetEntite)) +
              //         (benne.operationBenne ? ' / ' + benne.operationBenne.libelleObjetEntite : '');
              //       this.listcontenant.push(Object.assign({}, benne));
              //     });
              //   }
              // }

            }
            // } else {
            //   if (benne.listBon && benne.listBon.length) {
            //     benne.listBon.forEach(element => {
            //       benne.operationBenne = { id: 2, libelleObjetEntite: 'Rotation' };
            //       this.listcontenant.push(benne);
            //     });
            //   }
            // }
          });
        } else {
          this.listcontenant = [];
          this.listcontenant.push(...elt.listBenne);
        }

        this.listcontenant = this.listcontenant.sort((a, b) =>
          (a.isGroupeArticle ? 1 : 0) - (b.isGroupeArticle ? 1 : 0))
        this.listcontenant = this.listcontenant.sort((a, b) =>
          (a.isGroupeBenne ? 1 : 0) - (b.isGroupeBenne ? 1 : 0))
      }
    });

    this.searchGroupeContenantChoix();
  }

  nextFocus() {
    $('#infosup').focus();
  }

  sortListeBenne(listChantier) {
    listChantier.forEach(elt => {
      if (elt.listBenne) {
        elt.listBenne.sort(function (a, b) {
          if (a.isGroupeBenne || b.isGroupeBenne) {
            return (a.isGroupeBenne === b.isGroupeBenne) ? 0 : a.isGroupeBenne ? -1 : 1;
          } else {
            if (a.typeContenant && b.typeContenant) {
              if (a.typeContenant.famille && b.typeContenant.famille) {
                if (a.typeContenant.famille.libelle < b.typeContenant.famille.libelle) {
                  return -1;
                }
                if (a.typeContenant.famille.libelle > b.typeContenant.famille.libelle) {
                  return 1;
                }
              }

              if (a.typeContenant.cubage && b.typeContenant.cubage) {
                if (a.typeContenant.cubage.cubage < b.typeContenant.cubage.cubage) {
                  return -1;
                }
                if (a.typeContenant.cubage.cubage > b.typeContenant.cubage.cubage) {
                  return 1;
                }
              }

              if (a.art && b.art) {
                if (a.art.libelle < b.art.libelle) {
                  return -1;
                }
                if (a.art.libelle > b.art.libelle) {
                  return 1;
                }
              } else {
                return -1;
              }
            }
          }
          return 0;
        });
      }
    });
  }

  showInfoSupp(event) {
    this.newprest['showInfos'] = true;
    setTimeout(function () {
      $('[autofocus]').focus();
    }, 500);
  }

  changeFocus(event, i, value?) {
    if (event.keyCode === 40 && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      if (!value) {
        this.newprest['showInfo'] = !this.newprest['showInfo'];
      } else {
        this.newprest['showInfos'] = !this.newprest['showInfos'];
      }
    }
    if (event.keyCode === 38 && event.target.previousElementSibling) {
      event.target.previousElementSibling.focus();
      if (!value) {
        this.newprest['showInfo'] = !this.newprest['showInfo'];
      } else {
        this.newprest['showInfos'] = !this.newprest['showInfos'];
      }
    }
  }

  searchExutoireLimitArticle(event, verifLimit) {
    let groupIdArt = [];
    const contenant = !this.newprest['newContenant'] ? this.newprest['contenant'] : this.newprest['newBenne'];
    if (contenant.isGroupeArticle) {
      (contenant.listArticle || []).forEach(elt => groupIdArt.push('' + (elt.art ? elt.art.id : 0)));
    } else if (contenant.isGroupeBenne) {
      console.log(contenant.listBennes);
      contenant.listBennes.forEach(elt => {
        if (elt.isGroupeArticle) {
          (elt.listArticles || []).forEach(eltArt => groupIdArt.push('' + (eltArt.id || 0)));
        } else {
          groupIdArt.push('' + (elt.art ? elt.art.id : 0));
        }
      });
    }
    const idart = !this.newprest['newContenant'] ?
      (this.newprest['contenant'] ? (this.newprest['contenant'].art ? this.newprest['contenant'].art.id : 0) : 0) : (this.newprest['newBenne'] ? (this.newprest['newBenne'].art ?
        this.newprest['newBenne'].art.id : 0) : 0);

    const param = {
      'servlet': 'DBGetListeExuLimites',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': this.newprest['chantier'] ? (this.newprest['chantier'].id || 0) : 0
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.newprest['client'] ? (this.newprest['client'].id || 0) : 0
        },
        'LIST_ARTICLES': groupIdArt.length ? groupIdArt : ['' + idart],
        'CRITERE_NOM_EXUTOIRE': event + '%'
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        console.log('verifLimit = ' + verifLimit);
        datas.data.forEach(elt => elt.libelleObjetEntite = elt.nom || elt.libelleObjetEntite);
        if (verifLimit) {
          this.listExutoireLimiteArticle = datas.data || [];
        } else {
          this.listExutoire = datas.data || [];
          this.common.doAnothetThing(datas);
        }
      }
    });
  }

  searchExutoire(event) {
    console.log('searchExutoire');
    console.log(this.listExutoireLimiteArticle);
    if (this.listExutoireLimiteArticle && this.listExutoireLimiteArticle.length > 0) {
      this.searchExutoireLimitArticle(event, false);
    } else {
      this.anotheExutoire(event);
    }
  }

  anotheExutoire(event) {
    const param = 6;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listExutoire = datas.data;
      }
    });
  }

  hideCalendar() {
  }

  searchTypecontenant() {
  }

  searchTypecontenantByLibelle(event) {
    const listContenant = this.common.getType('listetypeContenant') || [];
    this.typeContenant = []; // { id: 0, libelleObjetEntite: 'Tous' }
    if (event !== '' && event !== 'Tous' && event !== 'tous') {
      listContenant.forEach(elt => {
        elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') +
          (elt.uniteCont ? elt.uniteCont.libelle : '');
        elt.isUnitaire = elt.isUnitaire || false;
        const libelle = elt.libelleObjetEntite ? elt.libelleObjetEntite.toLowerCase() : '';
        event = ((event || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
        const lib = ((libelle || '').normalize('NFD').replace(/\p{Diacritic}/gu, '')).toLowerCase();
        if (lib.includes(event)) {
          this.typeContenant.push(elt);
        }
      });
    } else {
      listContenant.forEach(elt => {
        elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? (elt.cubage.cubage || 0) + ' ' : '') +
          (elt.uniteCont ? elt.uniteCont.libelle : '');
        elt.isUnitaire = elt.isUnitaire || false;
        this.typeContenant.push(elt);
      });
    }

    console.log(this.typeContenant)
  }


  editEvent(event, step, idfocus?, isClick?) {
    if (this.edit) {
      if (this.isVidage) {
        if (!this.isGroupe) {
          if (step === 8 || step === 4 || step === 9 || step === 6 || step === 11 || step === 7) {
            this.showLeft = true;
          }
        } else {
          this.isModifier = false;
        }
      } else {
        this.showLeft = true;
      }
    }


    if (!this.isVidage) {
      this.step = step;
    } else {
      if (this.showLeft) {
        if (step === 8 || step === 4 || step === 9 || step === 6 || step === 11 || step === 7) {
          this.step = step;
        }
      }
    }

    if (step === 4 || step === 5) {
      this.searchExutoireLimitArticle('', true);
    }

    if (step === 5 && this.isGroupe) {
      this.step = 4;
    }

    console.log()
    if (this.step === 2) {
      if (idfocus) {
        this.objectFocus['lieu'] = true;
        setTimeout(function () {
          $('#conteneurLieu').click();
        }, 550);
        setTimeout(function () {
          $(idfocus).click();
        }, 600);
      }
    }
    if (this.step === 3) {
      setTimeout(function () {
        $('#autofocus').focus();
      }, 1000);
    }
    if (this.addContenant && !this.isGroupe) {
      if (this.step === 6) {
        setTimeout(function () {
          $('.combo').click();
        }, 600);
      }

      if (this.step === 8) {

        if (!idfocus) {
          setTimeout(function () {
            $('.typeOperation').click();
          }, 550);
        } else {
          setTimeout(function () {
            $(idfocus).click();
          }, 550);
        }
      }

      if (this.step === 4) {
        if (idfocus) {
          setTimeout(function () {
            $('#' + idfocus).focus();
          }, 100);
        } else {
          setTimeout(function () {
            $('#date1').focus();
          }, 100);
        }
      }

    } else {
      // if (this.step === 5) {
      //   setTimeout(function () {
      //     $('.combo').click();
      //   }, 600);
      // }

      if (this.step === 5) {
        if (!idfocus) {
          setTimeout(function () {
            $('.typeOperation').click();
          }, 550);
        } else {
          setTimeout(function () {
            $(idfocus).click();
          }, 550);
        }
      }

      if (this.step === 8) {
        if (idfocus) {
          setTimeout(function () {
            $(idfocus).focus();
          }, 100);
          if (isClick) {
            setTimeout(function () {
              $(idfocus).click();
            }, 100);
          }
        } else {
          setTimeout(function () {
            $('#date1').focus();
          }, 100);
        }
      }

    }

    if (this.step === 7) {
      setTimeout(function () {
        $('.sitePrest').click();
      }, 600);
    }

    if (this.step === 10) {
      if (idfocus) {
        setTimeout(function () {
          if (isClick) {
            $(idfocus).click();
          } else {
            $(idfocus).focus();
          }
        }, 100);
      } else {
        setTimeout(function () {
          $('#acompte').focus();
        }, 100);
      }
    }

    if (this.step === 9) {
      this.newprest['showInfos'] = true;
      this.newprest['showInfo'] = true;
      if (this.newprest['showInfo']) {
        if (idfocus) {
          setTimeout(function () {
            $(idfocus).focus();
          }, 100);
        } else {
          setTimeout(function () {
            $('#autofocus').focus();
          }, 100);
        }
      } else {
        setTimeout(function () {
          $('[tabindex=0]').focus();
        }, 500);
      }
    }

    if (this.editContenant) {
      if (!this.isModifierLeContenant && !this.isGroupe && !this.newprest.program) {
        this.step = 5;
      }
      if (idfocus) {
        setTimeout(function () {
          $(idfocus).click();
        }, 550);
      }
    }

    if (this.isModifierLeContenant) {
      if (step === 5) {
        return false;
      }
      this.afficherAutreStep = true;
    }

  }

  getDefaultExutoire(benne) {
    const param = {
      'servlet': 'DBGetExutoire',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetExutoire', '' + (benne['exu'] ? benne['exu'].id : '0')]
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => elt.libelleObjetEntite = elt.nom);
        if (datas.data[0].id) {
          this.defaultExutoir = datas.data[0];
          this.newprest['exutoire'] = this.defaultExutoir;
        }
      }
    });
  }

  getGroupeArt(benne) {
    const param = {
      'servlet': 'DBGetGroupeArticle',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeArticle', '' + (benne.id || 0), '1']
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data.forEach(elt => this.groupId.push('' + elt.id));
        this.newprest['contenant'].listArticles = datas.data || [];
      }
    });
  }

  getGroupeBenne(benne, isFirst?) {
    console.log(this.info['bonSelected'])
    const param = {
      'servlet': 'DBGetGroupeBennes',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetGroupeBennes', '' + (benne.id || 0), this.info['bonSelected'] ?
        ('' + (this.info['bonSelected'].id || 0)) : '0']
    };
    return this.common.post('', { param: param }, true).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        datas.data = datas.data || [];
        if (isFirst) {
          this.listcontenant = [...this.listcontenant];
          datas.data.forEach(elt => {
            const existe = this.listcontenant.filter(element => element.id === elt.id);
            if (existe && existe.length) {
              existe.forEach(m => {
                m = elt;
                this.operationBenneGroupe(m);
              });
            } else {
              this.operationBenneGroupe(elt);
              elt.idAndOp = elt.id + 'Op' + (elt.operationBenne ? elt.operationBenne.id : '');
              elt.libelleObjetEntite = (elt.typeContenant && elt.typeContenant.famille ?
                elt.typeContenant.famille.libelle : '') + '/' + (elt.typeContenant &&
                  elt.typeContenant.cubage ? elt.typeContenant.cubage.cubage : '0')
                + '' + (elt.typeContenant && elt.typeContenant.uniteCont ?
                  elt.typeContenant.uniteCont.libelle : '') + ' / ' + (elt.isGroupeArticle ? 'Grp Art' :
                    (elt.art && elt.art.id ? ((elt.art.code || '') + '' + (elt.art.libelle || elt.art.libelleObjetEntite)) : '')) +
                (elt.operationBenne ? ' / ' + elt.operationBenne.libelleObjetEntite : '');
              this.listcontenant.push(elt);
            }
            if (elt.isGroupeArticle) {
              this.getListArticleGrp(elt.id, true).then(data => {
                benne.listArticles = data;
              });
            }
          });
        }

        datas.data.forEach(element => {
          element.isChecked = true;
          element.isContenantCheck = true;
          this.operationBenneGroupe(element);
        });
        if (this.newprest['contenant']) {
          this.newprest['contenant'].listBennes = datas.data || [];
        }

        this.listBenneSelected = datas.data || [];
        this.listBenneSelected = [...this.listBenneSelected, ...this.listContDepot];
      }
      this.searchGroupeContenantChoix();
    });
  }

  getBeneDataChantier(notChangeSelected?) {
    console.log(this.info['bonSelected']);
    let mouvid, benneid;
    benneid = this.info['contenant'].id;
    if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
      if ('' + this.info['bonSelected'].id === this.info['mouvPrincipal'][16]) {
        mouvid = this.info['mouvPrincipal'][0];
      } else {
        this.listeMouvSupp.forEach(elt => {
          if (elt[5] === '' + this.info['bonSelected'].id) {
            mouvid = elt[4];
          }
        });
      }
    }
    if (this.isVidage) {
      mouvid = this.info['mouvement'] ? this.info['mouvement'].id : '';
    }

    if (this.info['mouvement'] && this.info['tournee']) {
      mouvid = this.info['mouvement'] ? this.info['mouvement'].id : '';
    }

    if (this.info['mouvement'] && this.info['mouvement'].id && !mouvid) {
      mouvid = this.info['mouvement'].id || 0;
    }

    const param = {
      'servlet': 'DBGestionEcorecExterne',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 6
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': this.newprest['chantier'] ? this.newprest['chantier'].id : 0
        },
        'CLEF_MOUVEMENT': {
          'typeParam': 'int',
          'valeur': mouvid || 0
        }
      }
    };
    this.listcontenant = [];
    return this.common.post('', { param: param }, true).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        console.log('DBGestionEcorecExterne', datas)
        const chantier = datas.data || [];
        const listContenant = [];
        if (!notChangeSelected) {
          this.listBenneSelected = this.newprest['contenant'].listBennes || [];
        }

        this.listBenneSelected.forEach(elt => {
          elt.isChecked = true;
          elt.isBenneEnPlace = false;
          elt.isBenneNonEnPlace = false;
          if (this.societe.operationBenneSupp && elt.operationBenne && elt.operationBenne.id !== 0 && elt.operationBenne.id !== 1
            && elt.operationBenne.id !== 2) {
            elt.isBenneEnPlace = this.isBenneEnPlace(elt.operationBenne);
            elt.isBenneNonEnPlace = this.isBenneNonEnPlace(elt.operationBenne);
          }

          if (elt.operationBenne) {
            elt.operationBenne.id = elt.operationBenne.id || 0;
            elt.operationBenne.libelleObjetEntite = elt.operationBenne.libelleObjetEntit || this.operationBenneGroupeLibelle(elt.operationBenne.id);
          }
        });
        chantier.forEach(element => {
          element = element || [];
          const benne = element[element.length - 1] || { id: 0 };
          benne.typeContenant = element[1] || { id: 0 };
          benne.qteContenant = element[2] || 0;
          benne['operationBenne'] = {
            id: parseInt(element[6] || '0', 10),
            libelle: this.operationBenneGroupeLibelle(element[6] || '0'),
            libelleObjetEntite: this.operationBenneGroupeLibelle(element[6] || '0')
          };

          benne.operationBenne = benne.operationBenne || { id: 2, libelleObjetEntite: 'Rotation' };
          const existe = this.listBenneSelected.filter(elt => elt.id === benne.id);
          if (existe && existe.length) {
            benne.isChecked = true;
          }
          this.operationBenneGroupe(element);
          if (!element[5]) {
            benne.art = {
              id: element[3],
              code: element[4],
              libelle: element[7],
              clefUnite: element[8],
            }
          } else {
            benne.isGroupeArticle = element[5];

            this.getListArticleGrp(benne.id, true).then(data => {
              benne['listArticles'] = data || [];
            })
          }
          listContenant.push(benne)
          this.listcontenant.push(benne);
        });
        console.log(this.listcontenant, this.listBenneSelected)
        setTimeout(() => {
          $('.etape4').trigger('click');
        }, 650)
      }
    });
  }

  getListContenantGroupEtape7() {
    return this.listcontenant.filter(elt => elt.isContenantCheck) || [];
  }

  operationBenneGroupe(benne) {
    const operation = [];
    const list = this.common.getType('listOperationSupp') || [];
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];
    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    benne['operationBenne'] = benne['operationBenne'] || { id: 0 };
    benne['operationBenne'].id = benne['operationBenne'].id || 0;
    operation.forEach(elt => {
      if (benne['operationBenne'] && elt.id === parseInt(benne['operationBenne'].id, 10)) {
        benne['operationBenne'] = elt;

        benne.isBenneEnPlace = false;
        benne.isBenneNonEnPlace = false;
        if (this.societe.operationBenneSupp && elt && elt.id !== 0 && elt.id !== 1
          && elt.id !== 2) {
          benne.isBenneEnPlace = this.isBenneEnPlace(elt);
          benne.isBenneNonEnPlace = this.isBenneNonEnPlace(elt);
        }
      }
    });
  }

  actualiseOperation(benne) {
    const elt = benne.operationBenne;
    benne.isBenneEnPlace = false;
    benne.isBenneNonEnPlace = false;
    if (this.societe.operationBenneSupp && elt && elt.id !== 0 && elt.id !== 1
      && elt.id !== 2) {
      benne.isBenneEnPlace = this.isBenneEnPlace(elt);
      benne.isBenneNonEnPlace = this.isBenneNonEnPlace(elt);
    }
  }

  operationBenneGroupeLibelle(op) {
    let libelle = ''
    const operation = [];
    const list = this.common.getType('listOperationSupp') || [];
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];
    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    op = op || 0;
    operation.forEach(elt => {
      if (elt.id === parseInt(op, 10)) {
        libelle = elt.libelleObjetEntite || '';
      }
    });

    return libelle;
  }

  getOperationByLibelle(libelle) {
    let op;
    const operation = [];
    const list = this.common.getType('listOperationSupp') || [];
    list.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    const list2 = this.common.getType('listOperationSuppBennePlace') || [];
    list2.forEach(elt => elt.libelleObjetEntite = elt.libelle);
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    operation.forEach(elt => {
      if ((elt.libelleObjetEntite.normalize('NFD').replace(/[\u0300-\u036f]/g, '')).toLowerCase() ===
        ((libelle || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')).toLowerCase()) {
        op = elt
      }
    });

    return op;
  }

  isValidDate(dateString) {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) != null;
  }

  isRetraitFct() {
    return this.newprest['typeOperation'] && this.newprest['typeOperation'].id === 1 ? true : false;
  }

  testOperationGeneration(dt, isGroupe?) {
    const momentDate = moment(this.newprest['dateStart']);
    const operation = [];
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    dt.LISTE_MOUV = dt.LISTE_MOUV || [];
    const existeMouvRetrait = dt.LISTE_MOUV.filter(elt => elt.operation === '1');
    if (existeMouvRetrait && existeMouvRetrait.length) {
      // 1
      const retrait = existeMouvRetrait[0] || {};
      const momentRetrait = moment(retrait.dateEnlevement, 'YYYY-MM-DD');
      this.setMomentHour0(momentDate);
      this.setMomentHour0(momentRetrait);
      if (momentDate.isAfter(momentRetrait) || this.isRetraitFct()) {
        this.isRetrait = true;
        const date = moment(retrait.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const numbon = retrait.bon ? retrait.bon.numBon || '' : '';
        this.error = `Il existe déjà un retrait sur ${isGroupe ? 'ce groupe de' :
          'cette'} benne le ${date} sur le bon ${numbon}.`;
        this.common.openModal(this.modalService, this.msg);
      } else {
        const mouvSupp = dt.LISTE_MOUV || [];
        const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate) && elt.operation === '0');
        if (listMouv && listMouv.length) {
          const mvtD = listMouv[0] || {};
          this.isRetrait = true;
          let ope = '';
          operation.forEach(elt => {
            if (elt.id === parseInt(mvtD['operation'], 10)) {
              ope = elt.libelleObjetEntite;
            }
          });
          const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
          const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
          this.error = `Il existe déjà un mouvement de  ${ope} sur ${isGroupe ? 'ce groupe de' :
            'cette'} de benne le ${date} sur le bon ${numbon}.`;
          this.common.openModal(this.modalService, this.msg);
        } else {
          if (this.isRetraitFct()) {
            const listMouvOp = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate));
            if (listMouvOp && listMouvOp.length) {
              const mvtD = listMouvOp[0] || {};
              this.isRetrait = true;
              let ope = '';
              operation.forEach(elt => {
                if (elt.id === parseInt(mvtD['operation'], 10)) {
                  ope = elt.libelleObjetEntite;
                }
              });
              const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
              const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
              this.error = `Il existe déjà un mouvement de ${ope} sur ${isGroupe ? 'ce groupe de' :
                'cette'} de benne le ${date} sur le bon ${numbon}.`;
              this.closeModalError()
              this.common.openModal(this.modalService, this.msg);
            } else {
              this.saveEquipeMvt().then(datas => {
                this.updateBenneChantier();
              });
            }
          } else {
            this.saveEquipeMvt().then(datas => {
              this.updateBenneChantier();
            });
          }
        }
      }
    } else {
      // 2
      const mouvSupp = dt.LISTE_MOUV || [];
      const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate) && elt.operation === '0');
      if (listMouv && listMouv.length) {
        const mvtD = listMouv[0] || {};
        this.isRetrait = true;
        let ope = '';
        operation.forEach(elt => {
          if (elt.id === parseInt(mvtD['operation'], 10)) {
            ope = elt.libelleObjetEntite;
          }
        });
        const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
        this.error = `Il existe déjà un mouvement de  ${ope} sur ${isGroupe ? 'ce groupe de' :
          'cette'} de benne le ${date} sur le bon ${numbon}.`;
        this.common.openModal(this.modalService, this.msg);
      } else {
        if (this.isRetraitFct()) {
          const listMouvOp = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate));
          if (listMouvOp && listMouvOp.length) {
            const mvtD = listMouvOp[0] || {};
            this.isRetrait = true;
            let ope = '';
            operation.forEach(elt => {
              if (elt.id === parseInt(mvtD['operation'], 10)) {
                ope = elt.libelleObjetEntite;
              }
            });
            const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
            const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
            this.error = `Il existe déjà un mouvement de ${ope} sur ${isGroupe ? 'ce groupe de' :
              'cette'} de benne le ${date} sur le bon ${numbon}.`;
            this.common.openModal(this.modalService, this.msg);
          } else {
            this.saveEquipeMvt().then(datas => {
              this.updateBenneChantier();
            });
          }
        } else {
          this.saveEquipeMvt().then(datas => {
            this.updateBenneChantier();
          });
        }

      }
    }
  }

  generatePrestation() {
    this.DBCheckContrat().then(res => {
      if (res) {
        console.log('Calling generatePrestation()');
        if (this.isMouvPraxy) {
          this.closeFunction();
          return false;
        }

        if (this.newprest['program'] && !this.modifProgram()) {
          this.error = 'Il faut sélectionner au moins un jour.';
          this.isClicked = false;
          this.showSpinner = false;
          this.common.openModal(this.modalService, this.msg);
          return;
        }

        if (!this.verificationOkNumBonManuelOb(this.newprest['numBonManuel'], this.client)) {
          this.error = 'Le champs Num bon manuel est obligatoire.';
          this.isClicked = false;
          this.showSpinner = false;
          this.common.openModal(this.modalService, this.msg);
          return;
        }

        const dateStart = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
        if (!this.isValidDate(dateStart)) {
          this.error = 'La date n\'est pas valide.';
          this.isClicked = false;
          this.showSpinner = false;
          this.common.openModal(this.modalService, this.msg);
          return;
        }

        if (this.newprest['chantier']) {
          this.newprest['chantier'].nomclass = 'Chantier';
        }
        if (this.newprest['client']) {
          this.newprest['client'].nomclass = 'Client';
        }
        if (this.newprest['newContenant']) {
          this.newprest['newBenne'] = this.newprest['newBenne'] || {};
          this.newprest['newBenne'].exutoire = this.newprest ? this.newprest['exutoire'] : {};
          this.newprest['newBenne'].infoFact = this.newprest['infoFact'] || '';
          this.newprest['newBenne'].infoNextMouv = this.newprest['infoNextMouv'] || '';
          this.newprest['newBenne'].infos = this.newprest['infos'] || '';
          if (this.newprest['newBenne'] && this.newprest['newBenne'].typeContenant && this.newprest['newBenne'].typeContenant.isUnitaire) {
            this.newprest['newBenne'].qteContenant = 1;
          }
          this.changeDatePlanning('dateDebutLoc', 'newBenne');
          this.benneChantier = this.newprest['newBenne'];
        } else {
          this.newprest['contenant'].exutoire = this.newprest['exutoire'];
          this.newprest['contenant'].infoFact = this.newprest['infoFact'] || '';
          this.newprest['contenant'].infoNextMouv = this.newprest['infoNextMouv'] || '';
          this.newprest['contenant'].infos = this.newprest['infos'] || '';
          if (this.newprest['contenant'] && this.newprest['contenant'].typeContenant && this.newprest['contenant'].typeContenant.isUnitaire) {
            this.newprest['contenant'].qteContenant = 1;
          }
          this.changeDatePlanning('dateDebutLoc', 'contenant');
          this.benneChantier = this.newprest['contenant'];
        }

        this.benneChantier['lieu'] = {
          'id': '' + (this.newprest['lieu'] ? this.newprest['lieu'].id || 0 : 0)
        };


        if (!this.benneChantier['isGroupeBenne'] && this.benneChantier['isGroupeArticle'] && (!this.benneChantier['listArticle'] ||
          (this.benneChantier['listArticle'] && !this.benneChantier['listArticle'].length))) {
          this.error = 'Votre groupe d\'article doit comporter au moins un article.';
          this.isClicked = false;
          this.showSpinner = false;
          this.common.openModal(this.modalService, this.msg);
          return;
        }

        if (!this.benneChantier['isGroupeArticle'] && this.benneChantier['art']) {
          this.benneChantier['art'].qtePrevisionnelle = this.benneChantier['qte'] || 0;
        }

        if (this.benneChantier['listArticle']) {
          this.benneChantier['listArticles'] = [];
          this.benneChantier['listArticle'].forEach(elt => {
            const art = Object.assign({}, elt.art);
            art.exu = Object.assign({}, elt.exutoire);
            art.qtePrevisionnelle = (elt.qte || 0);
            art.nomclass = 'Article';
            art.axeAnalytiqueLigneArticle = elt.axeAnalytiqueLigneArt || '';
            this.benneChantier['listArticles'].push(art);
          });
        }

        if (this.benneChantier['isGroupeBenne']) {
          // if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
          //   this.newprest['typeOperation'] = {id: '2'};
          // }


          this.newprest['typeOperation'] = { id: '2' };

          this.benneChantier['operation'] = this.benneChantier['operationBenne'] ? (this.benneChantier['operationBenne']['id'] || '0') : '0';
          this.benneChantier['operationBenne'] = {
            id: this.benneChantier['operationBenne'] ? (this.benneChantier['operationBenne']['id'] || '0') : '0'
          };
          console.log(this.newprest['typeOperation']);
        }
        if (this.benneChantier['listBennes']) {
          this.newprest['listeOperationParBenneDuGroupe'] = [];
          this.newprest['listeNumBSDDParBenne'] = [];
          this.newprest['listeNumScelleParBenne'] = [];
          this.benneChantier['listBennes'].forEach(elt => {
            let numScelle = '';
            if (elt.id < 0) {
              elt.id = 0;
            }

            if (elt.art && elt.art.amiante) {
              numScelle = elt.numScelle || ''
            }
            elt.nomclass = 'BenneData';
            elt.operation = elt.operationBenne ? (elt.operationBenne['id']) : 0;
            this.newprest['listeOperationParBenneDuGroupe'].push(elt.operationBenne ?
              (elt.operationBenne['id']) : 0);
            this.newprest['listeNumBSDDParBenne'].push(elt.numBSDDManuel || '');
            this.newprest['listeNumScelleParBenne'].push(numScelle || '');
            elt.operationBenne = {
              id: elt.operationBenne ? (elt.operationBenne['id']) : 0
            };
          });
        }

        if (this.benneChantier['isGroupeArticle'] && this.benneChantier['isGroupeBenne'] && this.benneChantier['listBennes'].length
          && (!this.benneChantier['listArticle'] || (this.benneChantier['listArticle'] && !this.benneChantier['listArticle'].length))
          && (!this.benneChantier['art'] || (this.benneChantier['art'] && !this.benneChantier['art'].id))) {
          const obj0 = this.benneChantier['listBennes'][0];
          this.benneChantier['isGroupeArticle'] = false;
          if (obj0.art) {
            this.benneChantier['art'] = Object.assign({}, obj0.art)
          } else {
            if (obj0.isGroupeArticle && obj0.listArticle && obj0.listArticle.length) {
              this.benneChantier['art'] = Object.assign({}, obj0.listArticle[0])
            }
          }
        }

        const operation = [];
        operation.push(...this.listOperationBenne, ...this.listOperationNew);

        this.benneChantier['qteContenant'] = this.benneChantier['qteContenant'] ? parseInt(this.benneChantier['qteContenant'], 10) : 1;
        const isClient = this.newprest['client'] && this.newprest['client'].id ? true : false;
        const isChantier = this.newprest['chantier'] && this.newprest['chantier'].id ? true : false;
        const isArticle = this.benneChantier['isGroupeArticle'] ? true :
          (this.benneChantier['art'] && this.benneChantier['art'].id ? true : false);
        this.newprest['exutoire'] = this.newprest['exutoire'] || { id: 0 };
        const isExutoire = this.newprest['exutoire'] && this.newprest['exutoire'].id ? true : false;
        const isTypecont = this.benneChantier['typeContenant'] && this.benneChantier['typeContenant'].id ? true : false;
        console.log(isClient, isChantier, isArticle, isExutoire, isTypecont);
        const isGoupe = this.benneChantier['isGroupeBenne'] || false;
        const listBennes = this.benneChantier['listBennes'] || [];
        if (this.newprest['typeOperation'] && (this.newprest['typeOperation'].id === 0 || this.newprest['typeOperation'].id === 1)) {
          this.defaultSelectedDefaut = { id: 0 }
        }

        let existeTypeCont0 = false;

        listBennes.forEach(element => {
          if (!existeTypeCont0 && (!element.typeContenant || element.typeContenant && !element.typeContenant.id)) {
            existeTypeCont0 = true;
          }
        });

        if (existeTypeCont0 && isGoupe) {
          this.isClicked = false;
          this.showSpinner = false;
          // this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article, type de contenant et exutoire)`;
          this.error = `Vous devez sélectionner un type de contenant`;
          this.common.openModal(this.modalService, this.msg);
        }


        if (!this.isClicked) {
          this.isClicked = true;
          this.showSpinner = true;
          // if (isClient && isChantier && isArticle && isExutoire && isTypecont && !isGoupe) {
          if (isClient && isChantier && isArticle && isTypecont && !isGoupe) {

            this.validerBSDDManContenantVert().then(datasBSD => {
              if (datasBSD.data) {
                if (this.newprest['newContenant']) {
                  console.log('new contenant');
                  this.creationMvt();
                } else {
                  console.log('exist contenant');
                  this.checkRetraitBenne().then(datas => {
                    const dt = datas.data || {};
                    this.testOperationGeneration(dt);

                  }).catch(err => {
                    this.isClicked = false;
                    this.showSpinner = false;
                  });
                }
              }
            }).catch(err => {
              this.isClicked = false;
              this.showSpinner = false;
            })

          } else {
            if (isGoupe && isClient && isChantier && listBennes.length) {
              if (listBennes.length) {
                this.validerBSDDManContenantVert().then(datasBSD => {
                  if (datasBSD.data) {
                    if (this.newprest['newContenant']) {
                      console.log('new contenant');
                      this.creationMvt();
                    } else {
                      console.log('exist contenant');
                      this.checkRetraitBenne().then(datas => {
                        const dt = datas.data || {};
                        this.testOperationGeneration(dt, true);
                      }).catch(err => {
                        this.isClicked = false;
                        this.showSpinner = false;
                      });
                    }
                  }
                }).catch(err => {
                  this.isClicked = false;
                  this.showSpinner = false;
                });
              } else {
                this.isClicked = false;
                this.showSpinner = false;
                this.error = `Votre groupe de contenant doit comporter au moins un contenant`;
                this.common.openModal(this.modalService, this.msg);
              }
            } else {
              this.isClicked = false;
              this.showSpinner = false;
              // this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article, type de contenant et exutoire)`;
              this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article et type de contenant)`;
              this.common.openModal(this.modalService, this.msg);
            }

          }
        }
      }
    });

  }

  closeModalError() {
    this.common.closeModal();
    if (this.isRetrait) {
      this.isRetrait = false;
      this.closeFunction();
    }
  }

  changeFocusCont(event, i) {
    if ((event.keyCode === 40) && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      this.selectContenant = this.listcontenant[i + 1];
    }
    if ((event.keyCode === 38) && event.target.previousElementSibling) {
      this.selectContenant = this.listcontenant[i - 1];
      event.target.previousElementSibling.focus();
    }
  }

  creationMvt() {
    console.log('Calling creationMvt()');
    console.log(this.newprest);

    const mouv = this.createObjMvt();
    const progm = this.createObjtMvtBennePgm();
    console.log(progm)
    const objEquipe = this.objMvtEquipe();
    // si xMouv alors mouv.listMouvSupp index 1 @ mouvcourant atao anaty mouv
    // listeMouvementsSupplementaires index 4 @ mouvcourant atao anaty mouv
    const tabData = this.createTabData(this.benneChantier);
    const beneData = {
      'nomclass': 'BenneData',
      'infoFact': this.benneChantier['infoFact'],
      'art': this.benneChantier['art'],
      'isGroupeBenne': this.benneChantier['isGroupeBenne'] || false,
      'isGroupeArticle': this.benneChantier['isGroupeArticle'] || false,
      'qteContenant': this.benneChantier['qteContenant'] || 1,
      'listBennes': this.benneChantier['listBennes'] || [],
      'listArticles': this.benneChantier['listArticles'] || [],
      'contrat': this.newprest['numContrat'] ? 'true' : 'false',
      'numContrat': this.newprest['numContrat'] || '',
      'infos': this.newprest['infos'] || '',
      'benneClient': this.benneChantier['benneClient'],
      'mailContenant': this.benneChantier['mailContenant'] || '',
      'dateDebutLoc': this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000',
      // point: 115801
      'typeLocation': this.benneChantier['typeLocation'] || 1,
      'isLocImmediat': this.benneChantier['isLocImmediat'] || false,
      'isLocJour': this.benneChantier['isLocJour'] || false,
      'isTarifLoc': this.benneChantier['isTarifLoc'] || false,
      'tarifLoc': this.benneChantier['tarifLoc'] || 0,
      'nbrRotTarifLoc': this.benneChantier['nbrRotTarifLoc'] || 0,
      'nbrRotGratuite': this.benneChantier['nbrRotGratuite'] || 0,
      'isTarifRot': this.benneChantier['isTarifRot'] || false,
      'tarifRot': this.benneChantier['tarifRot'] || 0,
      'commentairesFact': this.benneChantier['commentairesFact'] || '',
      'modeEquipe': this.newprest['modeEquipe'],
      'qualificationLeader': this.newprest['modeEquipe'] ? this.objEquipe['qualificationLeader'] || { id: 0 } : { id: 0 },
      'leaderEquipe': this.newprest['modeEquipe'] ? this.objEquipe['leaderEquipe'] || { id: 0 } : { id: 0 },
      'listePostes': this.newprest['modeEquipe'] ? objEquipe['listePostes'] || [] : [],
      'equipeDefinie': this.newprest['modeEquipe'] ? (objEquipe['listePostes'].length ? true : false) : false,
      'listePersonnelParPoste': this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPoste'] || [] : [],
      'clefOperationBenneParDefaut': this.defaultSelectedDefaut ? this.defaultSelectedDefaut['id'] || 0 : 0,
      'lieu': {
        'id': '' + (this.newprest['lieu'] ? this.newprest['lieu'].id || 0 : 0)
      },
    };

    if (this.newprest && this.newprest['contenant'] && this.newprest['contenant']['lieu'] && this.newprest['contenant']['lieu'].id) {
      beneData['lieu'] = this.newprest['contenant']['lieu'];
    }

    this.newprest['chantier'] = this.newprest['chantier'] || {};
    this.newprest['chantier'].siteChantier = {
      id: this.common.user[2]
    }

    const param = {
      'servlet': 'DBAjoutMouv',
      'module': 'Ecobennes',
      'type': 'liste',
      'compression': 'false',
      'data': [
        tabData,
        this.benneChantier['listArticles'] || [], // groupe article
        this.benneChantier['listBennes'] || [], // groupe benne
        [], // si xMouv alors mouv.listMouvSupp index 1 @ mouvcourant
        this.newprest['chantier'],
        this.newprest['client'],
        beneData, // benne data
        this.newprest['numBSDD'] || '', // bon.numBSDD
        this.newprest['program'] ? progm : 'null', // mouvementBenneProgramme => objet MouvementBenneProgramme || null
        this.societe['dateDemandeManuel'] ? (this.newprest['dateDemandeManuel'] ? moment(this.newprest['dateDemandeManuel'], 'DD/MM/YYYY').format('YYYY-MM-DD') : '') : '', // mouv.getDateDemandeManuel
        mouv,
        {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        {
          'typeParam': 'boolean',
          'valeur': true
        }
      ]
    };


    return this.common.post('', { param: param }).then(datas => {
      if (datas && datas.messageAfficher) {
        console.log(datas.messageAfficher);
        this.isClicked = false;
        this.showSpinner = false;
        return;
      } else {
        if (this.isCreateWithBtn) {
          const filtre = {
            id: this.newprest['client'].id,
            libelleObjetEntite: this.newprest['client'].libelleObjetEntite,
            table: 'clients'
          };
          this.common.filtreContenant = [];
          this.common.filtreContenant.push(filtre);
        }
        if (this.isDmdEcoGED) {
          this.showalert.emit(datas.data[0][4]);
        } else {
          this.showalert.emit(datas.data[0]);
        }

        this.error = datas.data && datas.data.length  ? datas.data[1] : '';
        if(this.error && this.error.length > 0){
          this.common.openModal(this.modalService, this.msgFormatTrackdechets);
        }  

        this.updateClientChantier();
      }
    });
  }

  focusDate(isLocation, id, benne?) {
    if (isLocation) {
      this.common.focusElement(id);
    }
  }

  verifyIfvalidContenant() {
    if (this.newprest['IsAfficheNewContenant'] && !this.isGroupe) {
      if (this.newBenne['isGroupeArticle'] && (!this.newBenne['listArticle'] || (this.newBenne['listArticle'] && !this.newBenne['listArticle'].length))) {
        return false;
      }
      if (!this.newBenne['isGroupeArticle'] && (!this.newBenne['art'] || !this.newBenne['typeContenant'] ||
        (this.newBenne['art'] && !this.newBenne['art'].id) || (this.newBenne['typeContenant'] && !this.newBenne['typeContenant'].id))) {
        // if (!this.newBenne['typeContenant'] || (this.newBenne['typeContenant'] && !this.newBenne['typeContenant'].id)) {
        //   this.error = `Vous devez sélectionner un type de contenant`;
        //   this.common.openModal(this.modalService, this.msg);
        // }
        return false;
      } else {
        this.newprest['IsAfficheNewContenant'] = !this.newprest['IsAfficheNewContenant']
      }
    } else {
      if (!this.newprest['exutoire'] || (this.newprest['exutoire'] && !this.newprest['exutoire'].id)) {
        $('#autocomplete').focus();
      }
    }

  }

  changeDatePlanning(item, contenant?) {
    if (!contenant) {
      const val = this.newBenne[item];
      console.log(val);
      if (val && typeof val === 'string') {
        const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
        if (type) {
          this.newBenne[item] = this.common.parseDate(val);
          console.log(this.newBenne[item]);
        }
      }
    } else {
      if (contenant) {
        this.newprest[contenant] = this.newprest[contenant] || {};
        const val = this.newprest[contenant][item];
        console.log(val);
        if (val && typeof val === 'string') {
          const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
          if (type) {
            this.newprest[contenant][item] = this.common.parseDate(val);
            console.log(this.newprest[contenant][item]);
          }
        }
      }
    }

  }

  changeDatelocContGrp(item) {
    this.selectedContenantGrp = this.selectedContenantGrp || {};
    const val = this.selectedContenantGrp[item];
    console.log(val);
    if (val && typeof val === 'string') {
      const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
      if (type) {
        this.selectedContenantGrp[item] = this.common.parseDate(val);
        console.log(this.selectedContenantGrp[item]);
      }
    }
  }

  createTabData(mouv) {
    const isAjoutBenne = this.newprest['newContenant'] ? true : false;
    const progm = this.createObjtMvtBennePgm();
    const heure = (this.newprest['hour'] || '');
    console.log(progm)
    // const heure = ((this.newprest['hour'] || '00') + 'h' + (this.newprest['min'] || '00'));
    const duree = this.parseDureeMvt();
    const famille = mouv['typeContenant'] ? (mouv['typeContenant'].famille ? mouv['typeContenant'].famille.id : '') : '0';
    const cubage = mouv['typeContenant'] ? (mouv['typeContenant'].cubage ? mouv['typeContenant'].cubage.id : '') : '0';
    const article = mouv['art'] ? mouv['art'].id : '0';
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const siteCA = this.isShowSite ? (this.newprest['siteCA'] ? this.newprest['siteCA'].id
      : this.common.user[2]) : this.common.user[2];
    const chauff = this.societe['ecobennesEquipe'] ? (this.newprest['modeEquipe'] ?
      this.objEquipe['chauffeur'] || { id: 0 } : { id: 0 }) : (this.objEquipe['chauffeur'] || { id: 0 });
    const typeDmd = this.newprest['typeDemande'] && this.newprest['typeDemande'].id ? this.newprest['typeDemande'].id : "1"
    return [
      'DBAjoutMouv',
      '' + (this.newprest['isImportant'] || false), // mouv.important (checkbox important, boolean)
      'false',
      '' + isAjoutBenne,
      '' + (this.benneChantier['commentairesFact'] || ''), // (bloc facturation->commentaireFact (String))
      '' + typeDmd || '1', // (mouvement.typeDemande (String))
      this.newprest['numContrat'] || '', // (bloc facturation->numContrat (String))
      this.isChoixCamionCreationMouv && this.newprest['camion'] ? '' + (this.newprest['camion'].id || '') : '', // (mouvement.camion.id (String))
      '' + (this.benneChantier['nbrRotTarifLoc'] || 0), // (facturation.getNbrRotTarifLoc)
      '' + (this.benneChantier['isLocJour'] || false), // (isIsLocJour)
      this.newprest['numContrat'] ? 'true' : 'false', // (isContrat) false : valeur taloha
      '' + (this.benneChantier['nbrRotGratuite'] || 0), // getNbrRotGratuite
      '' + (this.benneChantier['tarifRot'] || 0), // getTarifRot
      '' + (this.benneChantier['isTarifRot'] ? 1 : 0), // isIsTarifRot
      '' + this.common.user[0], // user
      '' + (this.newprest['auPlusTard'] || false), // isAuPlusTard
      '' + this.newprest['client'].id, // client
      '' + (this.benneChantier['tarifLoc'] || 0), // getTarifLoc
      '' + (this.benneChantier['isTarifLoc'] || false), // isIsTarifLoc
      '' + (this.benneChantier['isLocImmediat'] || false), // isIsLocImmediat
      '' + (this.newprest['lieu'] ? this.newprest['lieu'].id || 0 : 0), // benne.getLieu().getId()
      '' + (this.benneChantier['typeLocation'] || 1), // benne.getTypeLocation()
      this.newprest['infoNextMouv'] || '', // Info. mouv panel.getInfosMouv();
      this.newprest['infoFact'] || '', // Information Sup. (String) ##### Info. mouv panel.getInfosMouv();
      duree || '0', // duree
      moment().format('YYYY-MM-DD'),
      moment().format('HH:mm:ss'),
      moment(this.newprest['dateStart']).format('YYYY-MM-DD'),
      heure || '', //  (Heure (String))
      this.newprest['acompte'] || '0', // montant : acompte
      '0',
      '' + (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0'), // 31
      this.newprest['infos'] || '', // panel.getInfos : info supp
      '' + (this.newprest['typeOperation'] ? (this.newprest['typeOperation'].id || 0) : (this.defaultSelected ? (this.defaultSelected.id || 0) : '0')), // mouvement.operation ('2' par défaut (String))
      this.benneChantier['isGroupeArticle'] ? '1' : '0',  // index 34
      mouv.isGroupeBenne ? '1' : '0', // index 35
      '' + (this.newprest['program'] ? true : false), // isProgram (si programation)
      '' + (this.newprest['chantier'].id || 0),
      '' + famille,
      '' + cubage,
      '' + article,
      '' + sitePrest, // getClefSitePrest
      '' + siteCA, // getClefSiteCA
      '' + (mouv.isLocation || false), // isLocation // 43
      // this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000', // date debut loc
      this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('YYYY-MM-DD') : '2000-01-01', // date debut loc // point : 116778
      '' + (this.newprest['contratChamp'] ? (this.newprest['contratChamp'].id || 0) : 0), // (mouv.getContrat().getId() (String))
      'false', // mouv.isReceptionChantier
      '2000-01-01',
      '',
      '0', // mouv.getCamionChantier().getClef()
      '0', // mouv.getChauffeurChantier().getClef()
      '0', // mouv.getPositionPlanningChantier()
      this.newprest['numBonManuel'] || '', // mouv.getBon().getNumBonManuel()
      '' + chauff.id, // mouv.getClefChauffeur()
      this.isChoixCamionCreationMouv && this.newprest['periode'] ? '' + (this.newprest['periode'].id || '0') : '', // '0', // mouv.getPeriode().getId()
      this.societe['gestionDateMax'] ? moment(this.newprest['dateMaxStart']).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'), // date aujourd'hui (String) 55
      '' + (this.newprest['program'] ? progm['typeOperation'] : ''), // type prog si progm || ''
      '' + (this.newprest['program'] ? progm['frequence'] : ''), // frequence
      '0',
      '0',
      '0',
      '0'
    ];
  }

  modifContenant() {
    if (this.newprest['newBenne']) {
      this.isEditContenant = !this.isEditContenant;
      setTimeout(function () {
        $('.combo').click();
      }, 550);
    }
    if (this.newprest['contenant']) {
      if (!this.newprest['contenant'].isGroupeBenne) {
        this.isEditContenant = !this.isEditContenant;
        setTimeout(function () {
          $('.combo').click();
        }, 550);
      } else {
        if (this.isCreateWithBtn) {
          this.modifierGroupe = !this.modifierGroupe;
        }
      }
    }
  }

  compare(arr1, arr2) {
    const arr = [...arr1, ...arr2]

    return arr.shift().filter(y =>
      arr.every(x => x.some(j => j.Id === y.Id))
    )
  }

  updateClientChantier(notLog?) {
    if (!this.editContenant) {
      if (!notLog && this.newprest) {
        this.common.createLog('108', this.newprest['chantier'] ? this.newprest['chantier'].id : 0, false)
          .catch(err => this.showSpinner = false);
      }
      this.closeFunction();
    } else {
      const clt = this.newprest['client'] ? this.newprest['client'].id : 0;
      const cht = this.newprest['chantier'] ? this.newprest['chantier'].id : 0
      const idbenne = this.newprest['contenant'] ? this.newprest['contenant'].id : 0;
      const operation = [];
      operation.push(...this.listOperationBenne, ...this.listOperationNew);
      operation.forEach(elt => {
        if (elt.id === parseInt(this.info['typeOperation'], 10)) {
          if (!elt.operationSurBenneEnPlace && (elt.id !== 2 && elt.id !== 1)) {
            this.operationBenneEnPlaceFalse = true;
          } else {
            this.operationBenneEnPlaceFalse = false;
          }
        }
      });

      console.log(' this.operationBenneEnPlaceFalse', this.operationBenneEnPlaceFalse)
      this.getDetailBenneMouv(clt, cht, idbenne).then(benneData => {
        const client = benneData ? benneData[0] : {};
        const chantier = client.listChantier.length ? client.listChantier[0] : {};
        const benne = chantier.listBenne && chantier.listBenne.length ? chantier.listBenne[0] : false;
        const listBon = benne.listBon || [];
        let selectBon;
        this.info['listBon'] = benne.listBon || [];
        listBon.forEach(elt => {
          if (elt.numBon === this.numBon) {
            selectBon = elt;
          }
        });

        if (selectBon) {
          this.showDeleteGroupBtn = false;
          this.modifBenne(selectBon);
        }
      })
    }
  }

  getDetailContenant(benne, bon) {
    const idBon = bon ? bon.id : 0;
    const clefProgram = parseInt(benne.clefProgram, 10);
    const externe = benne.benneData ? (benne.benneData.clefBenneChantiersD0 > 0 || benne.benneData.contenantPerdu ? true : false) : false;
    const param = {
      'servlet': 'DBGetMouvCourant',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_BENNE_CHANTIERS': {
          'typeParam': 'int',
          'valeur': benne.id // index 3
        },
        'SITE': '' + this.common.user[2],
        'IS_PROGRAMME': {
          'typeParam': 'boolean',
          'valeur': clefProgram > 0 ? true : false
        },
        'CLEF_BON': {
          'typeParam': 'int',
          'valeur': idBon // index 4
        },
        'IS_EXTERNE': {
          'typeParam': 'boolean',
          'valeur': externe
        },
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas.data;
      }
    });
  }

  modifBenne(bon) {
    this.addContenant = false;
    this.editContenant = false;
    this.isHisto = false;
    this.isDmdEcoGED = false;
    this.isHistoMvt = false;
    this.showLeft = false;
    this.showEditBtn = false;
    const benne = this.benneChantier;
    this.info['bonSelected'] = Object.assign({}, bon);
    console.log(this.info['bonSelected'])
    this.isGroupe = benne && benne['isGroupeBenne'] ? true : false;
    // this.getDetail(bon.id).then(dt => console.log(dt));

    this.edit = true;
    this.getDetailContenant(benne, bon).then(dt => {
      this.info['mouvCourant'] = dt;
      this.info['mouvPrincipal'] = dt[0];

      // Demande Eli 10/06/2020
      if (!benne['clefProgram']) {
        dt[4].forEach(mvt => {
          if ('' + mvt.id === dt[0][0]) {
            this.info['bon'] = Object.assign({}, mvt.bon);
            this.info['mouvPrincipalObj'] = mvt || { id: 0 };
          }
        });
      } else {
        const mvt = dt[3];
        this.info['bon'] = Object.assign({}, mvt.bon);
        this.info['mouvPrincipalObj'] = mvt || { id: 0 };
        this.listeMouvSupp = [];
      }


      if (dt[1].length <= 1) {
        const elt = dt[0];
        console.log('mouv princ');
        this.info['bon'] = this.info['bon'] || {};
        this.info['heure'] = elt[4];
        this.info['acompte'] = elt[5];
        this.info['numBonManuel'] = elt[36];
        this.info['numBSDD'] = elt[24];
        this.info['numScelle'] = elt[42];
        this.info['typeOperation'] = elt[11];
        this.info['important'] = elt[23];
        this.info['contrat'] = benne['contrat'] || false;
        this.info['numContrat'] = benne['numContrat'] || '';
        this.info['infos'] = benne['infos'];
        this.info['date'] = this.common.parseDate(moment(elt[3] || '2000-01-01', 'YYYY-MM-DD').format('DD/MM/YYYY'));
        ;
        this.info['infoNextMouv'] = elt[10];
        this.info['infoFact'] = elt[28];
        this.info['sitePrest'] = elt[14];
        this.info['duree'] = elt[18];
        this.info['exutoire'] = this.newprest['exutoire'];
        if (benne['clefProgram'] && (benne['clefProgram'] !== '0' || benne['clefProgram'] !== 0)) {
          this.getMouvProgram(benne['clefProgram']).then(pgm => {
            this.info['mouvBenneProgramme'] = pgm[2];
            this.detectIfAdd();
          }).catch(err => this.showSpinner = false);
        } else {
          this.detectIfAdd();
        }
      } else {
        let elt;
        const test = dt[1].filter(elem => parseInt(elem[5], 10) === bon.id);
        console.log(test)

        if (test.length) {
          elt = test[0];
          if (elt) {
            console.log('mouv supp')
            this.info['heure'] = elt[1];
            this.info['infoNextMouv'] = elt[11];
            this.info['infoFact'] = elt[19];
            this.info['acompte'] = elt[18];
            this.info['numBonManuel'] = elt[29];
            this.info['numBSDD'] = elt[20];
            this.info['numScelle'] = elt[34];
            this.info['typeOperation'] = elt[2];
            this.info['important'] = elt[12];
            this.info['date'] = this.common.parseDate(moment(elt[0] || '2000-01-01', 'YYYY-MM-DD').format('DD/MM/YYYY'));
            ;
            this.info['contrat'] = benne['contrat'] || false;
            this.info['numContrat'] = benne['numContrat'] || '';
            this.info['infos'] = benne['infos'];
            this.info['sitePrest'] = elt[10];
            this.info['duree'] = elt[15];
            this.info['exutoire'] = this.newprest['exutoire'];
            if (benne['clefProgram'] && (benne['clefProgram'] !== '0' || benne['clefProgram'] !== 0)) {
              this.getMouvProgram(benne['clefProgram']).then(pgm => {
                this.info['mouvBenneProgramme'] = pgm[2];
                this.detectIfAdd();
              }).catch(err => this.showSpinner = false);
            } else {
              this.detectIfAdd();
            }
          }
        } else {
          elt = dt[0];

          if (bon && parseInt(elt[16], 10) === bon.id) {
            console.log('mouv princ');
            this.info['bon'] = this.info['bon'] || {};
            this.info['heure'] = elt[4];
            this.info['acompte'] = elt[5];
            this.info['numBonManuel'] = elt[36];
            this.info['numBSDD'] = elt[24];
            this.info['numScelle'] = elt[42];
            this.info['typeOperation'] = elt[11];
            this.info['important'] = elt[23];
            this.info['contrat'] = benne['contrat'] || false;
            this.info['numContrat'] = benne['numContrat'] || '';
            this.info['infos'] = benne['infos'];
            this.info['date'] = this.common.parseDate(moment(elt[3] || '2000-01-01', 'YYYY-MM-DD').format('DD/MM/YYYY'));
            ;
            this.info['infoNextMouv'] = elt[10];
            this.info['infoFact'] = elt[28];
            this.info['sitePrest'] = elt[14];
            this.info['duree'] = elt[18];
            this.info['exutoire'] = this.newprest['exutoire'];
            if (benne['clefProgram'] && (benne['clefProgram'] !== '0' || benne['clefProgram'] !== 0)) {
              this.getMouvProgram(benne['clefProgram']).then(pgm => {
                this.info['mouvBenneProgramme'] = pgm[2];
                this.detectIfAdd();
              }).catch(err => this.showSpinner = false);
            } else {
              this.detectIfAdd();
            }
          }
        }
      }
    }).catch(err => this.showSpinner = false);
  }

  getMouvProgram(clefPgm) {
    const param = {
      'servlet': 'DBGetMouvProgram',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetMouvProgram', '' + clefPgm]
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        return datas.data;
      }
    });
  }

  async getDetailBenneMouv(clt, chant, benne) {
    const param = {
      'servlet': 'DBRechercheClient',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'true',
      'data': ['DBRechercheClient', '' + clt, '' + (chant || ''), '' + benne, '' + this.common.user[2]]
    };
    return await this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return (datas.data);
      }
    });
  }

  /**
   * FenetreAjout.java -> getDataBenneChantier(boolean addInfoNextMouv)
   */
  updateBenneChantier(isEdit?) {
    console.log('Calling updateBenneChantier()');
    console.log(this.newprest);

    let tabUpdateBenneChantier;
    this.newprest['client'] = this.newprest['client'] || { id: '0' }; // debug !client
    this.newprest['client'].nomclass = 'Client';
    this.newprest['chantier'] = this.newprest['chantier'] || { id: '0' };
    this.newprest['chantier'].nomclass = 'Chantier';
    const mouvement = this.createObjMvt();
    this.changeDatePlanning('dateDebutLoc', 'contenant');
    if (this.benneChantier['listBennes'] && this.benneChantier['listBennes'].length) {
      this.benneChantier['listBennes'].forEach(elt => {
        elt.nomclass = 'BenneData';
      });
    }

    if (!this.newprest['contenant'].isLocation) {
      this.revertLocation();
    }

    if (this.benneChantier['typeContenant'] && this.benneChantier['typeContenant'].isUnitaire) {
      this.benneChantier['qteContenant'] = 1;
    }

    const progm = this.createObjtMvtBennePgm();
    mouvement['clefProgram'] = '' + (progm['id'] || 0);
    const famille = this.benneChantier['typeContenant'] ? (this.benneChantier['typeContenant'].famille ?
      this.benneChantier['typeContenant'].famille.id : '') : '0';
    const cubage = this.benneChantier['typeContenant'] ? (this.benneChantier['typeContenant'].cubage ?
      this.benneChantier['typeContenant'].cubage.id : '') : '0';
    const article = this.benneChantier['art'] ? '' + this.benneChantier['art'].id : '0';
    tabUpdateBenneChantier = [
      'DBUpdateBenneChantier',
      '' + cubage,
      '' + famille,
      '' + this.common.user[0],
      article,
      '' + (this.benneChantier['id'] || 0),
      '1',
      '0',
      '' + (this.newprest['program'] ? true : false), // true si program checked || false
      this.benneChantier['isGroupeArticle'] ? '1' : '0',
      this.benneChantier['isGroupeBenne'] ? '1' : '0',
      '' + this.newprest['chantier'].id,
      this.newprest['infos'] || '', // tabUpdateBenneChantier[12]
      '' + (this.newprest['contenant'].isLocation || false), // isLocation  // tabUpdateBenneChantier[13]
      this.newprest['contenant'].dateDebutLoc ? moment(this.newprest['contenant'].dateDebutLoc).format('YYYY-MM-DD') : '2000-01-01', // date debut loc, tabUpdateBenneChantier[14]
      '0',
      '0',
      '0',
      '0'
    ];

    const objEquipe = this.objMvtEquipe();
    const beneData = {
      'id': this.benneChantier['id'],
      'nomclass': 'BenneData',
      'infoFact': this.benneChantier['infoFact'],
      'art': this.benneChantier['art'],
      'isGroupeBenne': this.benneChantier['isGroupeBenne'] || false,
      'isGroupeArticle': this.benneChantier['isGroupeArticle'] || false,
      'listBennes': this.benneChantier['listBennes'] || [],
      'listArticles': this.benneChantier['listArticles'] || [],
      'contrat': this.newprest['numContrat'] ? 'true' : 'false',
      'numContrat': this.newprest['numContrat'] || '',
      'infos': this.newprest['infosbenneChantiers'] || '',
      'dateDebutLoc': this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000',
      'typeLocation': this.benneChantier['typeLocation'] || 1,
      'isLocImmediat': this.benneChantier['isLocImmediat'] || false,
      'isLocJour': this.benneChantier['isLocJour'] || false,
      'isTarifLoc': this.benneChantier['isTarifLoc'] || false,
      'tarifLoc': this.benneChantier['tarifLoc'] || 0,
      'nbrRotTarifLoc': this.benneChantier['nbrRotTarifLoc'] || 0,
      'nbrRotGratuite': this.benneChantier['nbrRotGratuite'] || 0,
      'isTarifRot': this.benneChantier['isTarifRot'] || false,
      'tarifRot': this.benneChantier['tarifRot'] || 0,
      'commentairesFact': this.benneChantier['commentairesFact'] || '',
      'qteContenant': this.benneChantier['qteContenant'] || 1,
      'benneClient': this.benneChantier['benneClient'],
      'mailContenant': this.benneChantier['mailContenant'] || '',
      'clefChantier': this.newprest['chantier'] ? (this.newprest['chantier'].id || 0) : 0,
      'modeEquipe': this.newprest['modeEquipe'],
      'qualificationLeader': this.newprest['modeEquipe'] ? this.objEquipe['qualificationLeader'] || { id: 0 } : { id: 0 },
      'leaderEquipe': this.newprest['modeEquipe'] ? this.objEquipe['leaderEquipe'] || { id: 0 } : { id: 0 },
      'listePostes': this.newprest['modeEquipe'] ? objEquipe['listePostes'] || [] : [],
      'equipeDefinie': this.newprest['modeEquipe'] ? (objEquipe['listePostes'].length ? true : false) : false,
      'listePersonnelParPoste': this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPoste'] || [] : [],
      'clefOperationBenneParDefaut': this.defaultSelectedDefaut ? this.defaultSelectedDefaut['id'] || 0 : 0,
      'lieu': {
        'id': '' + (this.newprest['lieu'] ? this.newprest['lieu'].id || 0 : 0)
      },
    };

    if (this.newprest && this.newprest['contenant'] && this.newprest['contenant']['lieu'] && this.newprest['contenant']['lieu'].id && !this.isModifierLeContenant) {
      beneData['lieu'] = this.newprest['contenant']['lieu'];
    }

    const param = {
      'servlet': 'DBUpdateBenneChantier',
      'module': 'Ecobennes',
      'type': 'liste',
      'compression': 'true',
      'data': [
        tabUpdateBenneChantier,
        this.benneChantier['listArticles'] || [], // groupe article
        this.benneChantier['listBennes'] || [],
        this.newprest['chantier'],
        this.newprest['client'],
        mouvement, // mouvement
        beneData, // benne.getBenneData()
        {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        this.newprest['program'] ? progm : 'null', // this.newprest['program'] ? MouvementBenneProgramme : 'null'
        // 'false'
        {
          'typeParam': 'boolean',
          'valeur': false
        }
      ]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (!isEdit) {
        if (!this.info['mouvCourant']) {
          this.createMouv(datas);
        } else {
          this.updateMouv(datas);
        }
      } else {
        return datas;
      }
    }).catch(err => {
      this.isClicked = false;
      this.showSpinner = false;
      return { "message": err };
    });
  }

  revertLocation() {
    this.benneChantier['typeLocation'] = 0;
    this.benneChantier['isLocJour'] = false;

    this.benneChantier['isLocImmediat'] = false;
    this.benneChantier['isTarifLoc'] = false;
    this.benneChantier['tarifLoc'] = 0;
    this.benneChantier['nbrRotTarifLoc'] = 0;
    this.benneChantier['isTarifRot'] = false;
    this.benneChantier['tarifRot'] = 0;
    this.benneChantier['nbrRotGratuite'] = 0;
    this.benneChantier['commentairesFact'] = '';
  }

  createMouv(data?) {

    const mouvement = this.createObjMvt(data);
    mouvement['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
    mouvement['listeMouvementsSupplementaires'] = mouvement['listeMouvementsSupplementaires'] || [];
    mouvement['pourcentageRemplissageDemande'] = this.info['pourcentageRemplissageDemande'] || 0
    mouvement['listeMouvementsSupplementaires'].forEach(elt => {
      elt.listeClesBennesDuGroupe = data ? (data.data || []) : [];
    });
    mouvement['operation'] = mouvement['operation'] !== '0' ? mouvement['operation'] : '2';
    mouvement['user'] = '' + this.common.user[0];
    const param = {
      'servlet': 'DBCreationMouv',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [
        ['DBCreationMouv'],
        mouvement,
        {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        }
      ]
    };
    return this.common.post('', { param: param }).then(datas => {
      if (!datas.message) {
        if (this.isDmdEcoGED) {
          this.showalert.emit(datas.data);
        }
        this.numBon = datas.data ? datas.data[2] : 0;
        this.error = datas.data ? datas.data[1] : '';
        if(this.error && this.error.length > 0){
          this.common.openModal(this.modalService, this.msgFormatTrackdechets);
        }  
        this.updateClientChantier();
      } else {
        this.isClicked = false;
        this.showSpinner = false;
        this.error = datas.message;
        this.common.openModal(this.modalService, this.msgFormat);
      }

    }).catch(err => {
      this.isClicked = false;
      this.showSpinner = false;
    });
  }

  updateMouv(data?, isTournee?) { // update Mouvement
    const mouvement = this.createObjMvt(data);
    mouvement['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
    mouvement['listeMouvementsSupplementaires'] = mouvement['listeMouvementsSupplementaires'] || [];
    mouvement['listeMouvementsSupplementaires'].forEach(elt => {
      elt.listeClesBennesDuGroupe = data ? (data.data || []) : [];
    });
    mouvement['bon'] = this.info['bon'];

    mouvement['bon'].numBonManuel = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][36] : (this.newprest['numBonManuel'] || '');
    mouvement['bon'].numBSDD = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][24] : this.newprest['numBSDD'] || '';
    mouvement['bon'].numScelle = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][42] : this.newprest['numScelle'] || '';
    mouvement['facturation'] = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][5] : this.newprest['acompte'] || '0';
    mouvement['bon']['axeAnalytiqueLigneArticle'] = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][39] :
      (!this.benneChantier['isGroupeArticle'] ? (this.benneChantier['axeAnalytiqueLigneArt'] || '') : '');
    mouvement['bon']['axeAnalytiqueLignePrestation'] = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][40] :
      (this.benneChantier['axeAnalytiqueLigne'] || '');
    mouvement['bon']['lignePrestationContrat'] = { id: this.newprest['prestation'] ? (this.newprest['prestation'].id || 0) : 0 };
    mouvement['user'] = '' + this.common.user[0];
    if (isTournee) {
      mouvement['tournee'] = this.newprest['tournee'];
    }

    if (!this.isChoixCamionCreationMouv || (this.isChoixCamionCreationMouv && (!mouvement['camion']) || !mouvement['camion'].id)) {
      const camion = (this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][20] : '0')
      // debug 114733
      mouvement['camion'] = camion ? { id: camion || 0 } : { id: 0 }
    }


    const user = this.common.local.getObject('userDetail').nom;

    const param = {
      'servlet': 'DBUpdateMouv',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        MOUVEMENT: mouvement,
        NOM_USER: '' + user,
        MOUV_PROGRAMME: {
          'typeParam': 'boolean',
          'valeur': this.updateAll // false // si oui || false
        },
        USER: {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        SITE: {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        CLEF_BON: {
          'typeParam': 'int',
          'valeur': this.info['bonSelected'] ? (this.info['bonSelected'].id || 0) : 0
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (!datas.message) {
        this.numBon = datas.data && datas.data.length && datas.data[1] ? datas.data[1] : 0;
        this.updateClientChantier();
        this.error = datas?.data[2]?.retourTrackDechet || '';
        if(this.error && this.error.length > 0){
          this.common.openModal(this.modalService, this.msgFormatTrackdechets);
        }  
      } else {
        this.isClicked = false;
        this.showSpinner = false;
        this.error = datas.message;
        this.common.openModal(this.modalService, this.msgFormat);
      }
    }).catch(err => {
      this.isClicked = false;
      this.showSpinner = false;
    });
  }

  modifContentMvt() {
    this.info['mouvCourant'][1] = this.info['mouvCourant'][1].filter(elt => elt[4] !== this.info['mouvPrincipal'][0]);
    this.info['mouvCourant'][4] = this.info['mouvCourant'][4].filter(elt => elt.id !== parseInt(this.info['mouvPrincipal'][0], 10));
    this.isExisteMouvSupp = this.info['mouvCourant'][1] && this.info['mouvCourant'][1].length > 0 ? true : false;
    this.info['mouvCourant'][1].forEach((elt, index) => {
      let mouv;

      this.info['mouvCourant'][4].forEach(mvt => {
        if ('' + mvt.id === elt[4]) {
          mouv = mvt;
        }
      });
      const datemax = mouv && mouv['dateMax'] ? moment(mouv['dateMax'], 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD') : '2000-01-01';

      this.listeMouvSupp[index] = [
        elt[0], // date
        elt[1], // heure
        elt[2], // operation
        elt[3], // chauffeur
        elt[4], // clef mvt
        elt[5], // clef bon
        elt[6], // numbon
        elt[7] === '0' ? 'false' : 'true', // au plustard
        elt[8], // date dmd => date de jour
        elt[9], // exutoire => exutoire existant
        elt[10], // site prest
        elt[11], // info mvt
        '' + (elt[12] === '1' ? true : false), // '' + this.newprest['isImportant'],  // important => false
        elt[13], // hors pgm  => true
        elt[14], // contrat => ''
        elt[15], // durée => ''
        elt[16], // site CA => site encours
        elt[17], // type dmd => type dmd existant
        elt[18], // acompte
        elt[19], // info fact
        elt[20], // bsdd
        elt[21], // clef camion => 0
        elt[22], // reception chantier => 'false'
        elt[23], // date reception chantier => 2000-01.01
        elt[24], // heure reception chantier => ''
        elt[25], // clef camion chantier => '0'
        elt[26], // clef chauffeur chantier => '0'
        elt[27], // position planning chantier => '0'
        elt[29], // bon manuel index 28
        elt[30], // periode index 29 => '0'
        datemax, // date max => cf movtcourant index 4 mvt.dateMax : yyyy-mm-dd index 30 => date mvt
        mouv ? mouv['bon'].axeAnalytiqueLignePrestation || '' : '', // axeAnalytiqueLignePrestation => ''
        mouv ? mouv['bon'].axeAnalytiqueLigneArticle || '' : '', // axeAnalytiqueLigneArticle => ''
        elt[34], // numScelle
      ];

      mouv['dateEnlevement'] = elt[0];
      mouv['heure'] = elt[1];
      mouv['operation'] = elt[2];
      mouv['chauffeur'] = mouv['chauffeur'] || {
        'id': elt[3]
      };
      mouv['bon'].numBSDD = elt[20];
      mouv['bon'].numBonManuel = elt[29];
      mouv['bon'].numScelle = elt[34] || '';
      mouv['auPlusTard'] = elt[7] === '0' ? false : true;
      mouv['dateDemande'] = elt[8];
      mouv['exutoire'] = {
        id: elt[9]
      };
      mouv['siteExploitation'] = {
        id: elt[10]
      };
      mouv['infoSupp'] = elt[11];
      mouv['important'] = elt[12] === '1' ? true : false; // this.newprest['isImportant'];
      mouv['horsProgram'] = elt[13] === '0' || elt[13] === 'false' ? false : true;
      mouv['contrat'] = {
        id: elt[14]
      };
      mouv['duree'] = elt[15];
      mouv['clefSiteCA'] = elt[16];
      mouv['typeDemande'] = {
        id: elt[17]
      };
      mouv['facturation'] = mouv['isFact'] ? elt[18] : '0.00';
      mouv['infoFact'] = elt[19];
      mouv['camion'] = mouv['camion'] || {
        id: elt[21]
      };

      mouv['receptionChantier'] = elt[22] === '0' || elt[22] === 'false' ? false : true;
      mouv['dateReception'] = elt[22] === '0' || elt[22] === 'false' ? '2000-01-01' : elt[23];
      mouv['heureReception'] = elt[22] === '0' || elt[22] === 'false' ? '' : elt[24];
      mouv['camionChantier'] = {
        id: elt[25]
      };
      mouv['chauffeurChantier'] = {
        id: elt[26]
      };
      mouv['positionPlanningChantier'] = elt[27];
      mouv['listeClesBennesDuGroupe'] = mouv['listeClesBennesDuGroupe'] || [];
      mouv['articleMouv'] = mouv['articleMouv'] || { id: 0 };
    });

  }

  updateListeMvt(data?) {
    const heure = this.hourMvt();
    const duree = this.parseDureeMvt();
    const objEquipe = this.objMvtEquipe();
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const siteCA = this.isShowSite ? (this.newprest['siteCA'] ? this.newprest['siteCA'].id
      : this.common.user[2]) : this.common.user[2];
    const chauff = this.societe['ecobennesEquipe'] ? (this.newprest['modeEquipe'] ?
      this.objEquipe['chauffeur'] || { id: 0 } : { id: 0 }) : (this.objEquipe['chauffeur'] || { id: 0 });
    // this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0';
    if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
      if (this.edit) {
        if (parseInt(this.info['bonSelected'].id, 10) === parseInt(this.info['mouvPrincipal'][16], 10)) {
          this.info['mouvPrincipal'][4] = heure;
          this.info['mouvPrincipal'][5] = '' + (this.newprest['acompte'] || '');
          if (this.societe['gestionDateMax']) {
            this.info['mouvPrincipalObj'].dateMax = moment(this.newprest['dateMaxStart']).format('DD/MM/YYYY HH:mm:ss');
          }
          this.info['mouvPrincipal'][3] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
          if (this.societe['ecobennesEquipe'] && this.newprest['modeEquipe'] && this.objEquipe['chauffeur'] &&
            this.objEquipe['chauffeur'].id !== parseInt(this.info['mouvPrincipal'][7], 10)) {
            this.info['mouvPrincipal'][7] = '' + (chauff.id);
          }

          this.info['mouvPrincipal'][11] = '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '');
          this.info['mouvPrincipal'][28] = (this.newprest['infoFact'] || '');
          this.info['mouvPrincipal'][10] = (this.newprest['infoNextMouv'] || '');
          this.info['mouvPrincipal'][36] = (this.newprest['numBonManuel'] || '');
          this.info['mouvPrincipal'][23] = this.newprest['isImportant'] ? '1' : '0';
          this.info['mouvPrincipal'][24] = (this.newprest['numBSDD'] || '');
          this.info['mouvPrincipal'][42] = (this.newprest['numScelle'] || '');
          this.info['mouvPrincipal'][14] = '' + sitePrest;
          this.info['mouvPrincipal'][15] = '' + siteCA;
          this.info['mouvPrincipal'][18] = this.parseDureeMvt();
          this.info['mouvPrincipal'][19] = this.newprest['auPlusTard'] || false;
          this.info['mouvPrincipal'][20] = (this.newprest['camion'] ? (this.newprest['camion'].id || 0) : 0);
          this.info['mouvPrincipal'][21] = (this.newprest['typeDemande'] ? this.newprest['typeDemande'].id : 1);
          this.info['mouvPrincipal'][37] = (this.newprest['periode'] ? (this.newprest['periode'].id || 0) : 0);
          this.info['mouvPrincipal'][39] = (!this.benneChantier['isGroupeArticle'] ? this.benneChantier['axeAnalytiqueLigneArt'] : '');
          this.info['mouvPrincipal'][40] = this.benneChantier['axeAnalytiqueLigne'];
          this.info['mouvPrincipalObj'].qtePrevisionnelle = this.benneChantier['qte'] || 0;

          this.info['mouvPrincipal'][13] = ('' + (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0'))
          this.info['mouvPrincipalObj']['listeNumBSDDParBenne'] = this.newprest['listeNumBSDDParBenne'] || [];
          this.info['mouvPrincipalObj']['listeNumScelleParBenne'] = this.newprest['listeNumScelleParBenne'] || [];
          this.info['mouvPrincipalObj']['listeOperationParBenneDuGroupe'] = this.newprest['listeOperationParBenneDuGroupe'] || [];
          let idart = 0
          if (!this.benneChantier['isGroupeBenne'] && !this.benneChantier['isGroupeArticle']) {
            idart = this.benneChantier['art'] && this.benneChantier['art'].id ? this.benneChantier['art'].id : 0
          }

          this.info['mouvPrincipalObj'].articleMouv = idart ? { id: idart } : { id: 0 };
          console.log('Mouv principal', this.info['mouvPrincipal']);
        } else {
          let chaufId = 0;
          this.listeMouvSupp.forEach(elt => {
            if (this.info['bonSelected'] && (elt[5] === '' + this.info['bonSelected'].id)) {
              elt[1] = heure;
              if (this.societe['ecobennesEquipe'] && this.newprest['modeEquipe'] && this.objEquipe['chauffeur'] &&
                this.objEquipe['chauffeur'].id !== parseInt(elt[3], 10)) {
                elt[3] = '' + (chauff.id);
              }
              // elt[3] = '' + (chauff.id);

              chaufId = elt[3];
              elt[18] = '' + (this.newprest['acompte'] || '0.00');
              elt[0] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
              elt[2] = '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0');
              elt[19] = (this.newprest['infoFact'] || '');
              elt[11] = (this.newprest['infoNextMouv'] || '');
              elt[28] = (this.newprest['numBonManuel'] || '');
              elt[9] = '' + (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0);
              elt[20] = (this.newprest['numBSDD'] || '');
              elt[33] = (this.newprest['numScelle'] || '');
              elt[12] = '' + this.newprest['isImportant'];
              elt[10] = '' + sitePrest;
              elt[16] = '' + siteCA;
              elt[7] = '' + this.newprest['auPlusTard'] || false;
              elt[15] = this.parseDureeMvt();
              elt[21] = '' + (this.newprest['camion'] ? this.newprest['camion'].id : 0);
              elt[31] = this.benneChantier['axeAnalytiqueLigne'];
              elt[32] = (!this.benneChantier['isGroupeArticle'] ? this.benneChantier['axeAnalytiqueLigneArt'] : '');
              if (this.societe['gestionDateMax']) {
                elt[30] = moment(this.newprest['dateMaxStart']).format('YYYY-MM-DD');
              }
              // elt[29] = '' + (this.newprest['periode'] ? this.newprest['periode'].id : 0);
              console.log('Edit mouv', elt);
            }
          });

          console.log('chaufId', chaufId);
          this.info['mouvCourant'][4].forEach(mouv => {
            mouv['camionRemorque'] = Object.assign({}, mouv['camionRemorque'] || { id: 0 });
            if (mouv.bon.id === this.info['bonSelected'].id) {
              mouv['dateEnlevement'] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
              if (this.societe['gestionDateMax']) {
                mouv['dateMax'] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
              }
              mouv['heure'] = heure;
              mouv['operation'] = this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0';
              mouv['bon'].numBSDD = this.newprest['numBSDD'] || '';
              mouv['bon'].numScelle = this.newprest['numScelle'] || '';
              mouv['bon'].numBonManuel = this.newprest['numBonManuel'] || '';
              mouv['bon'].axeAnalytiqueLigneArticle = (!this.benneChantier['isGroupeArticle'] ?
                this.benneChantier['axeAnalytiqueLigneArt'] : '');
              mouv['bon'].axeAnalytiqueLignePrestation = this.benneChantier['axeAnalytiqueLigne'];
              mouv['exutoire'] = {
                id: (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0)
              };
              mouv['bonRemorque'] = {
                id: mouv['bonRemorque'] ? mouv['bonRemorque'].id : 0
              }
              mouv['positionRemorque'] = mouv['positionRemorque'] || 0;
              mouv['important'] = this.newprest['isImportant'];
              mouv['infoSupp'] = this.newprest['infoNextMouv'] || '';
              mouv['facturation'] = this.newprest['acompte'] ? parseFloat(this.newprest['acompte']).toFixed(2) : '0.00';
              mouv['infoFact'] = this.newprest['infoFact'] || '';
              /****todo */
              mouv['clefSitePrest'] = sitePrest;
              mouv['clefSiteCA'] = siteCA;
              mouv['clefChauffeur'] = (chaufId || 0);
              mouv['chauffeur'] = { id: chaufId || 0 };
              mouv['camion'] = this.newprest['camion'] || { id: 0 };
              mouv['periode'] = this.newprest['periode'] || { id: 0 };
              mouv['listePersonnelParPoste'] = this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPosteMvt'] || [] : [];
              mouv['auPlusTard'] = this.newprest['auPlusTard'] || false;
              mouv['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
              mouv['listeNumBSDDParBenne'] = this.newprest['listeNumBSDDParBenne'] || [];
              mouv['listeNumScelleParBenne'] = this.newprest['listeNumScelleParBenne'] || [];
              mouv['listeOperationParBenneDuGroupe'] = this.newprest['listeOperationParBenneDuGroupe'] || [];
              mouv['qtePrevisionnelle'] = this.benneChantier['qte'] || 0;
              let idart = 0
              if (!this.benneChantier['isGroupeBenne'] && !this.benneChantier['isGroupeArticle']) {
                idart = this.benneChantier['art'] && this.benneChantier['art'].id ? this.benneChantier['art'].id : 0
              }

              mouv['articleMouv'] = idart ? { id: idart } : { id: 0 };
            }
            mouv['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
          });
        }
      } else {

        let typedmd = '1';
        if (this.info['mouvPrincipalObj']) {
          typedmd = this.info['mouvPrincipalObj'].typeDemande ? this.info['mouvPrincipalObj'].typeDemande.id : 1;
        }
        const mouvSupp = [
          moment(this.newprest['dateStart']).format('YYYY-MM-DD'), // date
          heure || '', // heure
          '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'), // operation
          '' + (chauff.id), // chauffeur
          '0', // clef mvt
          '0', // clef bon
          '0', // numbon
          '' + (this.newprest['auPlusTard'] || false), // au plustard
          moment().format('YYYY-MM-DD'), // date dmd => date de jour
          '' + (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0), // exutoire => exutoire existant
          '' + sitePrest, // site
          this.newprest['infoNextMouv'] || '', // info mvt
          '' + this.newprest['isImportant'], // important => false
          'true', // hors pgm  => true
          '0', // contrat => ''
          duree, // durée => ''
          '' + siteCA, // site CA => site encours
          '' + typedmd, // type dmd => type dmd existant
          this.newprest['acompte'] ? parseFloat(this.newprest['acompte']).toFixed(2) : '0.00', // acompte
          this.newprest['infoFact'] || '', // info fact
          this.newprest['numBSDD'] || '', // bsdd
          '' + (this.newprest['camion'] ? this.newprest['camion'].id : 0), // clef camion => 0
          'false', // reception chantier => 'false'
          '2000-01-01', // date reception chantier => 2000-01.01
          '', // heure reception chantier => ''
          '0', // clef camion chantier => '0'
          '0', // clef chauffeur chantier => '0'
          '0', // position planning chantier => '0'
          this.newprest['numBonManuel'] || '', // bon manuel index 28
          '0', // periode index 29 => '0' // + (this.newprest['periode'] ? this.newprest['periode'].id : 0)
          this.societe['gestionDateMax'] ? moment(this.newprest['dateMaxStart']).format('YYYY-MM-DD') : moment(this.newprest['dateStart']).format('YYYY-MM-DD'), // dateMax
          this.benneChantier['axeAnalytiqueLigne'] || '', // axeAnalytiqueLignePrestation => ''
          (!this.benneChantier['isGroupeArticle'] ? this.benneChantier['axeAnalytiqueLigneArt'] : ''), // axeAnalytiqueLigneArticle => ''
          this.newprest['numScelle'] || '' // numScelle
        ];

        const mouv = {
          'id': 0,
        };
        mouv['dateEnlevement'] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
        mouv['heure'] = heure || '';
        mouv['operation'] = '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0');
        mouv['chauffeur'] = {
          'id': '0'
        };
        mouv['bon'] = {
          'id': 0,
          'numBSDD': this.newprest['numBSDD'] || '',
          'numScelle': this.newprest['numScelle'] || '',
          'numBonManuel': this.newprest['numBonManuel'] || '',
        };
        mouv['bon'].axeAnalytiqueLigneArticle = (!this.benneChantier['isGroupeArticle'] ?
          this.benneChantier['axeAnalytiqueLigneArt'] : '');
        mouv['bon'].axeAnalytiqueLignePrestation = this.benneChantier['axeAnalytiqueLigne'];
        mouv['auPlusTard'] = this.newprest['auPlusTard'] || false;
        mouv['dateDemande'] = this.newprest['numBSDD'] || '';
        mouv['exutoire'] = {
          id: (this.newprest['exutoire'] ? this.newprest['exutoire'].id : 0)
        };
        mouv['siteExploitation'] = {
          id: this.common.user[2]
        };
        mouv['infoSupp'] = this.newprest['infoNextMouv'] || '';
        mouv['important'] = this.newprest['isImportant'];
        mouv['horsProgram'] = true;
        mouv['contrat'] = {
          id: 0
        };
        mouv['duree'] = duree;
        mouv['clefSiteCA'] = siteCA;
        mouv['typeDemande'] = {
          id: typedmd
        };
        mouv['facturation'] = this.newprest['acompte'] ? parseFloat(this.newprest['acompte']).toFixed(2) : '0.00';
        mouv['infoFact'] = this.newprest['infoFact'] || '';
        mouv['camion'] = {
          id: (this.newprest['camion'] ? this.newprest['camion'].id : 0)
        };
        mouv['qtePrevisionnelle'] = this.benneChantier['qte'] || 0;
        mouv['receptionChantier'] = false;
        mouv['dateReception'] = '2000-01-01';
        mouv['heureReception'] = '';
        mouv['camionChantier'] = {
          id: '0'
        };
        mouv['chauffeurChantier'] = {
          id: '0'
        };
        mouv['positionPlanningChantier'] = '0';
        mouv['periode'] = {
          id: this.newprest['periode'] ? this.newprest['periode'].id : 0
        };
        // mouv['listeClesBennesDuGroupe'] = [];
        mouv['chauffeur'] = chauff;
        mouv['listePersonnelParPoste'] = this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPosteMvt'] || [] : [];
        mouv['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
        mouv['listeNumBSDDParBenne'] = this.newprest['listeNumBSDDParBenne'] || [];
        mouv['listeNumScelleParBenne'] = this.newprest['listeNumScelleParBenne'] || [];
        mouv['listeOperationParBenneDuGroupe'] = this.newprest['listeOperationParBenneDuGroupe'] || [];
        let existe, existeSupp = false;
        if (this.societe['gestionDateMax']) {
          mouv['dateMax'] = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
        }
        let idart = 0
        if (!this.benneChantier['isGroupeBenne'] && !this.benneChantier['isGroupeArticle']) {
          idart = this.benneChantier['art'] && this.benneChantier['art'].id ? this.benneChantier['art'].id : 0
        }

        mouv['articleMouv'] = idart ? { id: idart } : { id: 0 };

        this.listeMouvSupp.forEach(elt => {
          if (elt[4] === '0') {
            existeSupp = true;
          }

          if (this.info['bonSelected'] && (elt[5] === '' + this.info['bonSelected'].id)) {
            elt[3] = '' + (chauff.id);
          }
        });
        if (!existeSupp) {
          this.listeMouvSupp[this.listeMouvSupp.length] = mouvSupp;
        }

        this.info['mouvCourant'][4].forEach(elt => {
          elt['listeClesBennesDuGroupe'] = data ? (data.data || []) : [];
          if (elt.id === 0) {
            existe = true;
            elt = mouv;
          }
        });
        if (!existe) {
          this.info['mouvCourant'][4].push(mouv);
        }

        this.info['mouvCourant'][4] = this.info['mouvCourant'][4].filter(elt => '' + elt.id !== this.info['mouvPrincipal'][0]);
      }
    }
  }

  createObjMvt(data?) {
    console.log('Calling createObjMvt()');
    console.log(this.newprest);
    if (!this.isAmiante) {
      this.newprest['numScelle'] = ''
    }

    /***Modif à faire demain */
    const heure = this.hourMvt();
    const duree = this.parseDureeMvt();
    const progm = this.createObjtMvtBennePgm();
    // si xMouv alors mouv.listMouvSupp index 1 @ mouvcourant atao anaty mouv
    // listeMouvementsSupplementaires index 4 @ mouvcourant atao anaty mouv
    const objEquipe = this.objMvtEquipe();

    this.updateListeMvt(data);
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const siteCA = this.isShowSite ? (this.newprest['siteCA'] ? this.newprest['siteCA'].id
      : this.common.user[2]) : this.common.user[2];
    const objTypedmd = this.newprest['typeDemande'] ? this.newprest['typeDemande'] : { id: 1 };
    const chauff = this.info['mouvPrincipal'] ? { id: this.info['mouvPrincipal'][7] || '0' } :
      (this.societe['ecobennesEquipe'] ? (this.newprest['modeEquipe'] ?
        this.objEquipe['chauffeur'] || { id: 0 } : { id: 0 }) : (this.objEquipe['chauffeur'] || { id: 0 }));
    const periode = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][37] :
      (this.newprest['periode'] ? this.newprest['periode'].id || 0 : 0);
    const camion = this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][20] :
      (this.newprest['camion'] ? this.newprest['camion'].id || 0 : 0);
    const mouv = this.info['mouvPrincipalObj'] || {};
    let idart = 0
    if (!this.benneChantier['isGroupeBenne'] && !this.benneChantier['isGroupeArticle']) {
      idart = this.benneChantier['art'] && this.benneChantier['art'].id ? this.benneChantier['art'].id : 0
    }

    const art = this.info['mouvPrincipalObj'] && this.info['mouvPrincipalObj'].articleMouv ? this.info['mouvPrincipalObj'].articleMouv : { id: 0 };
    const articleMouv = this.info['mouvPrincipal'] ? art : { id: idart };
    let objTypedmdInitial: any = {}
    if (this.info['mouvPrincipal'] && this.info['mouvPrincipal'][21]) {
      objTypedmdInitial = this.listeChoixDmdFaitPar.find(elt => elt.id === parseInt(this.info['mouvPrincipal'][21], 10)) || {}
    }

    if (objTypedmdInitial && objTypedmdInitial.id) {
      objTypedmdInitial['nomclass'] = 'TypeDemande';
    } else if (objTypedmd) {
      objTypedmd['nomclass'] = 'TypeDemande';
    }

    console.log('mouvement principal : ', mouv)
    const mouvement = {
      'dateDemande': moment().format('YYYY-MM-DD'),
      'dateEnlevement': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][3]
        : moment(this.newprest['dateStart']).format('YYYY-MM-DD'),
      'dateDemandeManuel': this.newprest['dateDemandeManuel'] ? moment(this.newprest['dateDemandeManuel'], 'DD/MM/YYYY').format('YYYY-MM-DD') : '0000-00-00',
      'heure': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][4] : heure,
      'clefBenneChantiers': '' + (this.benneChantier['id'] || 0),
      'clefClient': '' + (this.newprest['client'] ? this.newprest['client'].id : '0'),
      'clefChauffeur': '' + (chauff.id || 0), // clef chauffeur => debug pnt 102797
      'operation': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][11]
        : '' + (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'), // choix operation
      'clefExutoire': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][13] : ('' + (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0')),
      'clefSitePrest': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][14] : sitePrest,
      'clefSiteCA': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][15] : '' + siteCA,
      'typeDemande': objTypedmd && objTypedmd.id ? objTypedmd : objTypedmdInitial,
      'infoFact': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][28] : (this.newprest['infoFact'] || ''),
      'infoSup': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][10] : (this.newprest['infoNextMouv'] || ''),
      'listMouvSupp': this.info['mouvCourant'] ? this.listeMouvSupp : [],
      'listeMouvementsSupplementaires': this.info['mouvCourant'] ? this.info['mouvCourant'][4] : [],
      'bon': {
        'numBonManuel': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][36] : this.newprest['numBonManuel'] || '',
        'numBSDD': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][24] : this.newprest['numBSDD'] || '',
        'axeAnalytiqueLigneArticle': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][39] :
          (!this.benneChantier['isGroupeArticle'] ? (this.benneChantier['axeAnalytiqueLigneArt'] || '') : ''),
        'axeAnalytiqueLignePrestation': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][40] :
          (this.benneChantier['axeAnalytiqueLigne'] || ''),
        'lignePrestationContrat': { id: this.newprest['prestation'] ? (this.newprest['prestation'].id || 0) : 0 },
        'numScelle': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][42] : this.newprest['numScelle'] || '',
      },
      'bonRemorque': {
        id: mouv['bonRemorque'] ? mouv['bonRemorque'].id || 0 : 0
      },
      'positionRemorque': mouv['positionRemorque'] || 0,
      'clefProgram': this.newprest['program'] ? ('' + (progm['id'])) : '0', // MouvementBenneProgramme.id || '0'
      'isProgram': this.newprest['program'],
      // 'horsProgram': this.newprest['program'] ? false : true,
      'listeClesBennesDuGroupe': data ? (data.data || []) : [],
      'user': '' + this.common.user[0],
      'facturation': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][5] : this.newprest['acompte'],
      'important': this.info['mouvPrincipal'] ? (this.info['mouvPrincipal'][23] === '1' ? true : false) : this.newprest['isImportant'],
      'duree': this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][18] : duree,
      'chauffeur': chauff,
      'listePersonnelParPoste': this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPosteMvt'] || [] : [],
      'camion': { id: camion },
      'periode': {
        id: periode
      },
      'auPlusTard': this.info['mouvPrincipal'] ? (this.info['mouvPrincipal'][19] === '1' ||
        this.info['mouvPrincipal'][19] === true ? true : false) : (this.newprest['auPlusTard'] || false),
      'contrat': { id: this.newprest['contratChamp'] ? (this.newprest['contratChamp'].id || 0) : 0 },
      'listeOperationParBenneDuGroupe': this.info['mouvPrincipal'] ? this.info['mouvPrincipalObj']['listeOperationParBenneDuGroupe']
        : this.newprest['listeOperationParBenneDuGroupe'],
      'listeNumBSDDParBenne': this.info['mouvPrincipal'] ? this.info['mouvPrincipalObj']['listeNumBSDDParBenne'] :
        this.newprest['listeNumBSDDParBenne'],
      'listeNumScelleParBenne': this.info['mouvPrincipal'] ? this.info['mouvPrincipalObj']['listeNumScelleParBenne'] :
        this.newprest['listeNumScelleParBenne'],
      'articleMouv': articleMouv,
      'nomclass': 'Mouvement'
    };

    if (this.info['mouvPrincipalObj']) {
      mouvement['camionRemorque'] = Object.assign({}, this.info['mouvPrincipalObj'].camionRemorque || { id: 0 });
    }

    if (this.newprest['program']) {
      mouvement['isProgram'] = true;
      mouvement['typeProg'] = progm['typeOperation'];
      mouvement['freqProg'] = progm['frequence'];
      mouvement['listDateProg'] = progm['listJours'];
    }

    if (!this.benneChantier['isGroupeArticle']) {
      mouvement['qtePrevisionnelle'] = this.info['mouvPrincipal'] ? (this.info['mouvPrincipalObj'].qtePrevisionnelle
        || 0) : (this.benneChantier['qte'] || 0);
    }

    if (this.societe['gestionDateMax']) {
      mouvement['dateMax'] = this.info['mouvPrincipal'] ? moment(this.info['mouvPrincipalObj'].dateMax,
        'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD')
        : moment(this.newprest['dateMaxStart']).format('YYYY-MM-DD');
    }

    return mouvement;
  }

  createObjMvtPraxy(data?) {

    /***Modif à faire demain */
    const heure = this.hourMvt();
    const chauff = this.mouvement['chauffeur'] || { id: this.info['mouvPrincipal'][7] || '0' }
    const mouvement = {
      'dateDemande': moment().format('YYYY-MM-DD'),
      'dateEnlevement': moment(this.newprest['dateStart']).format('YYYY-MM-DD'),
      'heure': heure,
      'clefBenneChantiers': '' + (this.benneChantier['id'] || 0),
      'clefClient': '' + (this.newprest['client'] ? this.newprest['client'].id : '0'),
      'clefChauffeur': '' + (chauff.id || 0),
      'operation': (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'),
      'clefExutoire': '' + (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0'),
      'exutoire': { id: (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0') },
      'infoFact': (this.newprest['infoFact'] || ''),
      'infoSup': (this.newprest['infoNextMouv'] || ''),
      'listMouvSupp': this.info['mouvCourant'] ? this.listeMouvSupp : [],
      'listeMouvementsSupplementaires': this.info['mouvCourant'] ? this.info['mouvCourant'][4] : [],
      'user': '' + this.common.user[0],
      'nomclass': 'Mouvement'
    };


    return { ...this.mouvement, ...mouvement };
  }

  /*
   * Positionne 00:00:00 sur un objet moment
   */
  setMomentHour0(moment_object) {
    moment_object.set('hour', 0);
    moment_object.set('minute', 0);
    moment_object.set('second', 0);
  }

  testOperationValidation(dt, isGroupe?) {
    const momentDate = moment(this.newprest['dateStart']);
    const operation = [];
    operation.push(...this.listOperationBenne, ...this.listOperationNew);
    dt.LISTE_MOUV = dt.LISTE_MOUV || [];
    const existeMouvRetrait = dt.LISTE_MOUV.filter(elt => elt.operation === '1');
    if (existeMouvRetrait && existeMouvRetrait.length) {
      // 1
      const retrait = existeMouvRetrait[0] || {};
      const momentRetrait = moment(retrait.dateEnlevement, 'YYYY-MM-DD');
      this.setMomentHour0(momentDate);
      this.setMomentHour0(momentRetrait);
      if (momentDate.isAfter(momentRetrait) || this.isRetraitFct()) {
        this.isRetrait = true;
        this.isRetrait = true;
        const date = moment(retrait.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const numbon = retrait.bon ? retrait.bon.numBon || '' : '';
        this.error = `Il existe déjà un retrait sur ${isGroupe ? 'ce groupe de' :
          'cette'} benne le ${date} sur le bon ${numbon}.`;
        this.common.openModal(this.modalService, this.msg);
      } else {
        const mouvSupp = dt.LISTE_MOUV || [];
        const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate) && elt.operation === '0');
        if (listMouv && listMouv.length) {
          if (!this.newprest['typeOperation'] || (this.newprest['typeOperation'] && this.newprest['typeOperation'] === 0)) {
            this.saveEquipeMvt().then(datas => {
              if (this.isReport) {
                this.updateDateWeek().then(() => {
                  this.updateBenneChantier(true).then(data => {
                    if (!data || !data.message) {
                      this.updateMouv(data);
                    }
                  });
                });
              } else {
                this.updateBenneChantier(true).then(data => {
                  if (!data || !data.message) {
                    this.updateMouv(data);
                  }
                });
              }
            });

          } else {
            const mvtD = listMouv[0] || {};
            this.isRetrait = true;
            let ope = '';
            operation.forEach(elt => {
              if (elt.id === parseInt(mvtD['operation'], 10)) {
                ope = elt.libelleObjetEntite;
              }
            });
            const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
            const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
            this.error = `Il existe déjà un mouvement de  ${ope} sur ${isGroupe ? 'ce groupe de' :
              'cette'} de benne le ${date} sur le bon ${numbon}.`;
            this.common.openModal(this.modalService, this.msg);
          }
        } else {
          if (this.isRetraitFct()) {
            console.log(momentDate)
            const listMouvOp = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate));
            if (listMouvOp && listMouvOp.length) {
              const mvtD = listMouvOp[0] || {};
              this.isRetrait = true;
              let ope = '';
              operation.forEach(elt => {
                if (elt.id === parseInt(mvtD['operation'], 10)) {
                  ope = elt.libelleObjetEntite;
                }
              });
              const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
              const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
              this.error = `Il existe déjà un mouvement de ${ope} sur ${isGroupe ? 'ce groupe de' :
                'cette'} de benne le ${date} sur le bon ${numbon}.`;
              this.common.openModal(this.modalService, this.msg);
            } else {
              this.saveEquipeMvt().then(datas => {
                if (this.isReport) {
                  this.updateDateWeek().then(() => {
                    this.updateBenneChantier(true).then(data => {
                      if (!data || !data.message) {
                        this.updateMouv(data);
                      }
                    });
                  });
                } else {
                  this.updateBenneChantier(true).then(data => {
                    if (!data || !data.message) {
                      this.updateMouv(data);
                    }
                  });
                }
              });

            }
          } else {
            this.saveEquipeMvt().then(datas => {
              if (this.isReport) {
                this.updateDateWeek().then(() => {
                  this.updateBenneChantier(true).then(data => {
                    if (!data || !data.message) {
                      this.updateMouv(data);
                    }
                  });
                });
              } else {
                this.updateBenneChantier(true).then(data => {
                  if (!data || !data.message) {
                    this.updateMouv(data);
                  }
                });
              }
            });

          }

        }
      }
    } else {
      // 2
      const mouvSupp = dt.LISTE_MOUV || [];
      const listMouv = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate) && elt.operation === '0');
      if (listMouv && listMouv.length) {
        if (!this.newprest['typeOperation'] || (this.newprest['typeOperation'] && this.newprest['typeOperation'] === 0)) {
          this.saveEquipeMvt().then(datas => {
            if (this.isReport) {
              this.updateDateWeek().then(() => {
                this.updateBenneChantier(true).then(data => {
                  if (!data || !data.message) {
                    this.updateMouv(data);
                  }
                });
              });
            } else {
              this.updateBenneChantier(true).then(data => {
                if (!data || !data.message) {
                  this.updateMouv(data);
                }
              });
            }
          });
        } else {
          const mvtD = listMouv[0] || {};
          this.isRetrait = true;
          let ope = '';
          operation.forEach(elt => {
            if (elt.id === parseInt(mvtD['operation'], 10)) {
              ope = elt.libelleObjetEntite;
            }
          });
          const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
          const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
          this.error = `Il existe déjà un mouvement de  ${ope} sur ${isGroupe ? 'ce groupe de' :
            'cette'} de benne le ${date} sur le bon ${numbon}.`;
          this.common.openModal(this.modalService, this.msg);
        }
      } else {
        if (this.isRetraitFct()) {
          console.log(momentDate)
          const listMouvOp = mouvSupp.filter(elt => moment(elt.dateEnlevement, 'YYYY-MM-DD').isAfter(momentDate));
          if (listMouvOp && listMouvOp.length) {
            const mvtD = listMouvOp[0] || {};
            this.isRetrait = true;
            let ope = '';
            operation.forEach(elt => {
              if (elt.id === parseInt(mvtD['operation'], 10)) {
                ope = elt.libelleObjetEntite;
              }
            });
            const date = moment(mvtD.dateEnlevement, 'YYYY-MM-DD').format('DD/MM/YYYY');
            const numbon = mvtD.bon ? mvtD.bon.numBon || '' : '';
            this.error = `Il existe déjà un mouvement de ${ope} sur ${isGroupe ? 'ce groupe de' :
              'cette'} de benne le ${date} sur le bon ${numbon}.`;
            this.common.openModal(this.modalService, this.msg);
          } else {
            this.saveEquipeMvt().then(datas => {
              if (this.isReport) {
                this.updateDateWeek().then(() => {
                  this.updateBenneChantier(true).then(data => {
                    if (!data || !data.message) {
                      this.updateMouv(data);
                    }
                  });
                });
              } else {
                this.updateBenneChantier(true).then(data => {
                  if (!data || !data.message) {
                    this.updateMouv(data);
                  }
                });
              }
            });
          }
        } else {
          this.saveEquipeMvt().then(datas => {
            if (this.isReport) {
              this.updateDateWeek().then(() => {
                this.updateBenneChantier(true).then(data => {
                  if (!data || !data.message) {
                    this.updateMouv(data);
                  }
                });
              });
            } else {
              this.updateBenneChantier(true).then(data => {
                if (!data || !data.message) {
                  this.updateMouv(data);
                }
              });
            }
          });
        }
      }
    }
  }

  saveEquipeMvt() {
    const objEquipe = this.objMvtEquipe();
    const beneData = {
      'id': this.benneChantier['id'],
      'nomclass': 'BenneData',
      'infoFact': this.benneChantier['infoFact'],
      'art': this.benneChantier['art'],
      'isGroupeBenne': this.benneChantier['isGroupeBenne'] || false,
      'isGroupeArticle': this.benneChantier['isGroupeArticle'] || false,
      'listBennes': this.benneChantier['listBennes'] || [],
      'listArticles': this.benneChantier['listArticles'] || [],
      'contrat': this.newprest['numContrat'] ? 'true' : 'false',
      'numContrat': this.newprest['numContrat'] || '',
      'infos': this.newprest['infosbenneChantiers'] || '',
      'dateDebutLoc': this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000',
      'typeLocation': this.benneChantier['typeLocation'] || 1,
      'isLocImmediat': this.benneChantier['isLocImmediat'] || false,
      'isLocJour': this.benneChantier['isLocJour'] || false,
      'isTarifLoc': this.benneChantier['isTarifLoc'] || false,
      'tarifLoc': this.benneChantier['tarifLoc'] || 0,
      'nbrRotTarifLoc': this.benneChantier['nbrRotTarifLoc'] || 0,
      'nbrRotGratuite': this.benneChantier['nbrRotGratuite'] || 0,
      'isTarifRot': this.benneChantier['isTarifRot'] || false,
      'tarifRot': this.benneChantier['tarifRot'] || 0,
      'commentairesFact': this.benneChantier['commentairesFact'] || '',
      'qteContenant': this.benneChantier['qteContenant'] || 1,
      'benneClient': this.benneChantier['benneClient'],
      'mailContenant': this.benneChantier['mailContenant'] || '',
      'clefChantier': this.newprest['chantier'] ? (this.newprest['chantier'].id || 0) : 0,
      'modeEquipe': this.newprest['modeEquipe'],
      'qualificationLeader': this.newprest['modeEquipe'] ? this.objEquipe['qualificationLeader'] || { id: 0 } : { id: 0 },
      'leaderEquipe': this.newprest['modeEquipe'] ? this.objEquipe['leaderEquipe'] || { id: 0 } : { id: 0 },
      'listePostes': this.newprest['modeEquipe'] ? objEquipe['listePostes'] || [] : [],
      'equipeDefinie': this.newprest['modeEquipe'] ? (objEquipe['listePostes'].length ? true : false) : false,
      'listePersonnelParPoste': this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPoste'] || [] : [],
      'clefOperationBenneParDefaut': this.defaultSelectedDefaut ? this.defaultSelectedDefaut['id'] || 0 : 0,
      'lieu': {
        'id': '' + (this.newprest['lieu'] ? this.newprest['lieu'].id || 0 : 0)
      },
    };


    const param = {
      'servlet': 'DBGestionEquipeBenne',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'BENNE': beneData,
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'ANGULAR': {
          'typeParam': 'boolean',
          'valeur': true
        },
      }
    };
    const ctrl = this;
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          const benne = datas.data || {};
          if (benne) {
            benne.listePostes = benne.listePostes || [];
            benne.listePersonnelParPoste = benne.listePersonnelParPoste || [];
            benne.listePersonnelParPoste.forEach((elt, index) => {
              if (this.objEquipe['listePersonnelParPoste'][index]) {
                if (this.objEquipe['listePersonnelParPoste'][index].poste && elt.poste) {
                  this.objEquipe['listePersonnelParPoste'][index].poste.id = elt.poste.id || 0;
                }
              }
            });
          }
          return datas.data
        } else {
          return Promise.reject(datas.message);
        }
      }
    });
  }

  validerUpdateContenant() {
    console.log('Calling validerUpdateContenant()');

    this.benneChantier = this.newprest['contenant'];
    this.benneChantier['qteContenant'] = this.benneChantier['qteContenant'] ? parseInt(this.benneChantier['qteContenant'], 10) : 1;
    const isClient = this.newprest['client'] && this.newprest['client'].id ? true : false;
    const isChantier = this.newprest['chantier'] && this.newprest['chantier'].id ? true : false;
    const isArticle = this.benneChantier['isGroupeArticle'] ? true : (this.benneChantier['art'] && this.benneChantier['art'].id ? true : false);
    this.newprest['exutoire'] = this.newprest['exutoire'] || { id: 0 };
    const isExutoire = true;
    const isTypecont = this.benneChantier['typeContenant'] && this.benneChantier['typeContenant'].id ? true : false;
    const isGoupe = this.benneChantier['isGroupeBenne'] || false;
    const listBennes = this.benneChantier['listBennes'] || [];
    if (this.newprest['typeOperation'] && (this.newprest['typeOperation'].id === 0 || this.newprest['typeOperation'].id === 1)) {
      this.defaultSelectedDefaut = { id: 0 }
    }

    if (!this.verificationOkNumBonManuelOb(this.newprest['numBonManuel'], this.newprest['client'])) {
      this.error = 'Le champs Num bon manuel est obligatoire.';
      this.isClicked = false;
      this.showSpinner = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    const dateStart = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
    if (!this.isValidDate(dateStart)) {
      this.error = 'La date n\'est pas valide.';
      this.isClicked = false;
      this.showSpinner = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    this.benneChantier['lieu'] = {
      'id': '' + (this.newprest['lieu'] ? this.newprest['lieu'].id || 0 : 0)
    };

    if (!this.benneChantier['isGroupeBenne'] && this.benneChantier['isGroupeArticle'] && !this.benneChantier['listArticle'].length) {
      this.error = 'Votre groupe d\'article doit comporter au moins un article.';
      this.isClicked = false;
      this.showSpinner = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }
    if (!this.benneChantier['isGroupeArticle'] && this.benneChantier['art']) {
      this.benneChantier['art'].qtePrevisionnelle = this.benneChantier['qte'] || 0;
    }

    if (this.benneChantier['listArticle']) {
      this.benneChantier['listArticles'] = [];
      this.benneChantier['listArticle'].forEach(elt => {
        const art = Object.assign({}, elt.art);
        art.exu = Object.assign({}, elt.exutoire);
        art.qtePrevisionnelle = (elt.qte || 0)
        art.nomclass = 'Article';
        art.axeAnalytiqueLigneArticle = elt.axeAnalytiqueLigneArt || '';
        this.benneChantier['listArticles'].push(art);
      });
    }

    if (this.benneChantier['isGroupeBenne']) {
      this.benneChantier['operation'] = this.benneChantier['operationBenne'] ? (this.benneChantier['operationBenne']['id'] || '0') : '0';
      this.benneChantier['operationBenne'] = {
        id: this.benneChantier['operationBenne'] ? (this.benneChantier['operationBenne']['id'] || '0') : '0'
      };
    }

    let existeTypeCont0 = false;
    let existePasArticle = false;
    if (this.benneChantier['listBennes']) {
      this.newprest['listeOperationParBenneDuGroupe'] = [];
      this.newprest['listeNumBSDDParBenne'] = [];
      this.newprest['listeNumScelleParBenne'] = [];
      this.benneChantier['listBennes'].forEach(elt => {
        let numScelle = '';
        if (elt.id < 0) {
          elt.id = 0;
        }

        if (elt.art && elt.art.amiante) {
          numScelle = elt.numScelle || ''
        }
        if (!existeTypeCont0 && (!elt.typeContenant || elt.typeContenant && !elt.typeContenant.id)) {
          existeTypeCont0 = true;
        }

        if (!existePasArticle && ((elt.isGroupeArticle && (!elt.listArticles || (elt.listArticles && !elt.listArticles.length))) ||
          (!elt.isGroupeArticle && (!elt.art || (elt.art && !elt.art.id))))) {
          existePasArticle = true;
        }
        elt.nomclass = 'BenneData';
        elt.operation = elt.operationBenne ? (elt.operationBenne['id']) : 0;
        this.newprest['listeOperationParBenneDuGroupe'].push(elt.operationBenne ?
          (elt.operationBenne['id']) : 0);
        this.newprest['listeNumBSDDParBenne'].push(elt.numBSDDManuel || '');
        this.newprest['listeNumScelleParBenne'].push(numScelle);
        elt.operationBenne = {
          id: elt.operationBenne ? (elt.operationBenne['id']) : 0
        };
        // elt.nomclass = 'BenneData';
        // elt.operationBenne = {
        //   id: '2'
        // };
      });
    }

    if (this.benneChantier['isGroupeArticle'] && this.benneChantier['isGroupeBenne'] && this.benneChantier['listBennes'].length
      && (!this.benneChantier['listArticle'] || (this.benneChantier['listArticle'] && !this.benneChantier['listArticle'].length))
      && (!this.benneChantier['art'] || (this.benneChantier['art'] && !this.benneChantier['art'].id))) {
      const obj0 = this.benneChantier['listBennes'][0];
      this.benneChantier['isGroupeArticle'] = false;
      if (obj0.art) {
        this.benneChantier['art'] = Object.assign({}, obj0.art)
      } else {
        if (obj0.isGroupeArticle && obj0.listArticle && obj0.listArticle.length) {
          this.benneChantier['art'] = Object.assign({}, obj0.listArticle[0])
        }
      }
    }

    if (existePasArticle) {
      this.isClicked = false;
      this.showSpinner = false;
      // this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article, type de contenant et exutoire)`;
      this.error = `Votre groupe d\'article doit comporter au moins un article.`;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (existeTypeCont0 && isGoupe) {
      this.isClicked = false;
      this.showSpinner = false;
      // this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article, type de contenant et exutoire)`;
      this.error = `Vous devez sélectionner un type de contenant`;
      this.common.openModal(this.modalService, this.msg);
    }


    if (!this.isClicked) {
      this.isClicked = true;
      this.showSpinner = true;
      if (isClient && isChantier && isArticle && isExutoire && isTypecont && !isGoupe) {
        this.validerBSDDManContenantVert().then(datasBSD => {
          if (datasBSD.data) {
            if (this.isEcoDDS) {
              this.updateMvtECODDS();
            } else {
              if (this.isMouvPraxy) {
                this.updateMvtPraxy();
              } else {
                if (!this.isVidage) {
                  this.benneChantier = this.newprest['contenant'];
                  this.checkRetraitBenne().then(datas => {
                    const dt = datas.data || {};
                    const momentDate = moment(this.newprest['dateStart']);
                    this.testOperationValidation(dt);
                  }).catch(err => {
                    this.isClicked = false;
                    this.showSpinner = false;
                  });
                } else {
                  this.updateParking();
                }
              }
            }
          }
        }).catch(err => {
          this.isClicked = false;
          this.showSpinner = false;
        })


      } else {
        if (!this.newprest['tournee'] && isGoupe && isClient && isChantier && isExutoire && isTypecont) {
          if (listBennes.length) {
            this.validerBSDDManContenantVert().then(datasBSD => {
              if (datasBSD.data) {
                if (this.isEcoDDS) {
                  this.updateMvtECODDS();
                } else {
                  if (this.isMouvPraxy) {
                    this.updateMvtPraxy();
                  } else {
                    if (!this.isVidage) {
                      this.benneChantier = this.newprest['contenant'];
                      const momentDate = moment(this.newprest['dateStart']);
                      this.checkRetraitBenne().then(datas => {
                        const dt = datas.data || {};
                        this.testOperationValidation(dt, true);
                      }).catch(err => {
                        this.isClicked = false;
                        this.showSpinner = false;
                      });
                    } else {
                      this.updateParking();
                    }
                  }
                }
              }
            }).catch(err => {
              this.isClicked = false;
              this.showSpinner = false;
            })


          } else {
            this.isClicked = false;
            this.showSpinner = false;
            this.error = `Votre groupe de contenant doit comporter au moins un contenant`;
            this.common.openModal(this.modalService, this.msg);
          }
        } else {
          if (this.newprest['tournee']) {
            this.validerBSDDManContenantVert().then(datasBSD => {
              if (datasBSD.data) {
                if (this.isEcoDDS) {
                  this.updateMvtECODDS();
                } else {
                  if (this.isMouvPraxy) {
                    this.updateMvtPraxy();
                  } else {
                    if (!this.isVidage) {
                      this.editMvtTourne();
                    } else {
                      this.updateParking();
                    }
                  }
                }
              }
            }).catch(err => {
              this.isClicked = false;
              this.showSpinner = false;
            })


          } else {
            this.isClicked = false;
            this.showSpinner = false;
            // this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article, type de contenant et exutoire)`;
            this.error = `Veuillez renseigner tous les champs obligatoires. (client, chantier, article et type de contenant)`;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    }

  }

  testDate(str) {
    var t = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (t === null)
      return false;
    var d = +t[1], m = +t[2], y = +t[3];

    // Below should be a more acurate algorithm
    if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {
      return true;
    }

    return false;
  }

  updateMvtECODDS() {
    const mouvement = this.createObjMvtPraxy();
    mouvement['id'] = this.info['mouvement'] && this.info['mouvement'].id ? this.info['mouvement'].id : 0;
    mouvement['chantier'] = mouvement['chantier'] || {};
    mouvement['chantier'].siteChantier = mouvement['chantier'].siteChantier || { id: 0 };
    mouvement['chantier'].siteChantier.id = this.common.user[2] || 0;
    const duree = this.parseDureeMvt();
    mouvement['duree'] = duree;
    const benne = this.benneChantier;
    benne['dateDebutLoc'] = this.benneChantier['dateDebutLoc'] && (typeof this.benneChantier['dateDebutLoc'] === 'string' && this.testDate(this.benneChantier['dateDebutLoc'])) ?
      this.benneChantier['dateDebutLoc'] : (this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000');
    console.log('dateDebutLoc', benne['dateDebutLoc']);
    this.benneChantier['listBennes'] = this.benneChantier['listBennes'] || [];
    this.benneChantier['listBennes'].forEach(element => {
      element['dateDebutLoc'] = element['dateDebutLoc'] && (element['dateDebutLoc'] === 'string' && this.testDate(element['dateDebutLoc'])) ?
        element['dateDebutLoc'] : (element['dateDebutLoc'] ? moment(element['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000');
    });
    benne['nomclass'] = 'BenneData';

    mouvement['benne'] = benne;

    const param = {
      'servlet': 'DBGestionImportationEcodds',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'MOUVEMENT': mouvement,
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LISTE_BENNE': this.benneChantier['listBennes'] || [],
        'BENNE': benne
      }
    };

    console.log(param)
    return this.common.post('', { param: param }).then(datas => {
      this.closeFunction();
    }).catch(err => {
      this.isClicked = false;
      this.showSpinner = false;
    });
  }

  updateMvtPraxy() {
    const mouvement = this.createObjMvtPraxy();
    const benne = this.benneChantier;
    benne['dateDebutLoc'] = this.benneChantier['dateDebutLoc'] && this.common.isDate(this.benneChantier['dateDebutLoc']) ?
      this.benneChantier['dateDebutLoc'] : (this.benneChantier['dateDebutLoc'] ?
        moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000');
    this.benneChantier['listBennes'] = this.benneChantier['listBennes'] || [];
    this.benneChantier['listBennes'].forEach(element => {
      element['dateDebutLoc'] = element['dateDebutLoc'] && this.common.isDate(element['dateDebutLoc']) ?
        element['dateDebutLoc'] : (element['dateDebutLoc'] ?
          moment(element['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000');
    });
    benne['nomclass'] = 'BenneData';

    mouvement['benne'] = benne;

    const param = {
      'servlet': 'DBGestionEcorecExterne',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        },
        'MOUVEMENT': mouvement,
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LISTE_BENNE': this.benneChantier['listBennes'] || [],
        'BENNE': benne
      }
    };

    console.log(param)
    return this.common.post('', { param: param }).then(datas => {
      this.closeFunction();
    }).catch(err => {
      this.isClicked = false;
      this.showSpinner = false;
    });
  }

  updateParking() {
    // todo : updateParking
    const heure = this.hourMvt();
    const objEquipe = this.objMvtEquipe();
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const objTypedmd = this.newprest['typeDemande'] ? this.newprest['typeDemande'] : { id: 1 };
    let objTypedmdInitial: any = {}
    if (this.info['mouvPrincipal'] && this.info['mouvPrincipal'][21]) {
      objTypedmdInitial = this.listeChoixDmdFaitPar.find(elt => elt.id === parseInt(this.info['mouvPrincipal'][21], 10)) || {}
    }
    const siteCA = this.isShowSite ? (this.newprest['siteCA'] ? this.newprest['siteCA'].id
      : this.common.user[2]) : this.common.user[2];
    const mouvement = {
      'dateDemande': moment().format('YYYY-MM-DD'),
      'dateEnlevement': moment(this.newprest['dateStart']).format('YYYY-MM-DD'),
      'heure': heure,
      'clefBenneChantiers': '' + (this.benneChantier['id'] || 0),
      'clefClient': '' + (this.newprest['client'] ? this.newprest['client'].id : '0'),
      'clefChauffeur': '' + (this.info['mouvPrincipal'] ? this.info['mouvPrincipal'][7] : '0'), // clef chauffeur => debug pnt 102797
      'operation': (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'), // choix operation
      'clefExutoire': '' + (this.newprest['exutoire'] ? this.newprest['exutoire'].id : '0'),
      'clefSitePrest': '' + sitePrest,
      'clefSiteCA': '' + siteCA,
      'typeDemande': objTypedmd,
      'infoFact': (this.newprest['infoFact'] || ''),
      'infoSup': (this.newprest['infoNextMouv'] || ''),
      'listMouvSupp': this.listeMouvSupp || [],
      'listeMouvementsSupplementaires': [],
      'clefProgram': '0',
      'listeClesBennesDuGroupe': this.mouvement['listeClesBennesDuGroupe'] || [],
      'facturation': this.newprest['acompte'],
      'important': this.newprest['isImportant'],
      'chauffeur': this.societe['ecobennesEquipe'] ? (this.newprest['modeEquipe'] ?
        this.objEquipe['chauffeur'] || { id: 0 } : { id: 0 }) : (this.objEquipe['chauffeur'] || { id: 0 }),
      'listePersonnelParPoste': this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPosteMvt'] || [] : [],
      'nomclass': 'Mouvement'
    };
    mouvement['bon'] = this.info['bon'];
    mouvement['bon'].numBonManuel = (this.newprest['numBonManuel'] || '');
    mouvement['bon'].numBSDD = this.newprest['numBSDD'] || '';
    mouvement['facturation'] = this.newprest['acompte'] || '0';
    mouvement['user'] = '' + this.common.user[0];
    mouvement['infoFact'] = (this.newprest['infoFact'] || '');
    mouvement['infoSup'] = (this.newprest['infoNextMouv'] || '');
    mouvement['id'] = this.mouvement['id'];

    mouvement['benne'] = {
      'nomclass': 'BenneData',
      'id': this.mouvement['benne'].id || 0,
      'infoFact': this.benneChantier['infoFact'],
      'art': this.benneChantier['art'],
      'isGroupeBenne': this.benneChantier['isGroupeBenne'] || false,
      'isGroupeArticle': this.benneChantier['isGroupeArticle'] || false,
      'listBennes': this.benneChantier['listBennes'] || [],
      'listArticles': this.benneChantier['listArticles'] || [],
      'contrat': this.newprest['numContrat'] ? 'true' : 'false',
      'numContrat': this.newprest['numContrat'] || '',
      'infos': this.newprest['infos'] || '',
      'typeContenant': this.benneChantier['typeContenant'],
      'qteContenant': this.benneChantier['qteContenant'] || 1,
      'benneClient': this.benneChantier['benneClient'],
      'mailContenant': this.benneChantier['mailContenant'] || '',
      'dateDebutLoc': this.benneChantier['dateDebutLoc'] ? moment(this.benneChantier['dateDebutLoc']).format('DD/MM/YYYY') : '01/01/2000',
      // point: 115801
      'typeLocation': this.benneChantier['typeLocation'] || 1,
      'isLocImmediat': this.benneChantier['isLocImmediat'] || false,
      'isLocJour': this.benneChantier['isLocJour'] || false,
      'isTarifLoc': this.benneChantier['isTarifLoc'] || false,
      'tarifLoc': this.benneChantier['tarifLoc'] || 0,
      'nbrRotTarifLoc': this.benneChantier['nbrRotTarifLoc'] || 0,
      'nbrRotGratuite': this.benneChantier['nbrRotGratuite'] || 0,
      'isTarifRot': this.benneChantier['isTarifRot'] || false,
      'tarifRot': this.benneChantier['tarifRot'] || 0,
      'commentairesFact': this.benneChantier['commentairesFact'] || '',
      'modeEquipe': this.newprest['modeEquipe'],
      'qualificationLeader': this.newprest['modeEquipe'] ? this.objEquipe['qualificationLeader'] || { id: 0 } : { id: 0 },
      'leaderEquipe': this.newprest['modeEquipe'] ? this.objEquipe['leaderEquipe'] || { id: 0 } : { id: 0 },
      'listePostes': this.newprest['modeEquipe'] ? objEquipe['listePostes'] || [] : [],
      'equipeDefinie': this.newprest['modeEquipe'] ? (objEquipe['listePostes'].length ? true : false) : false,
      'listePersonnelParPoste': this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPoste'] || [] : [],
      'clefOperationBenneParDefaut': this.defaultSelectedDefaut ? this.defaultSelectedDefaut['id'] || 0 : 0,
      'lieu': {
        'id': '' + (this.newprest['lieu'] ? this.newprest['lieu'].id || 0 : 0)
      },
    };

    const param = {
      'servlet': 'DBGestionMouvementParking',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'MOUVEMENT': mouvement,
        'USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        }
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.isModifDateVidage) {
        this.common.openModal(this.modalService, this.changedate);
      } else {
        this.closeFunction();
      }
    }).catch(err => {
      this.isClicked = false;
      this.showSpinner = false;
    });
  }


  updateDateWeek() {
    const date = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
    const heure = this.newprest['hour'] || '';
    const mouv = this.mouvement;
    let mouvid;
    if (!mouv.id) {
      if (this.info && this.info['mouvCourant'] && this.info['mouvCourant'][3]) {
        if (this.info['mouvCourant'][3].bon && this.info['bonSelected'] && this.info['bonSelected'].id === this.info['mouvCourant'][3].bon.id) {
          mouvid = this.info['mouvCourant'][3].id;
        } else {
          this.info['mouvCourant'][4].forEach(elt => {
            if (elt.bon && elt.bon.id === this.info['bonSelected'].id) {
              mouvid = elt.id;
            }
          });
        }
      }
      console.log(mouvid)
    }

    const param = {
      'servlet': 'DBUpdateDateMouv',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBUpdateDateMouv', date, '' + (mouv ? (mouv.id || mouvid) : mouvid), '' + this.common.user[0],
        mouv.parking ? '' + mouv.parking.id : '0', heure, 'false', this.raisonReport]
    };
    this.common.closeModal();
    return this.common.post('', { param: param }).then(datas => {
      this.raisonReport = '';
      if (!this.isReport) {
        this.updateClientChantier();
      }
    }).catch(err => {
      this.isClicked = false;
      this.showSpinner = false;
    });
  }

  reportBon() {
    this.isReport = true;
    this.saveMouvement();
  }


  testerImprimerBon() {
    if (this.isImpressionSansChauffeur()) {
      if (this.societe.gestionFIP) {
        this.gestionFIPDND()
      } else {
        this.afficherChoixFormatPerso();
      }
    }
  }

  afficherChoixFormatPerso() {
    const ctrl = this;
    GestionFormat.getFormatperso(ConstanteEcorec.TYPE_FORMAT_PARAMETRABLE_BON_BENNES, this.common).then(datasFormat => {
      if (datasFormat.data && datasFormat.data.length) {
        ctrl.formatPerso = datasFormat.data;
        if (this.formatPerso.length > 1) {
          this.formatprs = this.formatPerso[0];
          // open modal
          this.common.openModal(this.modalService, this.format);
        } else {
          if (this.formatPerso.length === 1) {
            this.formatprs = this.formatPerso[0];
            ctrl.imprimerBon()
          } else {
            // get pdf to print
            // this.formatprs = this.formatPerso[0];
            this.common.openModal(this.modalService, this.format);
          }

        }
      } else {
        if (datasFormat.message) {
          this.alert.error(datasFormat.message);
        }
      }
    });
  }

  imprimerBon() {
    this.common.isRedirectOpenDocImp = false;
    if (!this.formatprs['id']) {
      this.error = 'Veuillez choisir un format.';
      this.common.openModal(this.modalService, this.msgFormat);
      return;
    } else {
      this.common.closeModal()
      const printPesee = 'true';
      let mouvid = this.info['mouvement'].id || 0
      if (!mouvid && this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
        if ('' + this.info['bonSelected'].id === this.info['mouvPrincipal'][16]) {
          mouvid = this.info['mouvPrincipal'][0];
        } else {
          this.listeMouvSupp.forEach(elt => {
            if (elt[5] === '' + this.info['bonSelected'].id) {
              mouvid = elt[4];
            }
          });
        }
      }

      const listClef = ['' + mouvid];
      GestionBon.imprimerBonEcoBenneFP(listClef, this.formatprs['id'], printPesee, this.common).then(datasPrint => {
        if (datasPrint.data && datasPrint.data.length) {
          this.common.openFile(datasPrint.data[0]);
          GestionBon.appelDetailmouv(listClef, this.common);
        } else {
          if (datasPrint.message) {
            this.alert.error(datasPrint.message);
          }
        }
      });
    }
  }

  isImpressionSansChauffeur() {
    if (!this.info['mouvement'].chauffeur
      && !this.info['mouvement'].camion) {
      return true;
    }

    if (this.info['mouvement'].chauffeur) {
      return true;
    } else {
      this.immatriculationCamionSsChauffeur = this.info['mouvement'].camion.immatriculation;
      this.common.openModal(this.modalService, this.confirmeImpBonSansChauffeur);
    }

    return false;
  }

  initSupprimerBon() {
    if (this.isVidage) {
      this.error = 'Ce mouvement a été réalisé vous ne pouvez plus le supprimer';
      this.common.openModal(this.modalService, this.msgFormat);
    } else {
      this.common.openModal(this.modalService, this.dialogueSuppression);
    }
  }

  supprimerBon() {
    const that = this;
    if (this.raisonSuppression !== '') {
      this.isClicked = true;
      this.showSpinner = true;
      let mouvid, benneid;
      benneid = this.info['contenant'].id;
      if (this.info && this.info['mouvPrincipal'] && this.info['mouvCourant']) {
        if ('' + this.info['bonSelected'].id === this.info['mouvPrincipal'][16]) {
          mouvid = this.info['mouvPrincipal'][0];
        } else {
          this.listeMouvSupp.forEach(elt => {
            if (elt[5] === '' + this.info['bonSelected'].id) {
              mouvid = elt[4];
            }
          });
        }
      }

      if (this.isVidage) {
        mouvid = this.info['mouvement'] ? this.info['mouvement'].id : '';
      }

      if (this.info['mouvement'] && this.info['tournee']) {
        mouvid = this.info['mouvement'] ? this.info['mouvement'].id : '';
      }

      if (this.info['mouvement'] && this.info['mouvement'].id && !mouvid) {
        mouvid = this.info['mouvement'].id || 0;
      }

      console.log(mouvid, this.info['mouvement']);
      GestionBon.supprimerBonEcoBenne(mouvid, benneid, this.raisonSuppression, this.common).then(datasSupp => {
        that.raisonSuppression = '';
        if (datasSupp.data && datasSupp.data.length) {
          if (datasSupp.data[0] === 'KO') {
            that.error = datasSupp.data[1];
            this.showSpinner = false;
            this.isClicked = false;
            that.common.openModal(that.modalService, that.msg);
          } else {
            if (this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity() && this.info['mouvement']) {
              const detail = this.info['mouvement'];
              this.resourceSygetrack = {
                nom: detail.chauffeur && detail.chauffeur.nom ? detail.chauffeur.nom : '',
                idChauff: detail.chauffeur && detail.chauffeur.id ? detail.chauffeur.id : 0,
                idCamion: detail.camion && detail.camion.id ? detail.camion.id : '',
                periodeId: detail.periode && detail.periode.id ? detail.periode.id : 0,
                dateSygetrack: moment(this.date).format('DD/MM/YYYY')
              };

              if (this.prepareSygetrack()) {
                this.setPlanifDI();
              } else {
                this.suiteSupprimerBon();
              }
            } else {
              this.suiteSupprimerBon();
            }
          }
        } else {
          if (datasSupp.message) {
            this.alert.error(datasSupp.message);
          }
        }
      }).catch(err => that.closeFunction());
      this.common.closeModal();
    }
  }

  suiteSupprimerBon() {
    this.closeFunction();
  }

  // synchroniser modification planning chauffeur sur sygetrack
  setPlanifDI() {
    const ctrl = this;
    this.common.openModal(this.modalService, this.loadingSygetrack);
    // if (this.common.isCLS()) {
    //   return GestionSygetrack.setPlanifDICLS(this.resourceSygetrack, false, this.common).then(datas => {
    //     if (datas.data && datas.data['erreur']) {
    //       this.setMsgSygetrack(datas.data['erreur'])

    //       // Pour debug
    //       if (datas.data['url']) {
    //         console.log('URL CLS SET_PLANIF / DEL_PLANIF : ' + datas.data['url']);
    //       }
    //     } else {
    //       this.closeSygetrack();
    //     }
    //   });
    // } else {
    return GestionSygetrack.setPlanifDI(this.resourceSygetrack, false, this.common).then(datas => {
      if (datas.data && datas.data['erreur']) {
        this.setMsgSygetrack(datas.data['erreur'])

        // Pour debug
        if (datas.data['url']) {
          console.log('URL SYGETRACK SET_PLANIF / DEL_PLANIF : ' + datas.data['url']);
        }
      } else {
        this.closeSygetrack();
      }
    });
    // }
  }

  checkRetraitBenne() {
    const BenneData = this.newprest['contenant'];
    BenneData.nomclass = 'BenneData';

    const param = {
      'servlet': 'DBCheckRetraitBenne',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'leger': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'BENNE_CHANTIER': BenneData,
        'CLEF_BON': {
          'typeParam': 'int',
          'valeur': this.info['bonSelected'] ? (this.info['bonSelected'].id || 0) : 0
        },
        'CLEF_OPERATION': {
          'typeParam': 'int',
          'valeur': this.newprest['typeOperation'] ? (this.newprest['typeOperation'].id || 0) : 0
        },
      }
    };

    return this.common.post('', { param: param });
  }

  getListeSite() {
    this.listeSite = this.common.getType('tousSite') || [];
    this.isShowSite = this.listeSite.length > 1 ? true : false;
    console.log(this.listeSite.length);
    this.listeSite.forEach(elt => {
      if (elt.id === this.common.user[2]) {
        this.defaultSite = elt;
        this.defaultSiteCA = elt;
      }
    });
  }

  searchSite(event) {
    this.listeSiteCA = [];
    this.listeSite.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
      this.listeSiteCA.push(elt);
    });
  }

  changeProgram() {
    this.mouvBenneProgramme['typeProgram'] = this.listProgram[1];
    this.mouvBenneProgramme['frequence'] = 1;
    this.mouvBenneProgramme['typeOperation'] = 1;
    this.mouvBenneProgramme['listTtSemaine'] = [];
    this.mouvBenneProgramme['listSemainePaire'] = [];
    this.mouvBenneProgramme['listSemaineImpaire'] = [];
    this.mouvBenneProgramme['listJoursMois'] = [];
    this.mouvBenneProgramme['listJoursMois1'] = [];
    this.mouvBenneProgramme['listJoursMois2'] = [];
    this.mouvBenneProgramme['listJoursMois3'] = [];
    this.mouvBenneProgramme['listJoursMois4'] = [];
    this.mouvBenneProgramme['listJoursMois5'] = [];
    this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
    if (this.newprest['program']) {
      this.showProgrammation();
    }
  }

  changeDatePgm(event) {
    if (moment(event).isValid()) {
      this.mouvBenneProgramme['dateFin'] = moment(event).format('DD/MM/YYYY');
    } else {
      this.mouvBenneProgramme['dateFin'] = !this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '' ?
        '31/12/9999' : moment().format('DD/MM/YYYY');
    }
  }

  changeDateDmD(date, event) {
    if (moment(event).isValid()) {
      this.newprest[date] = moment(event).format('DD/MM/YYYY');
    } else {
      this.newprest[date] = moment().format('DD/MM/YYYY');
    }
  }

  openModalConfirme() {
    this.DBCheckContrat().then(res => {
      if (res) {
        const societe = this.common.local.getObject('paramSociete') || {};

        if (societe.ecobennesEquipe && this.newprest['program'] && !this.newprest['tournee']) {
          this.common.openModal(this.modalService, this.programConfirme);
        } else {
          this.saveMouvement();
        }
      }
    });

  }

  saveMouvement() {
    if (this.newprest['program'] && !this.modifProgram()) {
      this.error = 'Il faut sélectionner au moins un jour.';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (!this.isVidage && this.isModifDateVidage && !this.isReport) {
      this.common.openModal(this.modalService, this.changedateBon);
      return;
    }

    this.validerUpdateContenant();
  }

  changeFrequence() {
    if (this.mouvBenneProgramme['nbSemainesProgram'] === '2') {
      this.mouvBenneProgramme['frequence'] = 1;
    }
  }

  showJourFerie() {
    this.isJourFerie = !this.isJourFerie;
  }

  saveJourFerier(event) {
    this.mouvBenneProgramme['tableConfigJoursFeries'] = event;
  }

  showSuspension() {
    this.isSuspension = !this.isSuspension;
  }

  saveSuspension(event) {
    this.mouvBenneProgramme['listePeriodesPause'] = event;
  }

  savePeriodePgm(event) {
    this.mouvBenneProgramme = event;
    console.log('test mvt', this.mouvBenneProgramme)
  }

  selectContenantForGroup(elem) {
    const listfilter = this.listBenneSelected.filter(elt => parseInt(elt.id, 10) === parseInt(elem.id, 10));
    if (listfilter.length) {
      let index;
      this.listBenneSelected.forEach((elt, idx) => {
        if (parseInt(elt.id, 10) === parseInt(elem.id, 10)) {
          index = idx;
          if (elt.operationBenne) {
            elt.operationBenne.id = elt.operationBenne.id || 0;
            elt.operationBenne.libelleObjetEntite = elt.operationBenne.libelleObjetEntit || this.operationBenneGroupeLibelle(elt.operationBenne.id);
          }
        }
      });
      // const index = list.indexOf('' + 5);
      this.listBenneSelected.splice(index, 1);
      this.listBenneSelected = [...this.listBenneSelected];
    } else {
      this.listBenneSelected.push(elem);
      this.listBenneSelected = [...this.listBenneSelected];
    }

    this.searchGroupeContenantChoix()
  }


  selectedContenant(elem) {
    this.listBenneSelected = this.listBenneSelected || [];
    const listfilter = this.listBenneSelected.filter(elt => parseInt(elt.id, 10) === parseInt(elem.id, 10));
    return listfilter.length ? true : false;
  }

  setGroupeBenne() {
    console.log('set', this.listBenneSelected)
    this.listBenneSelected.forEach(benne => {
      if (benne['isGroupeArticle']) {
        if ((benne['listArticle'] && benne['listArticle'].length)) {
          benne['listArticles'] = [];
          benne['listArticle'].forEach(elt => {
            const art = Object.assign({}, elt.art);
            art.exu = Object.assign({}, elt.exutoire);
            art.qtePrevisionnelle = (elt.qte || 0)
            art.nomclass = 'Article';
            art.axeAnalytiqueLigneArticle = elt.axeAnalytiqueLigneArt || '';
            benne['listArticles'].push(art);
          });
        }
      }
    });
    if (!this.isDmdEcoGED) {
      if (!this.deposerContenant) {
        if (this.listBenneSelected.length) {
          this.listcontenant.forEach(elt => {
            this.listBenneSelected.forEach(selected => {
              if (elt.id === selected.id) {
                elt.isChecked = selected.isChecked;
              }
            })
          })
          // this.listBenneSelected = this.listcontenant.filter(elt => elt.isChecked);
          this.listBenneSelected.forEach(benne => {
            if (benne.operationBenne) {
              benne.operationBenne.id = benne.operationBenne.id || 0;
              benne.operationBenne.libelleObjetEntite = benne.operationBenne.libelleObjetEntit || this.operationBenneGroupeLibelle(benne.operationBenne.id);
            }
            if (benne['isGroupeArticle'] && !benne['listArticles']) {
              if (benne.id > 0) {
                this.getListArticleGrp(benne.id, true).then(data => {
                  benne.listArticles = data;
                })
              }
            }
          })

          if (this.isCreateWithBtn && this.isGroupe) {
            this.newprest['newContenant'] = true;
          }

          if (this.newprest['newContenant']) {
            const benneIndex0 = Object.assign({}, this.listBenneSelected[0]);
            // benneIndex0['id'] = 0;
            this.contenantGoupe = {
              id: 0,
              art: benneIndex0['art'],
              typeContenant: benneIndex0['typeContenant'],
            };
            this.contenantGoupe['listBennes'] = this.listBenneSelected;
            this.contenantGoupe['isGroupeBenne'] = true;
            if (benneIndex0['isGroupeArticle']) {
              this.getListArticleGrp(benneIndex0.id, true).then(data => {
                this.contenantGoupe['art'] = data && data.length ? data[0] : { id: 0 };
                this.setValue(this.contenantGoupe, 'newBenne');
              })

            } else {
              this.setValue(this.contenantGoupe, 'newBenne');
            }

          } else {
            this.contenantGoupe = this.newprest['contenant'];
            this.newprest['contenant']['listBennes'] = this.listBenneSelected;
            // this.setValue(this.contenantGoupe, 'contenant');

            if (this.edit) {
              this.showLeft = false;
              this.isModifier = true;
              setTimeout(function () {
                $('#btnvalider').focus();
              }, 500);
            } else {
              if (this.modifierGroupe) {
                this.modifierGroupe = !this.modifierGroupe;
                return false;
              }
              if (this.editContenant) {
                this.step = 5;
              } else {
                this.nextStep();
              }
            }
          }
        }
      } else {
        if (!this.contenantDepot.typeContenant || (this.contenantDepot.typeContenant && !this.contenantDepot.typeContenant.id)) {
          this.error = `Vous devez sélectionner un type de contenant`;
          this.common.openModal(this.modalService, this.msg);
        }
        if (this.isCreateWithBtn && this.isGroupe) {
          this.newprest['newContenant'] = true;
        }

        if (this.contenantDepot.typeContenant && this.contenantDepot.typeContenant.id &&
          this.contenantDepot.art && this.contenantDepot.art.id) {
          this.deposerContenant = !this.deposerContenant;
          console.log(this.contenantDepot);
          this.contenantDepot.isChecked = true;
          this.listcontenant = this.listcontenant || [];
          this.contenantDepot['id'] = -1 * (this.listcontenant.length + 1);
          this.listcontenant.push(this.contenantDepot);
          this.listBenneSelected.push(this.contenantDepot);
          this.listContDepot.push(this.contenantDepot);
          if (this.newprest['newContenant']) {
            const benneIndex0 = Object.assign({}, this.listBenneSelected[0]);
            this.contenantGoupe = {
              id: 0,
              art: benneIndex0['art'],
              typeContenant: benneIndex0['typeContenant'],
            };
            this.contenantGoupe['listBennes'] = this.listBenneSelected;
            this.contenantGoupe['isGroupeBenne'] = true;
          } else {
            this.contenantGoupe = this.newprest['contenant'];
            this.newprest['contenant']['listBennes'] = this.listBenneSelected;
          }

          setTimeout(function () {
            $('.btn-ok').focus();
          }, 500);
        }

      }
    } else {
      if (this.editContenant) {
        this.step = 5;
      } else {
        this.nextStep();
      }
    }

  }

  modifContenantForGroup(item) {
    this.modifContenantGrp = true;
    this.selectedContenantGrp = Object.assign({}, item);
    const elt = this.selectedContenantGrp.typeContenant || {};
    elt.libelleObjetEntite = (elt.famille.libelle ? elt.famille.libelle + ' ' : '')
      + (elt.cubage.cubage ? (elt.cubage.cubage || 0) + ' ' : '')
      + (elt.uniteCont.libelle ? elt.uniteCont.libelle : '');

    if (this.selectedContenantGrp.art) {
      this.selectedContenantGrp.art.libelleObjetEntite = this.selectedContenantGrp.art.libelleObjetEntite ||
        (this.selectedContenantGrp.art.code + '/' + this.selectedContenantGrp.art.libelle);
    }

    if (this.selectedContenantGrp && this.selectedContenantGrp.isGroupeArticle) {

      this.selectedContenantGrp.listArticles = this.selectedContenantGrp.listArticles || [];
      if ((!this.selectedContenantGrp.listArticle || (this.selectedContenantGrp.listArticle && !this.selectedContenantGrp.listArticle.length)) && this.selectedContenantGrp.listArticles.length) {
        this.selectedContenantGrp.listArticle = [];
        this.selectedContenantGrp.listArticles.forEach(elt => {
          const art = {};
          art['art'] = Object.assign({}, elt);
          art['exutoire'] = Object.assign({}, elt.exu);
          art['qte'] = (elt.qtePrevisionnelle || 0);
          art['axeAnalytiqueLigneArt'] = elt.axeAnalytiqueLigneArticle || '';
          this.selectedContenantGrp.listArticle.push(art);
        });
        console.log(this.selectedContenantGrp.listArticle)
      }
    }

    if (this.selectedContenantGrp['isLocation']) {
      this.selectedContenantGrp['dateDebutLocModel'] = this.common.parseDate(this.selectedContenantGrp['dateDebutLoc'] || '01/01/2000');
    }

    console.log(this.selectedContenantGrp);
  }

  validerModifcontenantGroupe() {
    if ((this.selectedContenantGrp['isGroupeArticle'] && (!this.selectedContenantGrp['listArticle'] || (this.selectedContenantGrp['listArticle'] && !this.selectedContenantGrp['listArticle'].length)))
      || (!this.selectedContenantGrp['isGroupeArticle'] && (!this.selectedContenantGrp['art'] || (this.selectedContenantGrp['art'] && !this.selectedContenantGrp['art'].id)))) {
      this.error = 'Votre groupe d\'article doit comporter au moins un article.';
      this.common.openModal(this.modalService, this.msg);
    } else {

      this.modifContenantGrp = false;
      // this.selectedContenantGrp = Object.assign({}, item);
      const listBenneSelected = [];
      if (this.selectedContenantGrp['isLocation']) {
        this.selectedContenantGrp['dateDebutLoc'] = this.selectedContenantGrp['dateDebutLocModel'] ? moment(this.selectedContenantGrp['dateDebutLocModel']).format('DD/MM/YYYY') : '01/01/2000';
      }

      this.listBenneSelected.forEach(elt => {
        if (this.selectedContenantGrp && elt.id === this.selectedContenantGrp['id']) {
          listBenneSelected.push(this.selectedContenantGrp)
        } else {
          listBenneSelected.push(elt)
        }
      })
      this.listBenneSelected = [...listBenneSelected]
      console.log(this.listBenneSelected, this.selectedContenantGrp);
    }
  }

  getTournee(event) {
    const clefMvt = this.info['mouvement'] ? this.info['mouvement'].id : 0
    const param = {
      'servlet': 'DBGestionTournee',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'leger': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'OPTIMISATIONS': {
          'IS_CHARGER_CONTENANTS': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_MOUVEMENTS': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_BON_COMPLET': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_TOUS_BONS': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_CLIENT_COMPLET': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_SITE_COMPLET': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_CLIENT_COMPLET_CONTENANT': {
            'typeParam': 'boolean',
            'valeur': false
          },
          'IS_CHARGER_INFO_EQUIPE': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_PROGRAM_COMPLET': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_PRESENCE_MOUVEMENTS': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'IS_CHARGER_NB_CONTENANT': {
            'typeParam': 'boolean',
            'valeur': true
          },
          'CLEF_MOUVEMENT': {
            'typeParam': 'int',
            'valeur': clefMvt || 0
          },
          // 'CRITERE': event || '',
        }
      }
    };
    if (event) {
      param.data['CLEF_TOURNEE'] = {
        'typeParam': 'int',
        'valeur': event
      };
    }

    return this.common.post('', { param: param }, true).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          this.detailTournee = datas.data || {};
          this.newprest['tournee'] = Object.assign({}, datas.data || this.newprest['tournee']);
          const isProgram = this.newprest['tournee']['program'] ? true : false;
          if (isProgram) {
            this.newprest['program'] = true;
            this.getMouvProgramTournee(this.newprest['tournee']['program'].id);
          }
          this.newprest['tournee'].listeMouvements = this.newprest['tournee'].listeMouvements || [];
          // this.newprest['program'] = this.detailTournee['program'] ? true : false;
          this.newprest['tournee'].listeMouvements.forEach(elt => {
            console.log(elt);
            if (this.info['mouvement'] && elt.id === this.info['mouvement'].id) {
              this.newprest['chauffeur'] = elt['chauffeur'] || {};
              this.newprest['listePersonnelParPoste'] = Object.assign([], elt['listePersonnelParPoste'] || []);
              this.newprest['mouvement'] = Object.assign({}, elt);
              if (elt['periode']) {
                const p = this.remplirDetailPeriode(parseInt(elt['periode'], 10), elt['periode']);
                this.newprest['periode'] = p;
                this.defaultPeriode = p;
              }
              if (elt['camion']) {
                this.newprest['camion'] = elt['camion'];
                this.defaultCamion = elt['camion'];
              }

              this.newprest['hourDuree'] = Math.floor(parseFloat(elt['duree']));
              this.newprest['minDuree'] = Math.round((parseFloat(elt['duree']) - parseInt(this.newprest['hourDuree'], 10)) * 60);
              this.newprest['hourDuree'] = this.newprest['hourDuree'] === 0 ? '00' : this.newprest['hourDuree'];
              this.newprest['minDuree'] = this.newprest['minDuree'] === 0 ? '00' : this.newprest['minDuree'];
            }
          });
          this.newprest['modeEquipe'] = this.newprest['tournee'].modeEquipe || false;
          this.parseMouvement();
        }
      }
    });
  }

  getMouvProgramTournee(clefPgm) {
    const param = {
      'servlet': 'DBGetMouvProgram',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetMouvProgram', '' + clefPgm]
    };
    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.mouvBenneProgramme = datas.data ? datas.data[2] : {};
        this.mvtProgrammeTournee();
      }
    });
  }

  mvtProgrammeTournee() {
    if (this.mouvBenneProgramme['id']) {
      if (this.mouvBenneProgramme['typeOperation']) {
        this.listProgram.forEach(elt => {
          if (elt.id === this.mouvBenneProgramme['typeOperation']) {
            this.mouvBenneProgramme['typeProgram'] = elt;
          }
        });
      } else {
        this.mouvBenneProgramme['typeProgram'] = this.listProgram[1];
      }
      if (this.mouvBenneProgramme['dateFin']) {
        this.mouvBenneProgramme['editDate'] = true;
        if (this.mouvBenneProgramme['dateFin'] !== '01/01/1970 00:00:00') {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate(moment((this.mouvBenneProgramme['dateFin']),
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        } else {
          this.mouvBenneProgramme['datePgm'] = this.common.parseDate('31/12/9999');
        }
      }
      this.mouvBenneProgramme['nbSemainesProgram'] = '' + (this.mouvBenneProgramme['nbSemainesProgram'] || 1);
      this.mouvBenneProgramme['frequence'] = this.mouvBenneProgramme['frequence'] || 0;
      this.mouvBenneProgramme['listTtSemaine'] = [];
      this.mouvBenneProgramme['listSemainePaire'] = [];
      this.mouvBenneProgramme['listSemaineImpaire'] = [];
      this.mouvBenneProgramme['listJoursMois'] = [];
      this.mouvBenneProgramme['listJoursMois1'] = [];
      this.mouvBenneProgramme['listJoursMois2'] = [];
      this.mouvBenneProgramme['listJoursMois3'] = [];
      this.mouvBenneProgramme['listJoursMois4'] = [];
      this.mouvBenneProgramme['listJoursMois5'] = [];
      this.mouvBenneProgramme['listJoursDerSemaineMois'] = [];
      this.mouvBenneProgramme['listePeriodesPause'] = this.mouvBenneProgramme['listePeriodesPause'] || [];
      this.mouvBenneProgramme['typeOperation'] = this.mouvBenneProgramme['typeOperation'] || 0;
      switch (this.mouvBenneProgramme['typeOperation']) {
        case 0:
          if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
            this.mouvBenneProgramme['listTtSemaine'] = this.mouvBenneProgramme['listJours'] || [];
          } else {
            this.mouvBenneProgramme['listSemainePaire'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
            this.mouvBenneProgramme['listSemaineImpaire'] = this.mouvBenneProgramme['listJours'] || [];
          }
          break;
        case 1:
          this.mouvBenneProgramme['listJoursMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
        case 2:
          this.mouvBenneProgramme['listJoursMois1'] = this.mouvBenneProgramme['listJours'] || [];
          this.mouvBenneProgramme['listJoursMois2'] = this.mouvBenneProgramme['listJoursSemaine2'] || [];
          this.mouvBenneProgramme['listJoursMois3'] = this.mouvBenneProgramme['listJoursSemaine3'] || [];
          this.mouvBenneProgramme['listJoursMois4'] = this.mouvBenneProgramme['listJoursSemaine4'] || [];
          this.mouvBenneProgramme['listJoursMois5'] = this.mouvBenneProgramme['listJoursSemaine5'] || [];
          break;
        case 3:
          this.mouvBenneProgramme['listJoursDerSemaineMois'] = this.mouvBenneProgramme['listJours'] || [];
          break;
      }
      this.tempMvtProgramme = Object.assign({}, this.mouvBenneProgramme);

    }
  }

  createObjtMvtBennePgmTournee() {
    if (this.mouvBenneProgramme['tableConfigJoursFeries']) {
      this.mouvBenneProgramme['tableConfigJoursFeries'].forEach(elt => {
        if (elt.configJourFerie) {
          elt.configJourFerie.rattrapageLendemain = elt.configJourFerie.rattrapageLendemain || false;
        }
      });
    }
    const mouv = {
      id: this.mouvBenneProgramme['id'] || 0,
      typeOperation: this.mouvBenneProgramme['typeOperation'],
      frequence: this.mouvBenneProgramme['frequence'],
      tableConfigJoursFeries: this.mouvBenneProgramme['tableConfigJoursFeries'],
      listePeriodesPause: this.mouvBenneProgramme['listePeriodesPause'],
      nomclass: 'MouvementBenneProgramme',
    };
    switch (this.mouvBenneProgramme['typeOperation']) {
      case 0:
        mouv['nbSemainesProgram'] = this.mouvBenneProgramme['nbSemainesProgram'];
        if (this.mouvBenneProgramme['nbSemainesProgram'] === '1') {
          mouv['listJours'] = this.mouvBenneProgramme['listTtSemaine'] || [];
        } else {
          // mouv['listJours'] = this.mouvBenneProgramme['listSemainePaire'] || [];
          // mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJours'] = this.mouvBenneProgramme['listSemaineImpaire'] || [];
          mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listSemainePaire'] || [];
        }
        break;
      case 1:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois'] || [];
        break;
      case 2:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursMois1'] || [];
        mouv['listJoursSemaine2'] = this.mouvBenneProgramme['listJoursMois2'] || [];
        mouv['listJoursSemaine3'] = this.mouvBenneProgramme['listJoursMois3'] || [];
        mouv['listJoursSemaine4'] = this.mouvBenneProgramme['listJoursMois4'] || [];
        mouv['listJoursSemaine5'] = this.mouvBenneProgramme['listJoursMois5'] || [];
        break;
      case 3:
        mouv['listJours'] = this.mouvBenneProgramme['listJoursDerSemaineMois'] || [];
        break;
    }

    if (this.mouvBenneProgramme['editDate']) {
      console.log(this.mouvBenneProgramme['datePgm'])
      if (this.mouvBenneProgramme['dateFin']) {
        this.mouvBenneProgramme['datePgm'] = this.common.parseDate(this.mouvBenneProgramme['dateFin']);
      }
      if (this.mouvBenneProgramme['datePgm'] && typeof this.mouvBenneProgramme['datePgm'] === 'string' &&
        this.mouvBenneProgramme['datePgm'].match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)) {
        mouv['dateFin'] = this.mouvBenneProgramme['datePgm'];
      } else {
        if (moment(this.mouvBenneProgramme['datePgm']).isValid()) {
          mouv['dateFin'] = moment(this.mouvBenneProgramme['datePgm']).format('DD/MM/YYYY');
        }
        if (!this.mouvBenneProgramme['datePgm'] || this.mouvBenneProgramme['datePgm'] === '') {
          mouv['dateFin'] = '31/12/9999';
        }
      }
    }

    return mouv;
  }

  editMvtTourne() {
    const heure = this.hourMvt();
    const objEquipe = this.objMvtEquipe();
    const tourne = Object.assign({}, this.detailTournee);
    tourne.nomclass = 'Tournee';
    const sitePrest = this.isShowSite ? (this.newprest['sitePrest'] ? this.newprest['sitePrest'].id
      : this.common.user[2]) : this.common.user[2];
    const siteCA = this.isShowSite ? (this.newprest['siteCA'] ? this.newprest['siteCA'].id
      : this.common.user[2]) : this.common.user[2];
    const isProgram = (tourne.program && tourne.program.id > 0) ||
      (tourne.clefProgram && (tourne.clefProgram !== '' || tourne.clefProgram !== '0')) ? true : false;
    this.detailTournee['listeMouvements'].forEach(elt => {
      elt.tournee = {
        id: tourne.id,
        nomclass: 'Tournee'
      };
      elt.nomclass = 'Mouvement';
      if (this.info['mouvement'] && elt.id === this.info['mouvement'].id) {
        // sarobidy
        elt.dateEnlevement = moment(this.newprest['dateStart']).format('YYYY-MM-DD');
        elt.heure = heure;
        elt.operation = (this.newprest['typeOperation'] ? this.newprest['typeOperation'].id : '0'); // choix operation
        elt.exutoire = {
          id: '' + (this.newprest['exutoire'] ? (this.newprest['exutoire'].id || '0') : '0')
        };
        elt.clefSitePrest = sitePrest;
        elt.sitePrestation = {
          id: sitePrest
        };
        elt.clefSiteCA = siteCA;
        elt.siteCA = {
          id: siteCA
        };
        elt.majContenant = true;
        elt.listBenne = this.detailTournee['listeContenants'] || [];
        if (this.isChoixCamionCreationMouv) {
          elt.camion = {
            id: '' + (this.newprest['camion'] ? (this.newprest['camion'].id || '0') : '0')
          };
          elt.periode = {
            id: '' + (this.newprest['periode'] ? (this.newprest['periode'].id || '0') : '0')
          };
        }
        elt.chauffeur = this.societe['ecobennesEquipe'] ? (this.newprest['modeEquipe'] ?
          this.objEquipe['chauffeur'] || { id: 0 } : { id: 0 }) : (this.objEquipe['chauffeur'] || { id: 0 });
        elt.listePersonnelParPoste = this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPosteMvt'] || [] : [];
      }
      if (this.detailTournee['program'] && this.updateAll) {
        const dateEnlevement = moment(elt.dateEnlevement, 'YYYY-MM-DD');
        if (moment(dateEnlevement).isSameOrAfter(moment())) {
          if (!elt.horsProgram && this.newprest['modeEquipe']) {
            elt.chauffeur = this.societe['ecobennesEquipe'] ? (this.newprest['modeEquipe'] ?
              this.objEquipe['chauffeur'] || { id: 0 } : { id: 0 }) : (this.objEquipe['chauffeur'] || { id: 0 });
            elt.listePersonnelParPoste = this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPosteMvt'] || [] : [];
          }
        }
      }
      elt.user = '' + this.common.user[0];
    });
    const param = {
      'servlet': 'DBGestionTournee',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 6
        },
        'CLEF_TOURNEE': {
          'typeParam': 'int',
          'valeur': this.detailTournee['id']
        },
        'LISTE_MOUVEMENTS': this.detailTournee['listeMouvements'],
        'USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'IS_ANGULAR': {
          'typeParam': 'boolean',
          'valeur': true
        },
      }
    };

    if (this.detailTournee['program']) {
      param.data['PROGRAM'] = this.createObjtMvtBennePgm();
      // this.detailTournee['program'].nomclass = 'MouvementBenneProgramme';
      // param.data['PROGRAM'] = this.detailTournee['program'] || {};
      param.data['ACTUALISER_PROGRAM'] = {
        'typeParam': 'boolean',
        'valeur': true
      };
    }

    if (this.societe['ecobennesEquipe']) {
      this.detailTournee['nomclass'] = 'Tournee';
      this.detailTournee['modeEquipe'] = this.newprest['modeEquipe'];
      this.detailTournee['qualificationLeader'] = this.newprest['modeEquipe'] ?
        this.objEquipe['qualificationLeader'] || { id: 0 } : { id: 0 };
      this.detailTournee['leaderEquipe'] = this.newprest['modeEquipe'] ? this.objEquipe['leaderEquipe'] || { id: 0 } : { id: 0 };
      this.detailTournee['listePostes'] = this.newprest['modeEquipe'] ? objEquipe['listePostes'] || [] : [];
      this.detailTournee['equipeDefinie'] = this.newprest['modeEquipe'] ? (objEquipe['listePostes'].length ? true : false) : false;
      this.detailTournee['listePersonnelParPoste'] = this.newprest['modeEquipe'] ? objEquipe['listePersonnelParPoste'] || [] : [];
      param.data['TOURNEE'] = this.detailTournee;
    }

    // console.log(JSON.stringify(param))
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.updateClientChantier(true);
      }
    });
  }

  findCouleur() {
    if (this.info['listContenantTournee'] && this.info['listContenantTournee'][0]) {
      const artPAV = this.info['listContenantTournee'][0].art;
      return artPAV.couleurPAV || '#1eafba';
    }
  }

  toogleSlideTournee() {
    this.isAddContTournee = !this.isAddContTournee;
  }

  addContenantTournee(event) {
    this.detailTournee['listeContenants'].push(event);
    this.detailTournee['listeContenants'] = [...this.detailTournee['listeContenants']];
  }

  deleteLigne(item) {
    this.detailTournee['listeContenants'] = this.detailTournee['listeContenants'].filter(elt => elt !== item);
  }

  saveContenantTournee(idBenneData, operation) {
    this.detailTournee['nomclass'] = 'Tournee';
    const param = {
      'servlet': 'DBGestionTournee',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'TOURNEE': this.detailTournee,
        'CLEF_BENNE': {
          'typeParam': 'int',
          'valeur': idBenneData
        },
        'ACTUALISER_BON_MOUVEMENTS': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'OP_LISTE': {
          'typeParam': 'int',
          'valeur': operation
        },
      }
    };

    return this.common.post('', { param: param });
  }

  getLogs(n) {
    if (this.info['bon'] && this.info['bon'].id) {
      this.common.getLogs(this.info['bon'].id, '43', this.modalService);
    } else if (n['listBon'].length > 0) {
      let isExiste = false;
      n['listBon'].forEach(elt => {
        if (!isExiste && this.info['bonSelected'] && elt.id === this.info['bonSelected'].id) {
          isExiste = true;
          this.common.getLogs(n['listBon'][0].id, '43', this.modalService);
        }
      });
    }
  }

  addContenantDepot() {
    this.contenantDepot = { qteContenant: 1, operationBenne: { id: 0, libelleObjetEntite: 'Dépot' } };

    setTimeout(function () {
      $('.operationBac').click();
    }, 550);
  }

  getListTypeCont() {
    const param = {
      'servlet': 'DBGetListTypCont',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['']
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas) && datas.data != null) {
        this.listTypeContDepot = [];
        datas.data.forEach(elt => {
          // if (elt.famille && elt.famille.bac) {
          elt.libelleObjetEntite = (elt.famille.libelle ? elt.famille.libelle + ' ' : '')
            + (elt.cubage.cubage ? elt.cubage.cubage : '')
            + (elt.uniteCont.libelle ? elt.uniteCont.libelle : '');
          this.listTypeContDepot.push(elt);
          // }
        });

      }
    });
  }

  searchArticleDepot(event, grp?) {
    // const param = 14;

    const param = this.societe['gestionFIP'] && this.societe['isFIPCET'] && this.societe['compteGoodflag'] ? 57 : 14;
    const tab = this.societe['gestionFIP'] && this.societe['isFIPCET'] && this.societe['compteGoodflag'] ? [{
      nom: 'CLEF_CLIENT', valeur: {
        'typeParam': 'int',
        'valeur': this.newprest.client && this.newprest.client.id ? this.newprest.client.id : 0
      }
    },
    {
      nom: 'CLEF_CHANTIER', valeur: {
        'typeParam': 'int',
        'valeur': this.newprest.chantier && this.newprest.chantier.id ? this.newprest.chantier.id : 0
      }
    }] : [];


    return this.common.appelComboK3Fct(param, event, tab).then(datas => {
      $('.articleCont').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataArticleDepot = datas.data;
      }
    });
  }

  showFacturation() {
    if (this.modifContenantGrp) {
      this.contenantFact = this.selectedContenantGrp;
    } else {
      if (this.newprest['newContenant']) {
        if (this.isEditChantier) {
          this.contenantFact = this.newprest['newBenne'];
        } else {
          this.contenantFact = this.newBenne;
        }
      } else {
        this.contenantFact = this.newprest['contenant'];
      }
    }

    this.isClickFacturation = !this.isClickFacturation;
  }

  saveLocationFact(event) {
    console.log('test', this.contenantFact);
    console.log('test event', event);
  }

  addArticlesNewBenne() {
    this.selactedArticle = { add: true };
    this.actualiseAxeAnaArticle(this.selactedArticle);
    this.newBenne['listArticle'] = this.newBenne['listArticle'] || [];

    this.newBenne['listArticle'].push(this.selactedArticle);
    const index = this.newBenne['listArticle'].length - 1;
    setTimeout(function () {
      $('.articlegrp').focus();
    }, 650);
  }


  addArticlesContenant() {
    this.selactedArticle = { add: true };
    this.actualiseAxeAnaArticle(this.selactedArticle);
    if (this.newprest['contenant']) {
      this.newprest['contenant'].listArticle = this.newprest['contenant'].listArticle || [];

      this.newprest['contenant'].listArticle.push(this.selactedArticle);
      const index = this.newprest['contenant'].listArticle.length - 1;
      setTimeout(function () {
        $('.articlegrp').focus();
      }, 650);
    }
  }

  addArticlesContenantGrp() {
    this.selactedArticle = { add: true };
    this.actualiseAxeAnaArticle(this.selactedArticle);
    if (this.selectedContenantGrp) {
      this.selectedContenantGrp.listArticle = this.selectedContenantGrp.listArticle || [];

      this.selectedContenantGrp.listArticle.push(this.selactedArticle);
      const index = this.selectedContenantGrp.listArticle.length - 1;
      setTimeout(function () {
        $('.articlegrp').focus();
      }, 650);
    }
  }

  addArticlesNewprest() {
    this.selactedArticle = { add: true };
    this.actualiseAxeAnaArticle(this.selactedArticle);
    if (this.newprest['newBenne']) {
      this.newprest['newBenne'].listArticle = this.newprest['newBenne'].listArticle || [];

      this.newprest['newBenne'].listArticles.push(this.selactedArticle);
      const index = this.newprest['newBenne'].listArticles.length - 1;
      setTimeout(function () {
        $('.articlegrp').focus();
      }, 650);
    }
  }

  deleteListArticles(listArticles, item) {
    const index = listArticles.indexOf(item);
    if (index > -1) {
      listArticles.splice(index, 1);
    }
  }


  showArticleGrp() {
    this.listArticle = [];
    this.addArticle = !this.addArticle;
    if (this.addArticle) {
      if (this.selactedArticle.art) {
        this.selactedArticle.art.libelleObjetEntite = this.selactedArticle.art.libelleObjetEntite ||
          (this.selactedArticle.art.code + '/' + this.selactedArticle.art.libelle);
      }

      this.selactedArticle['axeAnalytiqueLigneArt'] = this.selactedArticle['axeAnalytiqueLigneArt'] || '';
      if (!this.selactedArticle['axeAnalytiqueLigneArt']) {
        this.actualiseAxeAnaArticle(this.selactedArticle, this.selactedArticle.art);
      }
    }
  }


  modifierLeContenant() {
    this.isModifierLeContenant = true;
    this.afficherAutreStep = false;
  }

  supprimerLeGroupe() {
    // this.common.openModal(this.modalService, this.dialogueConfirmSuppresionGroupe);
    this.appelDBGetMouvGroup();
  }

  appelDBGetMouvGroup() {
    const param = {
      'servlet': 'DBGetMouvGroup',
      'module': 'Ecobennes',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'string',
        'valeur': '' + this.benneId
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (datas.data && datas.data === 'OK') {
        this.common.openModal(this.modalService, this.dialogueConfirmSuppresionGroupe);
      } else {
        this.error = `Vous ne pouvez pas d\u00e9grouper tant que le bon "${datas.data}" n'a pas \u00e9t\u00e9 valid\u00e9.`;
        this.common.openModal(this.modalService, this.msg);
      }
    });
  }

  onClickOkSupprimeGroupe() {
    const param = {
      'servlet': 'DBSuppGroupeBennes',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_BENNE': {
          'typeParam': 'int',
          'valeur': this.benneId
        }
      }
    };
    return this.common.post('', { param: param });
  }

  saveModifContenant() {
    this.benneChantier = this.newprest['contenant'];
    this.benneChantier['qteContenant'] = this.benneChantier['qteContenant'] ? parseInt(this.benneChantier['qteContenant'], 10) : 1;
    const isClient = this.newprest['client'] && this.newprest['client'].id ? true : false;
    const isChantier = this.newprest['chantier'] && this.newprest['chantier'].id ? true : false;
    const isArticle = this.benneChantier['isGroupeArticle'] ? true : (this.benneChantier['art'] && this.benneChantier['art'].id ? true : false);
    const isExutoire = this.newprest['exutoire'] && this.newprest['exutoire'].id ? true : false;
    const isTypecont = this.benneChantier['typeContenant'] && this.benneChantier['typeContenant'].id ? true : false;
    const isGoupe = this.benneChantier['isGroupeBenne'] || false;
    const listBennes = this.benneChantier['listBennes'] || [];

    if (this.benneChantier['isGroupeArticle'] && !this.benneChantier['listArticle'].length) {
      this.error = 'Votre groupe d\'article doit comporter au moins un article.';
      this.isClicked = false;
      this.showSpinner = false;
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (!this.benneChantier['isGroupeArticle'] && this.benneChantier['art']) {
      this.benneChantier['art'].qtePrevisionnelle = this.benneChantier['qte'] || 0;
    }

    if (this.benneChantier['listArticle']) {
      this.benneChantier['listArticles'] = [];
      this.benneChantier['listArticle'].forEach(elt => {
        const art = Object.assign({}, elt.art);
        art.exu = Object.assign({}, elt.exutoire);
        art.qtePrevisionnelle = (elt.qte || 0)
        art.nomclass = 'Article';
        art.axeAnalytiqueLigneArticle = elt.axeAnalytiqueLigneArt || '';
        this.benneChantier['listArticles'].push(art);
      });
    }

    if (this.benneChantier['listBennes']) {
      this.benneChantier['listBennes'].forEach(elt => {
        if (elt.id < 0) {
          elt.id = 0;
        }
        elt.nomclass = 'BenneData';
        elt.operation = elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2';
        elt.operationBenne = {
          id: elt.operationBenne ? (elt.operationBenne['id'] || '2') : '2'
        };
      });
    }
    this.showSpinner = true;
    this.updateBenneChantier(true).then(dat => {
      // this.updateClientChantier(true);
      this.closeFunction();
    }).catch(err => this.showSpinner = false)
  }

  focustimeOut(elt) {
    const ctrl = this;

    setTimeout(function () {
      ctrl.common.focusElement(elt)
    }, 550);
  }

  showProgrammation() {
    if (this.newprest['program']) {
      this.isProgrammation = !this.isProgrammation;
    }
    console.log('après modification', this.mouvBenneProgramme);
  }

  showEquipe() {
    this.objEquipe['program'] = this.newprest['program'] || false;
    if (this.newprest['modeEquipe']) {
      this.isModeEquipe = !this.isModeEquipe;
      console.log('After close : ', this.objEquipe);
    }
  }

  getToutesRsrcBSDDPlanningGeneral() {
    const listToutesRessourcesBSDDPlanning = [];

    console.log(this.info['bonSelected'], this.info['mouvement'])
    if (this.info['bonSelected'] && this.info['bonSelected'].typeBon &&
      this.info['bonSelected'].typeBon.id !== 4 && !this.isHisto && !this.isHistoMvt) {
      if (this.info['mouvement'] && this.info['mouvement'].id) {
        listToutesRessourcesBSDDPlanning.push(this.info['mouvement']);
      }
    }

    if (listToutesRessourcesBSDDPlanning.length > 0) {
      this.imprimerTousLesBSDD(listToutesRessourcesBSDDPlanning);
    } else {
      this.error = 'Aucun BSDD \u00e0 imprimer sur ce bon.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  getToutesRsrcDACPlanningGeneral() {
    const listToutesRessourcesDACPlanning = [];
    if (this.info['bonSelected']) {
      if (this.info['mouvement'] && this.info['mouvement'].id && this.info['mouvement'].bon) {
        listToutesRessourcesDACPlanning.push(this.info['mouvement']);
      } else if (this.info['mouvement'] && !this.info['mouvement'].bon) {
        if (this.info['bon'] && this.info['mouvement']) {
          const objMvt = {
            id: this.info['mouvement'].id,
            bon: {
              id: this.info['bon'].id,
              numBon: this.info['bon'].numBon
            }
          }
          listToutesRessourcesDACPlanning.push(objMvt);
        }
      }
    }
    if (listToutesRessourcesDACPlanning.length > 0) {
      this.imprimerTousLesDAC(listToutesRessourcesDACPlanning);
    } else {
      this.error = 'Aucun DAC \u00e0 imprimer sur ce bon.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  openModalQtePrintADR() {
    let oMoment, listDate;

    // console.log(oMoment);
    this.showSpinner = true;
    this.listBonImp = [];
    const clefPeriode = 0;
    let format = '0';
    if (this.formatADRSelected && this.formatADRSelected.id) {
      format = '' + this.formatADRSelected.id;
    }
    const param = {
      'servlet': 'DBImprimeADR',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      // 'pathImpression': 'Ecobennes/tmp/EtiquetteADR/',
      'data': {
        'CLEF_FORMAT': {
          'typeParam': 'int',
          'valeur': format
        },
        'CLEF_MOUV': {
          'typeParam': 'int',
          'valeur': this.info['mouvement'] && this.info['mouvement'].id ? this.info['mouvement'].id : 0
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.listBonImp = [...(datas.data || [])];
        this.listBonImp.forEach(elt => elt.quantite = 1);
        this.showSpinner = false;
        this.common.openModal(this.modalService, this.dialogueQteADR);
      } else {
        this.showSpinner = false;
        if (datas.message) {
          this.alert.error(datas.message);
        }
      }

    }).catch(err => this.showSpinner = false);
  }

  imprissionTousADR() {
    this.listBonImp = this.listBonImp || [];
    const listPDF = [];
    this.listBonImp.forEach(elt => {
      if (elt.quantite > 0) {
        const pdf = ('Ecobennes/tmp/EtiquetteADR/' + elt.PDF);
        for (let i = 0; i < elt.quantite; i++) {
          listPDF.push(pdf);
        }
      }
    });
    console.log(listPDF);

    if (this.listBonImp && this.listBonImp.length) {
      GestionAdr.mergeFilePDF(listPDF, this.common).then(datas => {
        if (datas.data) {
          datas.data = datas.data || [];
          // const listURLADR = GestionAdr.getUrlADR(datas.data);
          datas.data.forEach(url => {
            this.common.openFile(url);
          });
        } else {
          if (datas.message) {
            // this.error = datas.message;
            // this.common.openModal(this.modalService, this.msg);
            // this.alert.error(datas.message);
          }
        }

      });
    } else {
      this.error = 'Aucun ADR \u00e0 imprimer sur ce bon.';
      this.common.openModal(this.modalService, this.msg);
    }

  }

  imprimerADR() {
    GestionFormat.getFormatperso(ConstanteEcorec.TYPE_FORMAT_PARAMETRABLE_ETIQUETTE_ADR, this.common).then(datasFormat => {
      if (datasFormat.data) {
        this.listFormatEtiquetteADR = datasFormat.data;
        if (this.listFormatEtiquetteADR.length > 1) {
          this.formatADRSelected = this.listFormatEtiquetteADR[0];
          // open modal
          this.common.openModal(this.modalService, this.formatEtiquetteADR);
        } else {
          if (this.listFormatEtiquetteADR.length === 1) {
            this.formatADRSelected = this.listFormatEtiquetteADR[0];
            this.processImprimerADR();
          } else {
            this.common.openModal(this.modalService, this.formatEtiquetteADR);
          }
        }
      } else {
        if (datasFormat.message) {
          this.alert.error(datasFormat.message);
        }
      }
    });
  }

  processImprimerADR() {

    const listToutesRessourcesADRPlanning = [];
    if (this.info['bonSelected'] && this.info['bonSelected'].typeBon && this.info['bonSelected'].typeBon.id !== 1 &&
      this.info['bonSelected'].typeBon.id !== 4 && !this.isHisto && !this.isHistoMvt) {
      if (this.info['mouvement'] && this.info['mouvement'].id) {
        listToutesRessourcesADRPlanning.push(this.info['mouvement']);
      }
    }

    if (listToutesRessourcesADRPlanning.length > 0) {
      // this.imprimerTousLesADR(listToutesRessourcesADRPlanning, this.info['mouvement']);
      this.openModalQtePrintADR()
    } else {
      this.error = 'Aucun ADR \u00e0 imprimer sur ce bon.';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  imprimerTousLesADR(listToutesRessourcesADRPlanning, mvt) {
    const ctrl = this;
    let format = '0';
    if (this.formatADRSelected && this.formatADRSelected.id) {
      format = '' + this.formatADRSelected.id;
    }
    const param = {
      'servlet': 'DBImprimeADR',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'pathImpression': 'Ecobennes/tmp/EtiquetteADR/',
      'data': ['DBImprimeADR', mvt.id, format]
    };

    return ctrl.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          datas.data = datas.data || [];
          const listURLADR = GestionAdr.getUrlADR(datas.data);
          /*
          listURLADR.forEach(url => {
            this.common.openFile(url);
          });
          */
          if (listURLADR.length) {
            GestionAdr.mergeFilePDF(listURLADR, this.common).then(datasMerge => {
              if (datasMerge.data) {
                datasMerge.data = datasMerge.data || [];
                datasMerge.data.forEach(url => {
                  this.common.openFile(url);
                });
              } else {
                if (datasMerge.message) {
                  this.alert.error(datasMerge.message);
                }
              }
            });
          }
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

  imprimerTousLesBSDD(listToutesRessourcesBSDDPlanning) {
    const promise = [];
    const ctrl = this;
    const listId = [];
    listToutesRessourcesBSDDPlanning.forEach(ressource => {
      listId.push('' + ressource.id);
      // promise.push(GestionBsdd.printBSDDMouv(ressource.id, ctrl.common));
    });
    GestionBsdd.printBSDDMouv(listId, ctrl.common).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data.length) {
          if (datas.data !== 'KO') {
            const url = datas.data[0]; // GestionBsdd.getUrlBsdd(datas.data);
            this.common.openFile(url);
          } else {
            this.error = `Aucun BSDD \u00e0 imprimer sur ce bon.
            V\u00e9rifiez :
            - Le bon contient un DD
            - Il ne s'agit pas d'un depot
            - Le client est configur\u00e9 pour imprimer des BSDDs pour des d\u00e9chets non DD
            `;
            this.common.openModal(this.modalService, this.msg);
          }
          console.log(datas.data);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

  imprimerTousLesDAC(listToutesRessourcesDAClanning) {
    const promise = [];
    const ctrl = this;
    const lisMouv = [];
    let objetMouvementDAC = {};
    if (listToutesRessourcesDAClanning.length) {
      listToutesRessourcesDAClanning.forEach(detail => {
        if (detail['bon'] && detail['bon'].id) {
          objetMouvementDAC = {
            'nomclass': "Mouvement",
            id: detail['id'],
            bon: {
              id: detail['bon'].id,
              numBon: detail['bon'].numBon
            }
          }
          if (detail['tournee'] && detail['tournee'].id) {
            objetMouvementDAC['tournee'] = {
              id: detail['tournee'].id
            }
          }
          lisMouv.push(objetMouvementDAC);
        }
      });
    }

    if (!lisMouv.length) {
      ctrl.error = 'Aucun DAC \u00e0 imprimer sur ce bon.';
      ctrl.common.openModal(ctrl.modalService, ctrl.msg);
      return;
    }

    GestionDAC.printDACMouv(lisMouv, ctrl.common).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data.length) {
          if (datas.data !== 'KO') {
            const url = datas.data[0]; // GestionBsdd.getUrlBsdd(datas.data);
            this.common.openFile(url);
          } else {
            this.error = `Aucun DAC \u00e0 imprimer sur ce bon`;
            this.common.openModal(this.modalService, this.msg);
          }
          console.log(datas.data);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }


  dialogueFormatPersoBonParMail() {
    const ctrl = this;
    GestionFormat.getFormatperso(ConstanteEcorec.TYPE_FORMAT_PARAMETRABLE_BON_BENNES, this.common).then(datasFormat => {
      if (datasFormat.data && datasFormat.data.length) {
        ctrl.formatPerso = datasFormat.data;
        if (this.formatPerso.length >= 1) {
          this.formatprs = this.formatPerso[0];
          // open modal
          this.common.openModal(this.modalService, this.formatBonParMail);
        } else {
          this.common.openModal(this.modalService, this.formatBonParMail);
        }
      } else {
        if (datasFormat.message) {
          this.alert.error(datasFormat.message);
        }
      }
    });
  }

  /**
   * EcobennesIHM -> FenetrePlanningImpression.java -> envoyerBonsParMail()
   */
  envoyerBonsParMail() {
    this.mouvementRiche = this.info['mvtP'];
    if (this.mouvementRiche && this.mouvementRiche['chantier'] && this.mouvementRiche['chantier'].id) {
      this.getDetailChantier(this.mouvementRiche['chantier'].id).then(datasChantier => {
        const chantier = datasChantier.data[0];
        console.log(chantier);

        // Prendre les infos de l'utilisateur
        this.envoiemail_signatureTexte = this.user['signatureBonChantier'] || '';
        this.envoiemail_signatureImageTemp = this.user['imageSignatureBonChantier'].nomFichier || '';
        this.envoiemail_signatureImage = '';

        // Les infos mails de l'utilisateur
        this.envoimail_siteEntrepriseAdresseExpBon = this.user['siteParamMail'].adresseExpBonChantier || '';
        this.envoimail_siteEntrepriseAdresseCopieBon = this.user['siteParamMail'].adresseCopieBonChantier || '';
        this.envoimail_siteEntrepriseTitreMailBon = this.user['siteParamMail'].titreMailBonChantier || '';
        this.envoimail_siteEntrepriseCorpsMailBon = this.user['siteParamMail'].corpsMailBonChantier || '';

        // Prendre les infos de site
        if (!this.envoiemail_signatureTexte) {
          this.envoiemail_signatureTexte = this.siteUtilisateur['signatureBonChantier'] || '';
        }

        if (!this.envoiemail_signatureImageTemp) {
          this.envoiemail_signatureImage = this.siteUtilisateur['imageSignatureBonChantier'].nomFichier;
        } else {
          this.envoiemail_signatureImage = this.envoiemail_signatureImageTemp;
        }
        this.envoiemail_finalSignatureImage = this.envoiemail_signatureImage;

        // Les infos mails
        this.envoimail_siteEntrepriseAdresseExpBon = this.envoimail_siteEntrepriseAdresseExpBon ||
          this.siteUtilisateur['siteParamMail'].adresseExpBonChantier || '';
        this.envoimail_siteEntrepriseAdresseCopieBon = this.envoimail_siteEntrepriseAdresseCopieBon ||
          this.siteUtilisateur['siteParamMail'].adresseCopieBonChantier || '';
        this.envoimail_siteEntrepriseTitreMailBon = this.envoimail_siteEntrepriseTitreMailBon ||
          this.siteUtilisateur['siteParamMail'].titreMailBonChantier || '';
        this.envoimail_siteEntrepriseCorpsMailBon = this.envoimail_siteEntrepriseCorpsMailBon ||
          this.siteUtilisateur['siteParamMail'].corpsMailBonChantier || '';

        this.envoiemail_destMail = chantier && chantier['mail'] ? chantier['mail'] : '';
        this.envoiemail_expMail = this.envoimail_siteEntrepriseAdresseExpBon || this.societe['mail'];
        this.envoiemail_copieMail = this.envoimail_siteEntrepriseAdresseCopieBon || this.envoiemail_expMail;
        this.envoiemail_titreMail = this.envoimail_siteEntrepriseTitreMailBon || this.SUJET_MAIL_BON_CHANTIER_ECOBENNES;
        this.envoiemail_corpsMail = this.envoimail_siteEntrepriseCorpsMailBon || this.CONTENU_MAIL_BON_CHANTIER_ECOBENNES;

        const numBon = this.mouvementRiche['bon'] && this.mouvementRiche['bon'].numBon ? this.mouvementRiche['bon'].numBon : '';
        this.envoiemail_titreMail = this.remplacerVariableCorpsMail(this.envoiemail_titreMail,
          this.envoiemail_signatureTexte, this.mouvementRiche, chantier);
        this.envoiemail_corpsMail = this.remplacerVariableCorpsMail(this.envoiemail_corpsMail,
          this.envoiemail_signatureTexte, this.mouvementRiche, chantier);
        this.envoiemail_corpsMail += '\n\n' + this.envoiemail_signatureTexte;

        this.envoiemail_format = this.siteUtilisateur['formatBon'] || '';

        console.log(this.newprest);
        console.log(this.info);

        this.datamail = {
          titre: 'Envoi du bon ' + numBon + ' par email',
          expediteur: this.envoiemail_expMail,
          destinataire: this.envoiemail_destMail,
          cc: this.envoiemail_copieMail,
          bcc: '',
          sujet: this.envoiemail_titreMail,
          contenu: this.envoiemail_corpsMail,
        };
        this.aUnSignature = this.envoiemail_finalSignatureImage ? true : false;

        this.common.closeModal(); // Ferme le choix du format
        this.common.openModal(this.modalService, this.mail);
      });
    }
  }

  remplacerVariableCorpsMail(chaine, strSignatureTexte,
    mouvementRiche, chantier) {
    let retour = chaine ? chaine : '';
    this.envoiemail_strNumBon = this.mouvementRiche['bon'] && this.mouvementRiche['bon'].numBon ? this.mouvementRiche['bon'].numBon : '';
    this.envoiemail_strNomSociete = this.societe['nom'];

    const date = this.newprest && this.newprest.dateStart ? this.common.isDate(this.newprest.dateStart) : '';
    retour = this.replaceAll(retour, '@dateBonLogEcobennes', date);
    retour = this.replaceAll(retour, '@dateBonChantierEcobennes', date);
    retour = this.replaceAll(retour, '@nomSociete', this.envoiemail_strNomSociete);
    retour = this.replaceAll(retour, '@numBon', this.envoiemail_strNumBon);
    retour = this.replaceAll(retour, '@VilleChantier', chantier['ville'] || '');
    retour = this.replaceAll(retour, '@DateBon', this.mouvementRiche['bon'] &&
      this.mouvementRiche['bon'].date ? this.mouvementRiche['bon'].date : '');
    retour = this.replaceAll(retour, '@NumChantier', chantier['numChantier'] || '');
    retour = this.replaceAll(retour, '@Heure', this.mouvementRiche['heure'] || '');
    retour = this.replaceAll(retour, '@Chauffeur', this.mouvementRiche['chauffeur'] &&
      this.mouvementRiche['chauffeur'].nom ? this.mouvementRiche['chauffeur'].nom : '');
    retour = this.replaceAll(retour, '@Immatricualtion', this.mouvementRiche['camion'] &&
      this.mouvementRiche['camion'].immatriculation ? this.mouvementRiche['camion'].immatriculation : '');
    retour = this.replaceAll(retour, '@Info', this.mouvementRiche['infoSup'] || '');

    return retour;
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  validerPanneauMail(panneauEmail) {
    const ctrl = this;
    const listeClefMouv = [{ 'typeParam': 'string', 'valeur': this.mouvementRiche['id'] }];

    ctrl.envoyerBonParEmail(
      listeClefMouv,
      panneauEmail.expediteur,
      panneauEmail.destinataire,
      panneauEmail.cc,
      panneauEmail.bcc,
      panneauEmail.sujet,
      panneauEmail.contenu,
      this.envoiemail_format,
      ctrl.common.user[2],
      ctrl.formatprs['id']
    );
  }


  envoyerBonParEmail(listeClefMouv, expediteurEmail, destinataireEmail, ccEmail, bcc,
    sujetEmail, contenuEmail, format, clefSite, formatParamBon) {
    const ctrl = this;
    this.common.closeModal();

    this.common.openModal(this.modalService, this.loading);

    const param = {
      'servlet': 'DBImprimeBonEcobennesParMail',
      'module': 'Ecobennes',
      'type': 'map',
      'compression': 'false',
      'data': {
        'MOUVEMENTS': listeClefMouv,
        'EXPEDITEUR': { 'typeParam': 'string', 'valeur': expediteurEmail },
        'DESTINATAIRE': { 'typeParam': 'string', 'valeur': destinataireEmail },
        'CC': { 'typeParam': 'string', 'valeur': ccEmail || '' },
        'BCC': { 'typeParam': 'string', 'valeur': bcc },
        'SUJET': { 'typeParam': 'string', 'valeur': sujetEmail || '' },
        'CONTENU': { 'typeParam': 'string', 'valeur': contenuEmail || '' },
        'FORMAT': { 'typeParam': 'string', 'valeur': format },
        'SITE': { 'typeParam': 'string', 'valeur': '' + clefSite },
        'CLEF_FORMAT_PARAMETRABLE': { 'typeParam': 'int', 'valeur': formatParamBon },
        'PRINT_PESEE': { 'typeParam': 'boolean', 'valeur': true }
      }
    };

    if (this.aUnSignature) {
      param['data']['IMAGE_SIGNATURE'] = {
        'typeParam': 'string',
        'valeur': this.envoiemail_finalSignatureImage || ''
      };
    }

    return this.common.post('', { param: param }).then(datas => {
      ctrl.common.closeModal();
      if (datas['data'] && datas['data'] === 'OK') {
        this.common.closeModal();
        this.error = 'Le mail a été envoyé avec succès';
        this.common.openModal(this.modalService, this.msg);
      } else {
        ctrl.common.closeModal();
        ctrl.error = 'Un problème est survenu lors de l\'envoi du mail';
        ctrl.common.openModal(ctrl.modalService, ctrl.msg);
      }
    }).catch(error => {
      console.log(error);
    });
  }

  setValueQte() {
    if (this.edit) {
      this.showLeft = false;
      this.isModifier = true;
      setTimeout(function () {
        $('#btnvalider').focus();
      }, 500);
    }
    if (!this.newprest['newContenant']) {
      this.newprest['contenant'].qteContenant = this.qteSelected['libelleObjetEntite'];
    } else {
      this.newprest['newBenne'].qteContenant = this.qteSelected['libelleObjetEntite'];
    }
    // this.nextStep();
  }


  listQteCombo(contenant) {
    let qteMax = 0;
    this.newprest[contenant].qteContenant = this.newprest[contenant].qteContenant || 1;
    qteMax = this.newprest[contenant].qteContenant;
    this.newprest[contenant].qteContenantTotaleNonUnitaire = this.newprest[contenant].qteContenantTotaleNonUnitaire || 1;
    if (this.newprest[contenant].qteContenant && this.newprest[contenant].qteContenantTotaleNonUnitaire) {
      qteMax = this.newprest[contenant].qteContenant >= this.newprest[contenant].qteContenantTotaleNonUnitaire ?
        this.newprest[contenant].qteContenant : this.newprest[contenant].qteContenantTotaleNonUnitaire
    }

    console.log(qteMax)
    if (qteMax) {
      for (let i = 0; i < qteMax; i++) {
        const existe = this.listQte.filter(elt => elt.id === i + 1);
        if (!existe || (existe && !existe.length)) {
          this.listQte.push({ id: i + 1, libelleObjetEntite: '' + (i + 1) });
        }
      }
    }
  }

  listQteComboGroup(item) {
    let qteMax = 0;
    item.qteContenant = item.qteContenant || 1;
    qteMax = item.qteContenant;
    item.qteContenantTotaleNonUnitaire = item.qteContenantTotaleNonUnitaire || 1;
    if (item.qteContenant && item.qteContenantTotaleNonUnitaire) {
      qteMax = item.qteContenant >= item.qteContenantTotaleNonUnitaire ?
        item.qteContenant : item.qteContenantTotaleNonUnitaire
    }
    item.listQte = [];
    if (qteMax) {
      for (let i = 0; i < qteMax; i++) {
        const existe = item.listQte.filter(elt => elt.id === i + 1);
        if (!existe || (existe && !existe.length)) {
          item.listQte.push({ id: i + 1, libelleObjetEntite: '' + (i + 1) });
        }
      }
    }
  }

  setValueQteGrp(item) {
    item.qteContenant = this.qteSelected['libelleObjetEntite'];
  }

  saveEquipe(event) {
    console.log(event);
    this.objEquipe = Object.assign({}, event);
    console.log('After save : ', this.objEquipe);
    this.isModeEquipe = !this.isModeEquipe;
  }

  getlistIndispo() {
    const param = {
      'servlet': 'DBGestionIndisponibiliteChauffeur',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DATE_DEBUT': {
          'typeParam': 'date',
          'valeur': moment(this.newprest['dateStart']).format('DD/MM/YYYY')
        },
        'DATE_FIN': {
          'typeParam': 'date',
          'valeur': moment(this.newprest['dateStart']).format('DD/MM/YYYY')
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.listIndispoChauff = datas.data || [];
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });

  }

  parseMouvement() {
    const ctrl = this;
    const planning = ctrl.newprest;
    planning['chauffeur'] = !this.isChauffeurIndispoInfoBulle(planning['chauffeur']) ?
      Object.assign({}, planning['chauffeur']) : { id: 0, libelleObjetEntite: 'A définir' };

    planning['listePersonnelParPoste'] = planning['listePersonnelParPoste'] || [];
    planning['listePersonnelParPoste'].forEach(e => {
      e.chauffeur = e.chauffeur || { id: 0, libelleObjetEntite: 'A définir' };
      if (e.chauffeur.id) {
        e.chauffeur = !this.isChauffeurIndispoInfoBulle(e.chauffeur) ?
          e.chauffeur : { id: 0, libelleObjetEntite: 'A définir' };
      }
    });
    const data = Object.assign({}, ctrl.newprest);
    ctrl.objEquipe['listePersonnelParPoste'] = data['listePersonnelParPoste'] || [];
    const poctuelPost = [];
    ctrl.objEquipe['listePersonnelParPoste'].forEach(elt => {
      elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
        ''} ${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';
      poctuelPost.push(elt);
    });
    ctrl.objEquipe['modeEquipe'] = ctrl.newprest['modeEquipe'] || false;
    ctrl.objEquipe['mouvement'] = Object.assign({}, ctrl.newprest['mouvement'] || { id: 0 });
    ctrl.objEquipe['chauffeur'] = Object.assign({}, ctrl.newprest['chauffeur']);
    ctrl.objEquipe['chauffeur'].libelleObjetEntite = ctrl.objEquipe['chauffeur'] && ctrl.objEquipe['chauffeur'].id ?
      `${ctrl.objEquipe['chauffeur'].matricule || ''} ${ctrl.objEquipe['chauffeur'].nom ||
      ''} ${ctrl.objEquipe['chauffeur'].prenom || ''}` : '';

    if (data['tournee']) {
      const tournee = data['tournee'];
      tournee.listePersonnelParPoste = tournee.listePersonnelParPoste || [];
      ctrl.objEquipe['modeEquipe'] = tournee.modeEquipe || false;
      ctrl.objEquipe['program'] = (tournee.program && tournee.program.id > 0) ||
        (tournee.clefProgram && (tournee.clefProgram !== '' || tournee.clefProgram !== '0')) ? true : false;
      ctrl.objEquipe['qualificationLeader'] = tournee.qualificationLeader;
      ctrl.objEquipe['leaderEquipe'] = tournee.leaderEquipe || { id: 0 };
      ctrl.objEquipe['leaderEquipe']['libelleObjetEntite'] = ctrl.objEquipe['leaderEquipe'] && ctrl.objEquipe['leaderEquipe'].id ?
        `${ctrl.objEquipe['leaderEquipe']['matricule']
        || ''} ${ctrl.objEquipe['leaderEquipe']['nom']
        || ''} ${ctrl.objEquipe['leaderEquipe']['prenom'] || ''}` : '';
      const posteMax = tournee.listePersonnelParPoste.length > poctuelPost.length ? tournee.listePersonnelParPoste.length : poctuelPost.length;
      // if (ctrl.objEquipe['program']) {
      //   tournee.listePersonnelParPoste = tournee.listePersonnelParPoste || [];
      //   tournee.listePersonnelParPoste.forEach((elt, idx) => {
      //     if (ctrl.objEquipe['listePersonnelParPoste'].length) {
      //       elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
      //         ''}${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';
      //       if (ctrl.objEquipe['listePersonnelParPoste'][idx]) {
      //         ctrl.objEquipe['listePersonnelParPoste'][idx]['personnelDefaut'] = elt.chauffeur;
      //       }
      //     }
      //   })
      // }

      ctrl.objEquipe['listePersonnelParPoste'] = [];
      for (let i = 0; i < posteMax; i++) {
        const objpost = poctuelPost[i] ? Object.assign({}, poctuelPost[i]) : { id: 0 };
        const elt = tournee.listePersonnelParPoste[i] ? Object.assign({}, tournee.listePersonnelParPoste[i]) : { id: 0 };
        objpost['poste'] = objpost['poste'] || elt.poste;
        if (ctrl.objEquipe['program']) {
          elt.chauffeur = elt.chauffeur || { id: 0 };
          elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
            ''}${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';
          if (objpost) {
            objpost['personnelDefaut'] = elt.chauffeur;
          }
        }
        ctrl.objEquipe['listePersonnelParPoste'].push(objpost);
      }

    } else {
      const benne = data['contenant'] || {};
      if (benne) {
        ctrl.objEquipe['modeEquipe'] = benne.modeEquipe || false;
        ctrl.objEquipe['program'] = benne.clefProgram && (benne.clefProgram !== '' || benne.clefProgram !== '0') ? true : false;
        ctrl.objEquipe['qualificationLeader'] = benne.qualificationLeader;
        ctrl.objEquipe['leaderEquipe'] = benne.leaderEquipe || { id: 0 };
        ctrl.objEquipe['leaderEquipe']['libelleObjetEntite'] = ctrl.objEquipe['leaderEquipe'] && ctrl.objEquipe['leaderEquipe'].id ?
          `${ctrl.objEquipe['leaderEquipe']['matricule']
          || ''} ${ctrl.objEquipe['leaderEquipe']['nom']
          || ''} ${ctrl.objEquipe['leaderEquipe']['prenom'] || ''}` : '';
        benne.listePersonnelParPoste = benne.listePersonnelParPoste || [];
        const posteMax = benne.listePersonnelParPoste.length > poctuelPost.length ? benne.listePersonnelParPoste.length : poctuelPost.length;

        ctrl.objEquipe['listePersonnelParPoste'] = [];
        for (let i = 0; i < posteMax; i++) {
          const objpost = poctuelPost[i] ? Object.assign({}, poctuelPost[i]) : { id: 0 };
          const elt = benne.listePersonnelParPoste[i] ? Object.assign({}, benne.listePersonnelParPoste[i]) : { id: 0 };
          objpost['poste'] = objpost['poste'] || elt.poste;
          if (ctrl.objEquipe['program']) {
            elt.chauffeur = elt.chauffeur || { id: 0 };
            elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
              ''}${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';
            if (objpost) {
              objpost['personnelDefaut'] = elt.chauffeur;
            }
          }
          ctrl.objEquipe['listePersonnelParPoste'].push(objpost);
        }

        // if (ctrl.objEquipe['program']) {
        //   benne.listePersonnelParPoste = benne.listePersonnelParPoste || [];
        //   benne.listePersonnelParPoste.forEach((elt, idx) => {
        //     if (ctrl.objEquipe['listePersonnelParPoste'].length) {
        //       elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
        //         ''}${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';
        //       if (ctrl.objEquipe['listePersonnelParPoste'][idx]) {
        //         ctrl.objEquipe['listePersonnelParPoste'][idx]['personnelDefaut'] = elt.chauffeur;
        //       }
        //     }
        //   })
        // }
      }

    }
  }

  objMvtEquipe() {
    const ObjetRetour: any = {};

    ObjetRetour.listePersonnelParPoste = [];
    ObjetRetour.listePersonnelParPosteMvt = [];
    ObjetRetour.listePostes = [];
    ObjetRetour.leaderEquipe = this.objEquipe['leaderEquipe'];
    ObjetRetour.qualificationLeader = this.objEquipe['qualificationLeader'];
    ObjetRetour.chauffeur = this.objEquipe['chauffeur'];
    ObjetRetour.modeEquipe = this.objEquipe['modeEquipe'] || false;
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    let i = 0;
    this.objEquipe['listePersonnelParPoste'].forEach((elt, index) => {
      if (elt.poste && !elt.poste.id) {
        i = i + 1;
      }
      elt.poste.id = elt.poste.id || (-1 * (i));
      ObjetRetour.listePostes.push(elt.poste);
      const defaut = {
        id: 0,
        poste: elt.poste,
        chauffeur: { id: elt.personnelDefaut ? (elt.personnelDefaut.id) || 0 : 0 }
      };
      const ponctuel = {
        id: 0,
        poste: elt.poste,
        chauffeur: { id: elt.chauffeur ? (elt.chauffeur.id) || 0 : 0 }
      }
      ObjetRetour.listePersonnelParPoste.push(defaut);
      ObjetRetour.listePersonnelParPosteMvt.push(ponctuel);
    });
    ObjetRetour.equipeDefinie = ObjetRetour.listePostes.length > 0 ? true : false;
    console.log(ObjetRetour)
    return ObjetRetour;
  }

  searchListCamion(event?) {
    const data = {
      'TOUS_CAMIONS': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'CAMIONS_CEDES': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'IS_FILTRE_RECEPTION_CHANTIER': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'IS_RECEPTION_CHANTIER': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'AU_GARAGE': {
        'typeParam': 'boolean',
        'valeur': true
      },
      'TO_STRING_AVEC_NUM_PARC': {
        'typeParam': 'boolean',
        'valeur': true
      },
      'CLEF_SITE': {
        'typeParam': 'int',
        'valeur': this.common.user[2]
      },
      'VISIBLE_ECODECHET': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'IS_CAMION_MULTIBENNE_ECOLOC': {
        'typeParam': 'boolean',
        'valeur': true
      },
      'GET_ONLY_SITE_USER': {
        'typeParam': 'boolean',
        'valeur': false
      },
      'CRITERE': event
    };

    if (this.societe.choixCamionCreationMouv) {
      data['TOUS_CAMIONS'] = {
        'typeParam': 'boolean',
        'valeur': false
      }
    } else {
      data['TOUS_CAMIONS'] = {
        'typeParam': 'boolean',
        'valeur': true
      }
    }

    this.listCamion = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];

    return this.common.post('', {
      param: {
        'servlet': 'DBGetListCamion',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': data,
      }
    }).then(datas => {
      datas.data.forEach(elt => {
        const l = (elt.numParc ? elt.numParc + ' / ' : '') + (elt.immatriculation ? elt.immatriculation : '');
        elt.libelleObjetEntite = l;
      });

      this.listCamion = [...this.listCamion, ...(datas.data || [])];
      return datas;
    }).catch(error => {
      throw error;
    });
  }

  getTextCamion(elt) {
    if (!elt) {
      return 'Aucun';
    }


    return (elt.numParc ? elt.numParc + ' / ' : '') + (elt.immatriculation ? elt.immatriculation : '');
  }

  // désactiver le champs contrat si lié aux données techniques
  disableNumContrat() {
    return (this.info && this.info.contenant &&
      this.info.contenant.contratBenne && this.info.contenant.contratBenne.id) || (this.newprest['contenant'] &&
        this.newprest['contenant'].contratBenne && this.newprest['contenant'].contratBenne.id);
  }


  actualiseAxeAnaArticle(contenant, article?) {
    if (!this.modifContenantGrp) {
      const AXE_CHANTIER = this.newprest['chantier'] ? (this.newprest['chantier'].axeAnalytique || '') : '';
      const Article = article ? article : (contenant.art || {});
      const listArticle = contenant.listArticle || [];
      console.log('6648', AXE_CHANTIER)
      if (AXE_CHANTIER && AXE_CHANTIER.length > 4 || (AXE_CHANTIER.length === 4 && AXE_CHANTIER.startsWith('12'))) {
        // on prend AXE_CHANTIER
        if (contenant.isGroupeArticle) {
          listArticle.forEach(art => {
            art.axeAnalytiqueLigneArt = AXE_CHANTIER;
          });
        } else {
          contenant.axeAnalytiqueLigneArt = AXE_CHANTIER;
        }
      } else {
        if (AXE_CHANTIER && AXE_CHANTIER.length === 4 && (AXE_CHANTIER.startsWith('14') || AXE_CHANTIER.startsWith('4D'))) {
          if (contenant.isGroupeArticle) {
            listArticle.forEach(art => {
              if (art && art.id) {
                art.axeAnalytiqueLigneArt = AXE_CHANTIER + (article ? (article.codeAnalytique || '') : (art.codeAnalytique || ''));
                console.log(AXE_CHANTIER + (article ? (article.codeAnalytique || '') : (art.codeAnalytique || '')))
              } else {
                art.axeAnalytiqueLigneArt = AXE_CHANTIER;
              }
            });
          } else {
            if (contenant.art && contenant.art.id) {
              contenant.axeAnalytiqueLigneArt = AXE_CHANTIER + (Article.codeAnalytique || '');
            } else {
              contenant.axeAnalytiqueLigneArt = AXE_CHANTIER;
            }

          }
        } else {
          // sinon vide
          if (contenant.isGroupeArticle) {
            listArticle.forEach(art => {
              art.axeAnalytiqueLigneArt = '';
            });
          } else {
            contenant.axeAnalytiqueLigneArt = ''
          }
        }
      }
      console.log(contenant)
    }
  }

  actualiseAxeAnaContenant(contenant) {
    if (!this.modifContenantGrp) {
      const AXE_CHANTIER = this.newprest['chantier'] ? (this.newprest['chantier'].axeAnalytique || '') : '';
      const Article = contenant.art || {};
      const listArticle = contenant.listArticle || [];
      console.log('6696', AXE_CHANTIER)
      if (AXE_CHANTIER && AXE_CHANTIER.length > 4 || (AXE_CHANTIER.length === 4 && AXE_CHANTIER.startsWith('12'))) {
        // on prend AXE_CHANTIER
        contenant.axeAnalytiqueLigne = AXE_CHANTIER;
      } else {
        if (AXE_CHANTIER && AXE_CHANTIER.length === 4 && (AXE_CHANTIER.startsWith('14') || AXE_CHANTIER.startsWith('4D'))) {
          if (contenant.typeContenant && contenant.typeContenant.id) {

            const codeAnalytique = contenant.typeContenant.depot && contenant.typeContenant.depot.codeAnalytique
              ? contenant.typeContenant.depot.codeAnalytique : (Article.codeAnalytique || '')
            contenant.axeAnalytiqueLigne = AXE_CHANTIER + codeAnalytique;
          } else {
            contenant.axeAnalytiqueLigne = AXE_CHANTIER;
          }
        } else {
          // sinon vide
          contenant.axeAnalytiqueLigne = '';
        }
      }
    }
  }

  hasSCrollBar(element) {
    return $(element) && $(element)[0] && $(element)[0].scrollHeight > $(element).height() ? true : false;
  }

  actualiseArt(article, contenant) {
    if (article) {
      const libelleObjetEntite = article.libelleObjetEntite;
      this.getDetailArticle(article.id).then(data => {
        article = data[0] || article;
        if (!contenant.isGroupeArticle) {
          contenant.art = article;
          contenant.art.libelleObjetEntite = libelleObjetEntite;

        }
        this.actualiseAxeAnaArticle(contenant, article);
      })
    }
  }

  detailArt(article, contenant) {
    if (article) {
      const libelleObjetEntite = article.libelleObjetEntite;
      this.getDetailArticle(article.id, true).then(data => {
        article = data[0] || article;
        if (!contenant.isGroupeArticle) {
          contenant.art = article;
          contenant.art.libelleObjetEntite = libelleObjetEntite;

        }
      })
    }
  }

  actualiseCont(contenant, notActuCont?) {
    if (contenant.typeContenant && contenant.typeContenant['id']) {
      const param = {
        'servlet': 'DBGetTypeCont',
        'module': 'Recylog',
        'type': 'liste',
        'compression': 'false',
        'forcerSerialisation': 'true',
        'data': [{
          'typeParam': 'int',
          'valeur': contenant.typeContenant['id'] || 0
        },
        {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        }]
      };
      const libelleObjetEntite = contenant.typeContenant.libelleObjetEntite;
      this.common.post('', { param: param }, notActuCont || false).then(datas => {
        if (this.common.verifySession(datas) && datas.data != null) {
          contenant.typeContenant = datas.data;
          contenant.typeContenant.libelleObjetEntite = libelleObjetEntite;

          if (!notActuCont) {
            this.actualiseAxeAnaContenant(contenant);
          }
        }
      });
    } else {
      if (!notActuCont) {
        this.actualiseAxeAnaContenant(contenant);
      }
    }
  }

  getListContrat() {
    if (this.newprest['client'] && this.newprest['client']['id']) {
      const param = {
        'servlet': 'DBGetContratsClient',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'forcerSerialisation': 'true',
        'data': {
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': this.newprest['client']['id'] || 0
          },
          'CLEF_BON': {
            'typeParam': 'int',
            'valeur': this.info && this.info['bonSelected'] ? (this.info['bonSelected'].id || 0) : 0
          }
        }
      };
      this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas) && datas.data != null) {
          this.LISTE_CONTRAT = datas.data || [];
          this.LISTE_CONTRAT[0] = this.LISTE_CONTRAT[0] || [];
          this.LISTE_CONTRAT[1] = this.LISTE_CONTRAT[1] || [];
          this.LISTE_CONTRAT[0].forEach(Contrat => {
            Contrat.listLignePrestation = Contrat.listLignePrestation || [];
            const negoce = Contrat.listLignePrestation.filter(LignePrestationContrat => LignePrestationContrat.pointChargement
              && LignePrestationContrat.pointChargement.id > 0);
            Contrat.negoce = negoce && negoce.length ? true : false;
            Contrat.libelleObjetEntite = `${Contrat.numContrat || ''} : ${Contrat.reference || ''}`;
          });
          this.LISTE_CONTRAT[1].forEach(Contrat => {
            Contrat.listLignePrestation = Contrat.listLignePrestation || [];
            const negoce = Contrat.listLignePrestation.filter(LignePrestationContrat => LignePrestationContrat.pointChargement
              && LignePrestationContrat.pointChargement.id > 0);
            Contrat.negoce = negoce && negoce.length ? true : false;
            Contrat.libelleObjetEntite = `${Contrat.numContrat || ''} : ${Contrat.reference || ''}`;
          });
          this.getListComboContrat();
          if (this.info['mouvPrincipal']) {
            this.listContrat.forEach(elt => {
              if (parseInt(this.info['mouvPrincipal'][29], 10) === elt.id) {
                this.newprest['contratChamp'] = elt;
              }
            });
            this.getListComboPresta();
            if (this.info['mouvCourant'] && this.info['mouvCourant'][3]) {
              const m = this.info['mouvCourant'][3];
              this.newprest['prestation'] = m.bon ? m.bon.lignePrestationContrat || { id: 0 } : { id: 0 };
              this.newprest['prestation'].date = this.newprest['prestation'].date ?
                moment(this.newprest['prestation'].date, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY') : '';
              if (this.newprest['contratChamp'] && this.newprest['contratChamp'].id
                && this.newprest['prestation'] && !this.newprest['prestation'].id) {
                this.newprest['prestation'].libelleObjetEntite = 'Nouvelle';
              }
            }
          }
        }
      });
    }
  }

  getListComboContrat() {
    this.listContrat = [...[{ id: 0, libelleObjetEntite: 'Aucun' }]];
    if (this.LISTE_CONTRAT) {
      this.newprest['contratChamp'] = this.newprest['contratChamp'] || { id: 0, libelleObjetEntite: 'Aucun' };
      if (this.newprest['typeOperation'] && this.newprest['typeOperation'].sortie) {
        const contrat = (this.LISTE_CONTRAT[1] || []).filter(Contrat => (Contrat.client && this.newprest['client'] &&
          Contrat.client.id === this.newprest['client'].id) || !Contrat.negoce)
        this.listContrat = [...this.listContrat, ...(contrat || [])];

        console.log(this.listContrat)
      } else {
        const contrat = (this.LISTE_CONTRAT[1] || []).filter(Contrat => {
          return Contrat.client && this.newprest['client'] &&
            Contrat.client.id !== this.newprest['client'].id
        })
        this.listContrat = [...this.listContrat, ...(this.LISTE_CONTRAT[0] || []), ...contrat || []];
      }
    }

    console.log('contrat', this.listContrat);
  }

  getListComboPresta() {
    this.listPrestation = [...[{ id: 0, libelleObjetEntite: 'Nouvelle' }]];
    const Client = this.newprest['client'] || { id: 0 };
    if (this.newprest['contratChamp'] && this.newprest['contratChamp'].id) {
      const Contrat = this.newprest['contratChamp'];
      const listLignePrestation = Contrat.listLignePrestation || [];
      const lignes = [];
      console.log(this.newprest['typeOperation'])
      listLignePrestation.forEach(LignePrestationContrat => {
        LignePrestationContrat.date = moment(LignePrestationContrat.date, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        LignePrestationContrat.libelleObjetEntite = LignePrestationContrat.date;
        if (this.societe['gestionContratHolding'] && (this.info && this.info['bonSelected'] && LignePrestationContrat.bon &&
          this.info['bonSelected'].id === LignePrestationContrat.bon.id)) {
          // on ne prend pas la prestation
        } else {
          LignePrestationContrat.pointChargement = LignePrestationContrat.pointChargement || { id: 0 }
          if (Contrat.negoce && this.newprest['typeOperation'] && !this.newprest['typeOperation'].sortie
            && LignePrestationContrat.pointChargement.id !== Client.id) {
            // on ne prend pas la prestation
          } else {
            if (Contrat.negoce && this.newprest['typeOperation'] && this.newprest['typeOperation'].sortie
              && LignePrestationContrat.pointChargement.id > 0 && LignePrestationContrat.pointChargement.id !== Client.id) {
              // on ne prend pas la prestation
            } else {
              LignePrestationContrat.site = LignePrestationContrat.site || { id: 0 };
              if (LignePrestationContrat.site.id === parseInt(this.common.user[2], 10) || !LignePrestationContrat.site.id) {
                lignes.push(LignePrestationContrat);
              }
            }
          }
        }
      })

      console.log(lignes)
      this.listPrestation = [...[{ id: 0, libelleObjetEntite: 'Nouvelle' }], ...lignes || []];
      this.newprest['prestation'] = { id: 0, libelleObjetEntite: 'Nouvelle' };
    } else {
      this.newprest['prestation'] = { id: 0, libelleObjetEntite: '' }
      this.listPrestation = [];
    }
  }

  verificationOkNumBonManuelOb(fieldNumBonManuel, client) {
    console.log('Calling verificationOkNumBonManuelOb', fieldNumBonManuel, client);
    const numBonManuelCreationMouv = this.common.local.getObject('paramSociete').numBonManuelCreationMouv ? true : false;
    if (numBonManuelCreationMouv) {
      if (client && client.numBonManuelObligatoire && !fieldNumBonManuel) {
        return false;
      }
    }

    return true;
  }

  getDetailMouvEdit(idMvt) {
    const param: any = {
      'servlet': 'DBListMouv',
      'module': 'Ecobennes',
      'type': 'tableau',
      'compression': 'false',
      'data': ['', '' + idMvt]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas.data;
      }
    });
  }

  getValeurDateMax() {
    if (this.societe['gestionDateMax']) {
      const param: any = {
        'servlet': 'DBGestionAngular',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 23
          },
          'SITE': '' + (this.common.user[2] || 0),
          'NB_DATE_MAX': {
            'typeParam': 'int',
            'valeur': this.newprest['client'].dateMax || this.client['dateMax'] || 0
          },
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          console.log(datas);
          if (datas.data) {
            this.newprest['dateMaxStart'] = this.common.parseDate(moment(datas.data,
              'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
          }
        }
      });
    }
  }

  getValeurDatePrestation() {
    const param: any = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 25
        },
        'SITE': '' + (this.common.user[2] || 0),
      }
    };

    return this.common.post('', { param: param }, true).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          this.newprest['dateStart'] = this.common.parseDate(moment(datas.data,
            'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY'));
        }
      }
    });
  }

  searchZone(event?) {
    this.resultZone = [];
    this.resultZone.push(this.defaultLieu);
    if (this.newprest['chantier']) {
      this.newprest['chantier'].listLieu = this.newprest['chantier'].listLieu || [];
      this.newprest['chantier'].listLieu.forEach(element => {
        const elt = Object.assign({}, element);
        elt.libelleObjetEntite = elt.nom;
        this.resultZone.push(elt);
      });
    }
  }

  // Fermer fenetre sygetrack
  closeSygetrack() {
    this.msgSygetrack = '';
    this.common.closeModal();

    switch (this.callSygetrack) {
      case 'SUPP_MVT':
        this.suiteSupprimerBon();
        this.callSygetrack = '';
        break;

      default:
        this.suiteRetourUpdateChantier();
    }
  }

  // traitement après click bouton fermer sygetrack
  suiteRetourUpdateChantier() {
    this.getDetailChantier(this.arg1FuncAfterSygetrack).then(dt => {
      const chantier = dt.data && dt.data.length ? dt.data[0] || this.arg2FuncAfterSygetrack : this.arg2FuncAfterSygetrack;
      this.selectedChantier = chantier;
      this.newprest['chantier'] = this.selectedChantier;
      this.setValue(this.selectedChantier, 'chantier');
      setTimeout(function () {
        $('#autocomplete').focus();
      }, 500);
    });
  }

  // synchroniser modification chantier sur sygetrack
  setPOI(id) {
    this.common.openModal(this.modalService, this.loadingSygetrack);
    return GestionSygetrack.setPOI(id, this.common).then(datas => {
      if (datas.data && datas.data['erreur']) {
        this.setMsgSygetrack(datas.data['erreur']);

        // Pour debug
        if (datas.data['url']) {
          console.log('URL SYGETRACK SET_POI : ' + datas.data['url']);
        }
      } else {
        this.closeSygetrack();
      }
    });
  }

  // pour préparation de callSygetrack et debug des variables
  prepareSygetrack() {
    let newIm, newPerId, newDate, newCamion;
    let newId = 0;

    this.callSygetrack = '';
    if (this.resourceSygetrack) {
      newIm = this.resourceSygetrack['nom'] || '';
      newId = this.resourceSygetrack['idChauff'] || 0;
      newCamion = this.resourceSygetrack['idCamion'] || 0;
      newPerId = this.resourceSygetrack['periodeId'] || 0;
      newDate = this.resourceSygetrack['dateSygetrack'];
    }

    if (newId == 0) {
      console.log('Dbg sygetrack suppression mvt sans-chauffeur');
      return false; // Pas d'appel de sygetrack
    }

    console.log('Dbg sygetrack ' + newDate + ' : Suppression mvt de ' + newIm + '(' + newId + '/per=' + newPerId + '/' + newDate + '/' + newCamion + ')');
    this.callSygetrack = 'SUPP_MVT';
    return true;
  }

  // Afficher le msg de retour sygetrack et un bouton fermer
  setMsgSygetrack(msgSygetrack) {
    this.msgSygetrack = msgSygetrack;
    $('#container-msg-sygetrack').trigger('click');
  }

  listContenantCree(event, listcontenant) {
    this.listeContent = [];
    listcontenant.forEach(elt => {
      if (elt.isGroupeBenne) {
        elt.libelleObjetEntite = 'Grp. Contenants' + elt.id
      } else {
        elt.libelleObjetEntite = (elt.typeContenant && elt.typeContenant.famille ?
          elt.typeContenant.famille.libelle : '') + '/' + (elt.typeContenant &&
            elt.typeContenant.cubage ? elt.typeContenant.cubage.cubage : '0')
          + '' + (elt.typeContenant && elt.typeContenant.uniteCont ?
            elt.typeContenant.uniteCont.libelle : '') + ' /  ' +
          (elt.isGroupeArticle ? 'Grp Art' : (elt.art ? elt.art.code : '') + '' + (elt.art ? (elt.art.libelle || elt.
            art.libelleObjetEntite) : ''));
      }
      this.listeContent.push(elt);
    });
    this.listeContent = this.listeContent.sort((a, b) =>
      (a.isGroupeArticle ? 1 : 0) - (b.isGroupeArticle ? 1 : 0))
    this.listeContent = this.listeContent.sort((a, b) =>
      (a.isGroupeBenne ? 1 : 0) - (b.isGroupeBenne ? 1 : 0))
  }


  ChoixContent(event) {

    this.newBenne = {};
    this.newprest['newContenant'] = false;
    this.newprest['newBenne'] = false;
    this.setValue(event, 'contenant', false, false, true)
  }

  addContenantToGroupe(item) {
    const obj = Object.assign({}, item)
    obj.isChecked = true;
    if (obj && obj.isGroupeArticle) {
      this.getListArticleGrp(obj.id, true).then(data => {
        obj.listArticles = data;
        this.selectContenantForGroup(obj);
      })
    } else {
      this.selectContenantForGroup(obj);
    }
  }

  searchGroupeContenantChoix() {
    this.listcontenantGroupe = this.listcontenant.filter(elt => {
      const existe = this.listBenneSelected.filter(selected => selected.id === elt.id);
      return existe && existe.length ? false : (elt.id > 0 ? true : false);
    });
  }


  validerBSDDManContenantVert() {
    if (this.contenantVert && this.newprest.numBSDD && this.newprest.numBSDD !== '') {
      const numerosaisi = this.newprest.numBSDD || '';
      const idArticle = this.benneChantier && this.benneChantier['art'] && this.benneChantier['art'].id ?
        this.benneChantier['art'].id || 0 : 0;
      const param = {
        'servlet': 'DBGestionAngular',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 28
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2] || 0
          },
          'NUM_BSDD_MANUEL': numerosaisi,
          'CLEF_ARTICLE': {
            'typeParam': 'int',
            'valeur': idArticle
          }
        }
      };
      if (idArticle) {
        return this.common.post('', { param: param })
      } else {
        Promise.resolve({ data: true });
      }
    } else {
      return Promise.resolve({ data: true });
    }
  }

  getHeightdetail(element) {
    return $('#autofocus' + element).height();
  }

  calcHeightDatatable() {
    const offsetHeight = document.getElementById('editTop') && document.getElementById('editTop').offsetHeight ?
      document.getElementById('editTop').offsetHeight : 0;

    return offsetHeight;
  }


  gestionFIPDND() {
    const societe = this.societe;
    const idBon = this.info && this.info.bonSelected ? this.info.bonSelected.id || 0 : 0;
    this.common.getDetailBon(idBon).then(dataBon => {
      this.detailBon = dataBon || {};
      const obj = this.detailBon || {};
      const bonDetail = this.detailBon || {};
      this.common.getListFIP((obj.client ? obj.client.id : 0), false, true).then(listfipdnd => {
        console.log(listfipdnd)
        this.isFipDNDDejaImprimer(bonDetail, listfipdnd).then(existe => {
          if (!existe && moment().month() !== 0 && societe.isBlocageFIP) {
            // imprimer FipDND
            this.isDD = false;
            this.common.openModal(this.modalService, this.confirmaFIPDND);
          } else {
            this.gestionFIPDD();
          }
        });
      });
    })
  }


  gestionFIPDD() {
    const societe = this.societe;
    if (societe.gestionFIP) {
      const obj = this.detailBon || {};
      const bonDetail = this.detailBon || {};
      this.common.getListFIP(obj.client ? obj.client.id : 0, true).then(listfipdd => {
        this.isFipDDDejaImprimer(bonDetail, listfipdd).then(existeDD => {
          if (!existeDD && moment().month() !== 0 && societe.isBlocageFIP) {
            // imprimer FipDD
            this.isDD = true;
            this.common.openModal(this.modalService, this.confirmaFIPDD);
          } else {
            // impression
            this.afficherChoixFormatPerso();
          }
        });
      });
    } else {
      // impression
      this.afficherChoixFormatPerso();
    }
  }

  isFipDDDejaImprimer(bon, listFipDD) {
    const listLigneBonNonDISArtAtester = (bon.listLignes || []);

    if (listLigneBonNonDISArtAtester.length > 0) {
      return this.parcoursListBonDD(bon, listFipDD, 0)
    } else {
      return Promise.resolve(true);
    }
  }


  parcoursListBonDD(bon, listFipDD, index) {
    let retour = false;
    let isExist = false;
    const societe = this.societe;
    const listLigneBonNonDISArtAtester = (bon.listLignes || []);
    if (index < listLigneBonNonDISArtAtester.length) {
      console.log('parcoursListBonDD index:' + index);
      const ligneBon = listLigneBonNonDISArtAtester[index];
      if (ligneBon.article && ligneBon.article.isDIS && ligneBon.article.id > 0) {
        if (listFipDD.length === 0) {
          retour = false;
          return Promise.resolve(retour);
        }
        const year = parseInt(moment().format('YYYY'), 10);
        const clefClient = bon.client ? bon.client.id : 0;
        const clefArticle = ligneBon.article ? ligneBon.article.id : 0;
        const clefChantier = bon.chantier ? bon.chantier.id : 0;
        const clefSiteCourant = this.common.user[2];
        return this.isFipDDExist(clefArticle, clefClient, clefChantier, year).then(isFipDDExist => {
          if (isFipDDExist) {
            return this.parcoursListBonDD(bon, listFipDD, index + 1);
          } else {
            const existeDD = listFipDD.filter(fipDD => fipDD.annee === year &&
              (fipDD.article && ligneBon.article && fipDD.article.id === ligneBon.article.id) &&
              (fipDD.client && bon.client && fipDD.client.id === bon.client.id) &&
              (fipDD.chantier && bon.chantier && fipDD.chantier.id === bon.chantier.id));
            if (existeDD && existeDD.length) {
              isExist = true;
              retour = true;
              return this.parcoursListBonDD(bon, listFipDD, index + 1)
            } else {
              isExist = false;
              return Promise.resolve(retour);
            }
          }
        })
      } else {
        retour = true;
        isExist = true;
        return this.parcoursListBonDD(bon, listFipDD, index + 1)
      }
    } else {
      return Promise.resolve(true);
    }
  }


  isFipDDExist(clefArticle, clefClient, clefChantier, year) {
    const param = {
      'servlet': 'DBGestionFipDD',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        },
        'CLEF_ARTICLE': {
          'typeParam': 'int',
          'valeur': clefArticle
        },
        'ANNEE_BON': {
          'typeParam': 'int',
          'valeur': year
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': clefClient
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': clefChantier
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': 0
        },
      }
    };
    return this.common.post('', { param: param }, true).then(datas => {
      return datas.data;
    });
  }



  isFipDNDDejaImprimer(bon, listFipDND) {
    const listLigneBonNonDISArtAtester = (bon.listLignes || []);
    if (listLigneBonNonDISArtAtester.length > 0) {
      return this.parcoursListBonDND(bon, listFipDND, 0)
    } else {
      return Promise.resolve(true);
    }
  }

  parcoursListBonDND(bon, listFipDND, index) {
    let isExist = false;
    let ret = false;
    const societe = this.societe;
    const listLigneBonNonDISArtAtester = (bon.listLignes || []);
    if (index < listLigneBonNonDISArtAtester.length) {
      console.log('parcoursListBonDND index:' + index);
      const ligneBon = listLigneBonNonDISArtAtester[index];
      const year = parseInt(moment().format('YYYY'), 10);
      const clefClient = bon.client ? bon.client.id : 0;
      const clefArticle = ligneBon.article ? ligneBon.article.id : 0;
      const clefChantier = bon.chantier ? bon.chantier.id : 0;
      const clefSiteCourant = this.common.user[2];
      const dtBon = bon.date;
      if (!this.societe.isFIPCET) {
        if (ligneBon.article && !ligneBon.article.isDIS && ligneBon.article.nomenclatureICPE
          && ligneBon.article.nomenclatureICPE.id > 0) {
          const clefNomICPE = ligneBon.article.nomenclatureICPE.id;
          if (listFipDND.length === 0) {
            ret = false;
            return Promise.resolve(ret);
          } else {
            // FipDND Exist ou pas
            return this.isFipDNDByClefNomenclatureExist(clefNomICPE, clefClient, year).then(isFipDNDExist => {
              if (isFipDNDExist) {
                isExist = true;
                ret = true;
                return this.parcoursListBonDND(bon, listFipDND, index + 1);
              } else {
                const existeFIPDnd = listFipDND.filter(fipDND => fipDND.annee === year &&
                  fipDND.nomenclatureICPE.id === ligneBon.article.nomenclatureICPE.id
                  && fipDND.client.id === bon.client.id)

                if (!existeFIPDnd || (existeFIPDnd && !existeFIPDnd.length)) {
                  isExist = false;
                  return Promise.resolve(false);
                } else {
                  if (!societe.isFIPParSite) {
                    isExist = true;
                    ret = true;
                    return this.parcoursListBonDND(bon, listFipDND, index + 1);
                  } else {
                    const existeSiteEgale = existeFIPDnd.filter(element => element.clefSite === clefSiteCourant);
                    if (!existeSiteEgale || (existeSiteEgale && !existeSiteEgale.length)) {
                      isExist = false;
                      return Promise.resolve(false);
                    } else {
                      isExist = true;
                      ret = true;
                      return this.parcoursListBonDND(bon, listFipDND, index + 1);
                    }
                  }
                }
              }
            });
          }
        } else {
          ret = true;
          isExist = true;
          return this.parcoursListBonDND(bon, listFipDND, index + 1);
        }
      } else {
        if (ligneBon.article && !ligneBon.article.isDIS && ligneBon.article.id > 0 && (ligneBon.article.famille === '1' || ligneBon.article.famille === '3'))  {
          if (listFipDND.length === 0) {
            ret = false;
            return Promise.resolve(ret);
          } else {
            return this.isFipDNDArticleExist(clefArticle, clefChantier, clefClient, year).then(isFipDDExist => {
              if (isFipDDExist) {
                isExist = true;
                ret = true;
                return Promise.resolve(ret);
              } else {
                const existeFIPDnd = listFipDND.filter(fipDND => fipDND.annee === year &&
                  fipDND.article.id === ligneBon.article.id &&
                  fipDND.client.id === bon.client.id && fipDND.chantier.id === bon.chantier.id)

                if (!existeFIPDnd || (existeFIPDnd && !existeFIPDnd.length)) {
                  isExist = false;
                  return Promise.resolve(false);
                } else {
                  if (!societe.isFIPParSite) {
                    isExist = true;
                    ret = true;
                    return this.parcoursListBonDND(bon, listFipDND, index + 1);
                  } else {
                    const existeSiteEgale = existeFIPDnd.filter(element => element.clefSite === clefSiteCourant);
                    if (!existeSiteEgale || (existeSiteEgale && !existeSiteEgale.length)) {
                      isExist = false;
                      return Promise.resolve(false);
                    } else {
                      isExist = true;
                      ret = true;
                      return this.parcoursListBonDND(bon, listFipDND, index + 1);
                    }
                  }
                }
              }
            });
          }
        } else {
          ret = true;
          isExist = true;
           // on passe à la ligne suivante pour vérifier si c'est un DND
          return this.parcoursListBonDND(bon, listFipDND, index + 1);
        }
      }
    } else {
      return Promise.resolve(true);
    }
  }

  isFipDNDByClefNomenclatureExist(clefNomenclature, clefClient, anneeBon) {
    const param = {
      'servlet': 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        },
        'CLEF_NOMENCLATURE': {
          'typeParam': 'int',
          'valeur': clefNomenclature
        },
        'ANNEE_BON': {
          'typeParam': 'int',
          'valeur': anneeBon
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': clefClient
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': 0
        },
      }
    };
    return this.common.post('', { param: param }, true).then(datas => {
      return datas.data;
    });
  }

  isFipDNDArticleExist(clefArticle, clefChantier, clefClient, anneeBon) {
    const param = {
      'servlet': 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 9
        },
        'CLEF_ARTICLE': {
          'typeParam': 'int',
          'valeur': clefArticle
        },
        'ANNEE_BON': {
          'typeParam': 'int',
          'valeur': anneeBon
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': clefClient
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': clefChantier
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': 0
        },
      }
    };
    return this.common.post('', { param: param }, true).then(datas => {
      return datas.data;
    });

  }

  nextClose() {
    if (this.isDD) {
      // impression
      this.afficherChoixFormatPerso();
    } else {
      this.gestionFIPDD();
    }
  }


  printFIP() {
    const BON = this.detailBon || {};
    BON.nomclass = 'Bon';
    const param = {
      'servlet': this.isDD ? 'DBImprimeFIPDD' : 'DBImprimeFIP',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_FORMAT_PARAMETRABLE': {
          'typeParam': 'int',
          'valeur': this.formatprs ? this.formatprs['id'] || 0 : 0
        },
        'BON': BON,
        '"CLEF_USER" ': {
          'typeParam': 'int',
          'valeur': this.common.user[0] || 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2] || 0
        },
      }
    };
    if (this.isDD) {
      param.data['LISTDD'] = [];
    } else {
      param.data['LISTDND'] = [];
    }
    return this.common.post('', { param: param }, true).then(datas => {
      if (datas.data && datas.data.length) {
        datas.data.forEach(doc => {
          this.common.isRedirectOpenDocImp = true;
          this.common.openFile(doc, false, false);
        });
      }
      if (!this.isDD) {
        this.gestionFIPDD();
      } else {
        this.afficherChoixFormatPerso();
      }
    }).catch(err => {
      this.afficherChoixFormatPerso();
    });

  }

  getFormatPersoFIP(type) {
    const that = this;
    GestionFormat.getFormatperso(type, this.common).then(datasFormat => {
      if (datasFormat.data) {
        that.formatPerso = datasFormat.data;
        if (that.formatPerso.length > 1) {
          that.formatprs = that.formatPerso[0];
          that.common.openModal(that.modalService, that.formatPesroFIP);
        } else {
          if (that.formatPerso.length === 1) {
            that.formatprs = that.formatPerso[0];
            that.printFIP();
          } else {
            that.common.openModal(that.modalService, that.formatPesroFIP);
          }
        }
      } else {
        if (datasFormat.message) {
          this.error = datasFormat.message;
          this.common.openModal(this.modalService, this.msg);
        }
      }
    });
  }
}
